import "./bootstrap.js";
import Swiper from "swiper";
import { Virtual, Navigation, Pagination, Autoplay, Scrollbar } from "swiper/modules";
Swiper.use([Virtual, Navigation, Pagination, Autoplay, Scrollbar]);
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import $, { event } from "jquery";
import * as bootstrap from "bootstrap";
// import { start } from "@popperjs/core/index.js";

import.meta.glob(["../images/**"]);
import PhotoSphereViewer from 'photo-sphere-viewer';


const themeVersion = document.body.getAttribute('data-theme-version').replace('-', '') || '';
//console.log('Theme version:', themeVersion);
const themeActive = document.body.getAttribute('data-theme-active') || '';
//console.log('Theme active:', themeActive);
const diarySlides = Array.isArray(window.diarySlides) ? window.diarySlides : [];

// Hacer PhotoSphereViewer disponible globalmente para scripts en templates
window.PhotoSphereViewer = PhotoSphereViewer;

// dispatch an event to let know this module has been loaded
document.dispatchEvent(new Event("app-public-loaded"));

//PARA QUE FUNCIONEN LOS AJAX
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

const modalAlerta = new bootstrap.Modal(document.getElementById("modalAlerta"));
const modalDeleteUserPlan = new bootstrap.Modal(
    document.getElementById("modalDeleteUserPlan")
);
const modalDeleteEventPlan = new bootstrap.Modal(
    document.getElementById("modalDeleteEventPlan")
);
const modalAvisoIrLogin = new bootstrap.Modal(
    document.getElementById("modalAvisoIrLogin")
);

var modalChangePass;
var modalChangeEmail;
var modalConfirmDelete;

if (document.getElementById("modalChangePass")) {
    modalChangePass = new bootstrap.Modal("#modalChangePass", {
        keyboard: false,
    });
}

if (document.getElementById("modalChangeEmail")) {
    modalChangeEmail = new bootstrap.Modal("#modalChangeEmail", {
        keyboard: false,
    });
}

if (document.getElementById("modalConfirmDelete")) {
    modalConfirmDelete = new bootstrap.Modal("#modalConfirmDelete", {
        keyboard: false,
    });
}

window.mostrarAlerta = function (_tit, _txt) {
    $("#modalAlerta .modal-title").html(_tit);
    $("#modalAlerta .modal-body").html(_txt);
    modalAlerta.show();
};


const swiperRelacionados = document.querySelector(".swiper-relacionados") ? new Swiper(".swiper-relacionados", {
    loop: false,
    pagination: {
        el: "#swiperRelacionados .swiper-pagination", // si la añades después
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".cont-swiper .swiper-button-next-rel",
        prevEl: ".cont-swiper .swiper-button-prev-rel",
    },
    slidesPerView: 4,
    spaceBetween: 20,
}) : null;

const swiperRecomendados = document.querySelector(".swiper-recomendados") ? new Swiper(".swiper-recomendados", {
    loop: false,
    pagination: {
        el: "#swiperRecomendados .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: "#swiperRecomendados .swiper-button-next",
        prevEl: "#swiperRecomendados .swiper-button-prev",
    },
    slidesPerView: themeVersion == 'v3' ? 2.5 : 3,
    spaceBetween: 20,
    breakpoints: {
        // mobile: always 1 slide per view
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        // tablet
        768: {
            slidesPerView: themeVersion == 'v3' ? 1.5 : 3,
            spaceBetween: 20,
        },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 2.5 : 3,
            spaceBetween: 20,
        }
    },
}) : null;

const swiperHighlighted = document.querySelector(".swiper-highlighted-events") ? new Swiper(".swiper-highlighted-events", {
    loop: false,
    pagination: {
        el: "#swiperHighlighted .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: "#swiperHighlightedNext",
        prevEl: "#swiperHighlightedPrev",
    },
    slidesPerView: themeVersion == 'v3' ? 2.5 : 3,
    spaceBetween: 20,
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: themeVersion == 'v3' ? 1.5 : 3,
            spaceBetween: 20,
        },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 2.5 : 3,
            spaceBetween: 20,
        }
    },
    on: {
        init: function () { lazyLoadSwiperBackgrounds(this); },
        slideChange: function () { lazyLoadSwiperBackgrounds(this); },
        resize: function () { lazyLoadSwiperBackgrounds(this); }
    }
}) : null;

function lazyLoadSwiperBackgrounds(swiper, preload = 1) {
    if (!swiper || !swiper.slides) {
        return;
    }

    const applyBackground = (slide) => {
        if (!slide) {
            return;
        }

        slide.querySelectorAll("[data-bg]").forEach((element) => {
            element.style.backgroundImage = `url('${element.dataset.bg}')`;
            element.removeAttribute("data-bg");
        });
    };

    // En modo virtual, swiper.slides contiene solo el subconjunto renderizado en DOM.
    // activeIndex es global y no coincide con estos indices locales.
    if (swiper.params.virtual && swiper.params.virtual.enabled) {
        swiper.slides.forEach((slide) => applyBackground(slide));
        return;
    }

    const slidesPerView = Number.isFinite(swiper.params.slidesPerView) ? Math.ceil(swiper.params.slidesPerView) : 1;
    const start = Math.max((swiper.activeIndex || 0) - preload, 0);
    const end = Math.min((swiper.activeIndex || 0) + slidesPerView + preload, swiper.slides.length - 1);

    for (let index = start; index <= end; index++) {
        applyBackground(swiper.slides[index]);
    }
}

const swiperDiary = document.querySelector(".swiperDiary") ? new Swiper(".swiperDiary", {
    // Optional parameters
    loop: false,
    //modules: [Navigation],

    // solo visible en Ponferrada
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next-agenda",
        prevEl: ".swiper-button-prev-agenda",
    },

    virtual: {
        slides: diarySlides,
        addSlidesBefore: 3,
        addSlidesAfter: 3,
    },

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },

    slidesPerView: 1,
    spaceBetween: 20,
    on: {
        init: function () {
            lazyLoadSwiperBackgrounds(this);
        },
        slideChange: function () {
            lazyLoadSwiperBackgrounds(this);
        },
        resize: function () {
            lazyLoadSwiperBackgrounds(this);
        },
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        // when window width is >= 480px
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
}) : null;


// swiperImprescindibles se inicializa en initializeEventSwipers() para funcionar tanto en página directa como en modal

const swiperDiary2 = document.querySelector(".swiperDiary2") ? new Swiper(".swiperDiary2", {
    // Optional parameters
    loop: false,
    //modules: [Navigation],

    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next-agenda",
        prevEl: ".swiper-button-prev-agenda",
    },

    virtual: {
        slides: diarySlides,
        addSlidesBefore: 3,
        addSlidesAfter: 3,
    },

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },

    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
    on: {
        init: function () {
            lazyLoadSwiperBackgrounds(this);
        },
        slideChange: function () {
            lazyLoadSwiperBackgrounds(this);
        },
        resize: function () {
            lazyLoadSwiperBackgrounds(this);
        },
    },

}) : null;

// JB 280225: aado navigation
const swiperImageTitleCard = document.querySelector(".swiperImageTitleCard") ? new Swiper(".swiperImageTitleCard", {
    // Optional parameters
    loop: false,
    //modules: [Pagination, Navigation],

    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },

    navigation: {
        nextEl: ".swiper-button-next", // Botón siguiente
        prevEl: ".swiper-button-prev", // Botón anterior
    },

    slidesPerView: 1,
    //spaceBetween: 20,
}) : null;



//JB 240525 hago que el autoplay sea opcional
// const swiperImagesHome = new Swiper(".swiperImagesHome", {
//     modules: [Navigation, Pagination],
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 0,
//     autoplay: {
//         delay: 5000,
//     },
//     pagination: {
//         el: ".swiper-pagination",
//         type: "bullets",
//         clickable: true,
//     },
// });
const swiperImagesHomeAutoplay = document.querySelector(".swiperImagesHome") && document.querySelector(".swiperImagesHome").dataset.auto == "true" ? { delay: 5000 } : false;
const isManresaTheme = document.body && document.body.dataset.themeActive === "manresa";
const swiperImagesHome = document.querySelector(".swiperImagesHome") ? new Swiper(".swiperImagesHome", {
    //modules: [Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: isManresaTheme,
    autoplay: swiperImagesHomeAutoplay,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
}) : null;


const swiperRegister = document.querySelector(".swiperRegister") ? new Swiper(".swiperRegister", {
    // Optional parameters
    loop: false,
    simulateTouch: false,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 20,
}) : null;

const swiperHomeArticles = document.querySelector(".swiperHomeArticles") ? new Swiper(".swiperHomeArticles", {
    loop: false,
    pagination: {
        el: ".swiperHomeArticles .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".swiper-button-next-articles",
        prevEl: ".swiper-button-prev-articles",
    },
    slidesPerView: themeVersion == 'v3' ? 4 : 3,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 4 : 3,
            spaceBetween: 20,
        }
    },
}) : null;

const siteSwiperArticles = document.querySelector("#siteSwiperArticles") ? new Swiper("#siteSwiperArticles", {
    loop: false,
    pagination: {
        el: "#siteSwiperArticles .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    },
}) : null;

$(document).ready(function () {
    console.log("app-public.js");

    /*
    $("#search_article").on("keydown blur", function (e) {
        if (e.key === "Enter" || e.key === "Tab" || e.type === "blur") {
            e.preventDefault();

            $("#formSearchArticles").submit();
        }
    });

    $(".articletag-checkbox").change(function () {
        let selectedTags = $(".articletag-checkbox:checked")
            .map(function () {
                return $(this).val();
            })
            .get();

        $(".js-item-article").each(function () {
            let dataTags = $(this).data("articletags");
            if (typeof dataTags === "string" && dataTags.length > 0) {
                dataTags = dataTags.split(",").map((tag) => tag.trim());
            } else if (dataTags) {
                dataTags = [dataTags];
            } else {
                dataTags = [];
            }

            let isVisible =
                selectedTags.length === 0 ||
                dataTags.some((tag) =>
                    selectedTags.map(String).includes(String(tag))
                );
            $(this).toggleClass("d-none", !isVisible);
        });
    });
    */
    const currentLocale = document.documentElement.lang || "es";

    $(".js-home-diary-dropdown").click(function (e) {
        e.preventDefault();

        var obj = $(this).closest(".js-home-diary-slider");

        obj.find(".js-home-diary-dropdown-label").html($(this).html());

        $.ajax({
            method: "POST",
            url: "/ajax/home/diary",
            data: { date: $(this).attr("data-date"), locale: currentLocale },
            dataType: "json",
        }).done(function (response) {
            const swiper = obj.find(".swiperDiary2").length ? swiperDiary2 : swiperDiary;
            const slides = Array.isArray(response.slides) ? response.slides : [];

            if (!swiper || !swiper.virtual) {
                return;
            }

            swiper.virtual.removeAllSlides();
            swiper.virtual.appendSlide(slides);
            swiper.slideTo(0, 0);
            swiper.update();
            lazyLoadSwiperBackgrounds(swiper);
        });
    });

    $(".js-home-diary-dropdown-manresa").click(function (e) {
        e.preventDefault();

        var selectedDate = $(this).attr("data-date");
        var selectedLabel = $(this).text();

        $.ajax({
            method: "POST",
            url: "/ajax/home/diaryManresa",
            data: { date: selectedDate, locale: currentLocale },
            dataType: "json",
        }).done(function (html) {
            $("#js-agendaManresa").html(html.html);
            
            // Guardar la fecha seleccionada en localStorage
            localStorage.setItem("selectedDiaryDate", selectedDate);
            localStorage.setItem("selectedDiaryLabel", selectedLabel);
            
            // Actualizar el texto del botón para mostrar el mes seleccionado
            $("#navbarDropdown").text(">> " + selectedLabel);
            
            // Mostrar eventos de relleno si es necesario
            adjustManresaFillerEvents();

            setTimeout(function () {
                if (typeof window.swiperAgenda !== "undefined") {
                    window.swiperAgenda.update();
                    window.swiperAgenda.slideTo(0);
                }

            }, 500);

        });
    });
    
    // Función para ajustar visibilidad de eventos de relleno en Manresa
    function adjustManresaFillerEvents() {
        const container = document.getElementById("js-agendaManresa");
        if (!container) return;
        
        const slides = container.querySelectorAll(".swiper-slide");
        const minRequired = 6;
        
        // Contar eventos visibles (no ocultos por filtros o display:none)
        let visibleCount = 0;
        const fillerSlides = [];
        
        slides.forEach(slide => {
            const style = window.getComputedStyle(slide);
            const isFiller = slide.getAttribute("data-filler") === "true";
            
            if (isFiller) {
                fillerSlides.push(slide);
            } else if (style.display !== "none") {
                visibleCount++;
            }
        });
        
        // Si hay menos de 6 eventos visibles, mostrar eventos de relleno
        if (visibleCount < minRequired) {
            const neededFillers = minRequired - visibleCount;
            for (let i = 0; i < Math.min(neededFillers, fillerSlides.length); i++) {
                fillerSlides[i].style.display = "";
            }
        } else {
            // Ocultar todos los eventos de relleno si hay 6 o más
            fillerSlides.forEach(slide => {
                slide.style.display = "none";
            });
        }
    }
    
    // Cargar el mes guardado al iniciar la página
    $(document).ready(function() {
        var savedDate = localStorage.getItem("selectedDiaryDate");
        if (savedDate) {
            var savedLabel = localStorage.getItem("selectedDiaryLabel");
            $.ajax({
                method: "POST",
                url: "/ajax/home/diaryManresa",
                data: { date: savedDate, locale: currentLocale },
                dataType: "json",
            }).done(function (html) {
                $("#js-agendaManresa").html(html.html);
                $("#navbarDropdown").text(">> " + savedLabel);
                
                setTimeout(function () {
                    if (typeof window.swiperAgenda !== "undefined" && window.swiperAgenda) {
                        window.swiperAgenda.update();
                        window.swiperAgenda.slideTo(0);
                    }
                }, 500);
            });
        }
    });

    $(".js-itinerary-button-list").click(function (e) {
        e.preventDefault();

        $(".js-itinerary-button-map").removeClass("active");
        $(".js-itinerary-button-list").addClass("active");

        $("#itineraryList").removeClass("d-none");
        $("#itineraryList").addClass("d-block");
        $("#itineraryMap").addClass("d-none");
        $("#itineraryMap").removeClass("d-block");

        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0,
            },
            500
        );
    });

    $(".js-itinerary-button-map").click(function (e) {
        e.preventDefault();

        $(".js-itinerary-button-map").addClass("active");
        $(".js-itinerary-button-list").removeClass("active");

        $("#itineraryList").addClass("d-none");
        $("#itineraryList").removeClass("d-block");
        $("#itineraryMap").removeClass("d-none");
        $("#itineraryMap").addClass("d-block");

        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0,
            },
            500
        );
    });

    $(".js-field-showpass").click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("passshowed")) {
            $(this).removeClass("passshowed");
            $(this)
                .closest(".form-group")
                .find(".form-control")
                .attr("type", "password");
        } else {
            $(this).addClass("passshowed");
            $(this)
                .closest(".form-group")
                .find(".form-control")
                .attr("type", "text");
        }
    });

    $(".js-showModalChangePass").click(function (e) {
        e.preventDefault();

        modalChangePass.show();
    });

    $("#js-formChangePass").submit(function (e) {
        e.preventDefault();

        // we have to call the api /user/post_data with field, value and value_confirmation
        // if the response is ok, we have to show a success message
        // if the response is not ok, we have to show an error message

        let errors = [];
        let password = $(this).find("#pass").val();
        let password_confirmation = $(this).find("#pass_confirmation").val();

        if (!password || password.length < 8 || !/\W/.test(password)) {
            errors.push($(this).find("#pass").attr("data-error"));
        }

        if (password !== password_confirmation) {
            errors.push($(this).find("#pass_confirmation").attr("data-error"));
        }

        if (errors.length == 0) {
            $(this).find(".js-errors ul").html("");
            $(this).find(".js-errors").slideUp();

            $.ajax({
                method: "POST",
                url: "/user/post_data",
                data: {
                    field: "password",
                    value: password,
                    value_confirmation: password_confirmation,
                },
                dataType: "json",
            }).done(function (response) {
                modalChangePass.hide();

                if (response.status === "ok") {
                    window.mostrarAlerta(response.title, response.message);
                } else {
                    window.mostrarAlerta(response.title, response.error);
                }
            });
        } else {
            var cadena = "";
            $.each(errors, function (indexInArray, valueOfElement) {
                //console.log(valueOfElement);

                cadena += "<li>" + valueOfElement + "</li>";
            });

            $(this).find(".js-errors ul").html(cadena);
            $(this).find(".js-errors").slideDown();
        }
    });

    $(".js-showModalChangeEmail").click(function (e) {
        e.preventDefault();

        modalChangeEmail.show();
    });

    $("#js-formChangeEmail").submit(function (e) {
        e.preventDefault();
        //console.log("cambio de email");
        //
        let errors = [];
        let email = $(this).find("#email").val();
        let email_confirmation = $(this).find("#email_confirmation").val();

        if (!email || !$(this).find("#email")[0].checkValidity()) {
            errors.push($(this).find("#email").attr("data-error"));
        }

        if (email !== email_confirmation) {
            errors.push($(this).find("#email_confirmation").attr("data-error"));
        }

        if (errors.length == 0) {
            $.ajax({
                method: "POST",
                url: "/user/post_data",
                data: {
                    field: "email",
                    value: email,
                    value_confirmation: email_confirmation,
                },
                dataType: "json",
            }).done(function (response) {
                modalChangeEmail.hide();

                if (response.status === "ok") {
                    window.mostrarAlerta(response.title, response.message);
                } else {
                    window.mostrarAlerta(response.title, response.error);
                }
            });
        } else {
            var cadena = "";
            $.each(errors, function (indexInArray, valueOfElement) {
                console.log(valueOfElement);

                cadena += "<li>" + valueOfElement + "</li>";
            });

            $(this).find(".js-errors ul").html(cadena);
            $(this).find(".js-errors").slideDown();
        }
    });

    $(".js-showConfirmDelete").click(function (e) {
        e.preventDefault();

        modalConfirmDelete.show();
    });

    $("#js-formConfirmDelete").submit(function (e) {
        e.preventDefault();
        console.log("eliminar cuenta");
        //
        $.ajax({
            method: "DELETE",
            url: "/user/delete",
            data: {},
            dataType: "json",
        }).done(function (response) {
            modalChangeEmail.hide();

            if (response.status === "ok") {
                window.mostrarAlerta(response.title, response.message);
                document.location.href = "/";
            } else {
                window.mostrarAlerta(response.title, response.error);
            }
        });
    });

    $(".js-login").click(function (e) {
        e.preventDefault();

        let errors = [];

        let email = document.getElementById("email").value.trim();
        let password = document.getElementById("password").value.trim();

        // Check if email is empty
        if (!email) {
            errors.push(
                document.getElementById("email").getAttribute("data-error")
            );
        } else if (!validateEmail(email)) {
            errors.push(
                document.getElementById("email").getAttribute("data-error2")
            );
        }

        if (!password) {
            errors.push(
                document.getElementById("password").getAttribute("data-error")
            );
        } else if (password.length < 4) {
            errors.push(
                document.getElementById("password").getAttribute("data-error2")
            );
        } else if (!/\W/.test(password) && 1 == 0) {//lo dejo por si quieren revertirlo
            errors.push(
                document.getElementById("password").getAttribute("data-error3")
            );
        }

        if (errors.length > 0) {
            let errorMessages = document.getElementById("errorMessages");
            errorMessages.innerHTML = "";
            errors.forEach(function (error) {
                let li = document.createElement("li");
                li.textContent = error;
                errorMessages.appendChild(li);
            });

            let validationModal = new bootstrap.Modal(
                document.getElementById("validationModal")
            );
            validationModal.show();
        } else {
            // Limpiar localStorage después de login exitoso
            localStorage.removeItem('redirectAfterLogin');
            $("#Flogin").submit();
        }
    });

    $(".js-register").click(function (e) {
        e.preventDefault();

        let errors = [];
        let name = document.getElementById("inputName").value.trim();
        let email = document.getElementById("inputEmail").value.trim();
        let password = document.getElementById("inputPassword1").value.trim();
        let confirmPassword = document
            .getElementById("inputPassword2")
            .value.trim();
        let legal = document.getElementById("legal").checked;

        // Check if name is empty
        if (!name) {
            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputNameError").innerHTML = document.getElementById("inputName").getAttribute("data-error");
                document.getElementById("inputNameError").classList.add("d-block");
                errors.push(
                    document.getElementById("inputName").getAttribute("data-error")
                );                
            }else{
                errors.push(
                    document.getElementById("inputName").getAttribute("data-error")
                );
            }
        }else{
            let inputNameErrorEl = document.getElementById("inputNameError");
            if (inputNameErrorEl) {
                inputNameErrorEl.innerHTML = "";
                inputNameErrorEl.classList.remove("d-block");
            }
        }

        // Check if email is empty
        if (!email) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputEmailError").innerHTML = document.getElementById("inputEmail").getAttribute("data-error");
                document.getElementById("inputEmailError").classList.add("d-block");
                errors.push(
                    document.getElementById("inputEmail").getAttribute("data-error")
                );                
            }else{
                errors.push(
                    document.getElementById("inputEmail").getAttribute("data-error")
                );
            }

        } else if (!validateEmail(email)) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputEmailError").innerHTML = document.getElementById("inputEmail").getAttribute("data-error2");
                document.getElementById("inputEmailError").classList.add("d-block");
                errors.push(
                    document
                        .getElementById("inputEmail")
                        .getAttribute("data-error2")
                );                
            }else{
                errors.push(
                    document
                        .getElementById("inputEmail")
                        .getAttribute("data-error2")
                );
            }

        }else{
            let inputEmailErrorEl = document.getElementById("inputEmailError");
            if (inputEmailErrorEl) {
                inputEmailErrorEl.innerHTML = "";
                inputEmailErrorEl.classList.remove("d-block");
            }
        }

        if (!password) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputPassword1Error").innerHTML = document.getElementById("inputPassword1").getAttribute("data-error");
                document.getElementById("inputPassword1Error").classList.add("d-block");
                errors.push(
                    document
                        .getElementById("inputPassword1")
                        .getAttribute("data-error")
                );                
            }else{
                errors.push(
                    document
                        .getElementById("inputPassword1")
                        .getAttribute("data-error")
                );
            }

        } else if (password.length < 4) {
            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputPassword1Error").innerHTML = document.getElementById("inputPassword1").getAttribute("data-error2");
                document.getElementById("inputPassword1Error").classList.add("d-block");
                errors.push(
                    document
                        .getElementById("inputPassword1")
                        .getAttribute("data-error2")
                );                
            } else {
                errors.push(
                    document
                        .getElementById("inputPassword1")
                        .getAttribute("data-error2")
                );
            }
        } else if (!/\W/.test(password) && 1 == 0) {//lo dejo invalidado por si quieren volver a poner el control
            errors.push(
                document
                    .getElementById("inputPassword1")
                    .getAttribute("data-error3")
            );
        }else{
            let inputPassword1ErrorEl = document.getElementById("inputPassword1Error");
            if (inputPassword1ErrorEl) {
                inputPassword1ErrorEl.innerHTML = "";
                inputPassword1ErrorEl.classList.remove("d-block");
            }
        }

        if (!confirmPassword) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputPassword2Error").innerHTML = document.getElementById("inputPassword2").getAttribute("data-error");
                document.getElementById("inputPassword2Error").classList.add("d-block");
                errors.push(
                    document
                        .getElementById("inputPassword2")
                        .getAttribute("data-error")
                );                
            } else {
                errors.push(
                    document
                        .getElementById("inputPassword2")
                        .getAttribute("data-error")
                );
            }

        } else if (password !== confirmPassword) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("inputPassword2Error").innerHTML = document.getElementById("inputPassword2").getAttribute("data-error2");
                document.getElementById("inputPassword2Error").classList.add("d-block");
                errors.push(
                    document
                        .getElementById("inputPassword2")
                        .getAttribute("data-error2")
                );               
            } else {
                errors.push(
                    document
                        .getElementById("inputPassword2")
                        .getAttribute("data-error2")
                );
            }

        }else{
            let inputPassword2ErrorEl = document.getElementById("inputPassword2Error");
            if (inputPassword2ErrorEl) {
                inputPassword2ErrorEl.innerHTML = "";
                inputPassword2ErrorEl.classList.remove("d-block");
            }
        }

        if (!legal) {

            if ($('body').attr('data-theme-active') === 'ponferrada') {
                document.getElementById("legalError").innerHTML = document.getElementById("legal").getAttribute("data-error");
                document.getElementById("legalError").classList.add("d-block");
                errors.push(
                    document.getElementById("legal").getAttribute("data-error")
                );              
            } else {
                errors.push(
                    document.getElementById("legal").getAttribute("data-error")
                );
            }


        }else{
            let legalErrorEl = document.getElementById("legalError");
            if (legalErrorEl) {
                legalErrorEl.innerHTML = "";
                legalErrorEl.classList.remove("d-block");
            }
        }

        if (errors.length > 0) {
            // Si es Ponferrada, mostrar errores como texto, sino usar modal
            if ($('body').attr('data-theme-active') === 'ponferrada') {
                // let errorList = document.getElementById("registerValidationList");
                // if (!errorList) return; // Si no existe el elemento, salir
                // errorList.innerHTML = "";
                // errors.forEach(function (error) {
                //     let li = document.createElement("li");
                //     li.textContent = error;
                //     errorList.appendChild(li);
                // });
                // let errorMessage = document.getElementById("registerValidationMessage");
                // if (errorMessage) {
                //     errorMessage.classList.remove("d-none");
                // }
            } else {
                let errorMessages = document.getElementById("errorMessages");
                errorMessages.innerHTML = "";
                errors.forEach(function (error) {
                    let li = document.createElement("li");
                    li.textContent = error;
                    errorMessages.appendChild(li);
                });

                let validationModal = new bootstrap.Modal(
                    document.getElementById("validationModal")
                );
                validationModal.show();
            }
        } else {
            // Limpiar errores si los hay
            let errorMessage = document.getElementById("registerValidationMessage");
            if (errorMessage) {
                errorMessage.classList.add("d-none");
            }
            if (swiperRegister) {
                swiperRegister.slideTo(1);
            }

            $("#registerErrorMessage").addClass('d-none alert-success');
            $("#registerErrorText").html("");
            $("#registerErrorMessage1").addClass('d-none alert-success');
            $("#registerErrorText1").html("");             

        }
    });
    /*
    $('#js-resetpasspublic').on("click", function ($event) {
        $event.preventDefault();

        if (!password) {
            errors.push(
                document
                    .getElementById("inputPassword1")
                    .getAttribute("data-error")
            );
        } else if (password.length < 8) {
            errors.push(
                document
                    .getElementById("inputPassword1")
                    .getAttribute("data-error2")
            );
        } else if (!/\W/.test(password)) {
            errors.push(
                document
                    .getElementById("inputPassword1")
                    .getAttribute("data-error3")
            );
        }

    });
*/
    $(".js-register2").on("click", function ($event) {
        $event.preventDefault(); // Previene el comportamiento por defecto del botón

        $.ajax({
            method: "POST",
            url: "/api/user/register",
            data: $("#formRegister").serialize() + '&locale=' + $('html').attr('lang'),
            dataType: "json",
            success: function (response) {
                if (response.status === "ok") {
                    let okMessage = $("#msjeRegistroOK").val();
                    if ($('body').attr('data-theme-active') === 'ponferrada') {
                        $("#registerErrorMessage").removeClass('d-none alert-danger').addClass('alert-success');
                        $("#registerErrorText").html(okMessage);
                    } else {
                        window.mostrarAlerta("{{ __('Éxito') }}", okMessage);
                    }
                    // Esperar 2 segundos y redireccionar a home
                    setTimeout(function() {
                        window.location.href = '/';
                    }, 2000);
                } else {
                    let errorMessage = $("#errorRegistroGenerico").val();
                    if ($('body').attr('data-theme-active') === 'ponferrada') {
                        $("#registerErrorMessage").removeClass('d-none alert-success').addClass('alert-danger');
                        $("#registerErrorText").html(errorMessage);
                    } else {
                        window.mostrarAlerta("{{ __('Error') }}", errorMessage);
                    }
                }
            },
            error: function (xhr) {
                // Maneja la respuesta de error del servidor
                let errorMessage = $("#errorRegistroGenerico").val();
                if (xhr.responseJSON.message == "validation.unique") {
                    errorMessage = $("#errorUsuarioUnico").val();
                }

                if ($('body').attr('data-theme-active') === 'ponferrada') {
                    $("#registerErrorMessage").removeClass('d-none alert-success').addClass('alert-danger');
                    $("#registerErrorText").html(errorMessage);
                    if (xhr.responseJSON.message == "validation.unique") {
                        $("#registerErrorMessage1").removeClass('d-none alert-success').addClass('alert-danger');
                        $("#registerErrorText1").html(errorMessage);
                        if (swiperRegister) {
                            swiperRegister.slideTo(0);
                        }
                    }                  
                } else {
                    window.mostrarAlerta("{{ __('Error') }}", errorMessage);
                }
            },
        });
    });

    $(".dropdown-item").on("click", function (event) {
        event.preventDefault();

        var ico = $(this).data("ico");
        var text = $(this).data("text");
        var value = $(this).data("value");

        $("#country").val(value);

        $("#dropdownIcon").attr("src", ico);
        $("#dropdownText").text(text);
    });

    // Function to validate email format
    window.validateEmail = function(email) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    // if the location is /plans/slug
    //if (window.location.pathname.includes("/planes/")) {

    let recommended_itinerary_confirmSave = $(
        "#modalSaveRecommendedItinerary"
    ).find("#btguardarplan");

    console.log(
        "recommended_itinerary_confirmSave",
        recommended_itinerary_confirmSave
    );
    $(".js-avisoGuardarPlan").on("click", function (e) {
        e.preventDefault();
        //si body NO tiene la clase template-v2
        if (!$("body").hasClass("template-v2")) {
            $(".col-header-1").removeClass("col-md-4").addClass("col-md-6");
        }
        $(".col-header-2").remove();
        $(".col-header-3").removeClass("col-md-4").addClass("col-md-6");
    });
    recommended_itinerary_confirmSave.on("click", function (e) {
        console.log("guardar plan");
        let nombre_plan = $("#nombre_plan").val();
        let plan_id = $("#plan_id").val();

        let formData = new FormData();
        formData.append("name", nombre_plan);
        formData.append("id", plan_id);

        $.ajax({
            method: "POST",
            url: "/plans/save_recommended",
            data: formData,
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.status === "ok") {
                    console.log("response", response);
                    console.log(".itinerarySaveOK", $(".itinerarySaveOK"));
                    let confirmSaveModal = $("#modalConfirmSaveCustomItinerary");
                    if (confirmSaveModal.length) {
                        console.log("mostrar mensaje OK (MODAL)");
                        // open the modal
                        let modalConfirmSaveCustomItinerary =
                            new bootstrap.Modal(
                                document.getElementById(
                                    "modalConfirmSaveCustomItinerary"
                                )
                            );
                        modalConfirmSaveCustomItinerary.show();
                    } else {
                        console.log("mostrar mensaje OK (ALERTA)");
                        $(".itinerarySaveOK").removeClass("d-none");
                        $(".js-avisoGuardarPlan").addClass("d-none");
                        $("#modalSaveRecommendedItinerary .btn-close")[0].click();
                    }

                } else {
                    alert(response.message);
                }
            },
            error: function (xhr) {
                // Maneja la respuesta de error del servidor
                alert(errorMessage);
            },
        });
    });
    //}

    $(".js-deleteevent").on("click", function (e) {
        e.preventDefault();

        var idplanedit = $("#plancreado_id").val();
        var itemdelete = $(this).attr("id");
        var eventId = itemdelete.replace("delete_", "");

        $.ajax({
            method: "POST",
            url: "/plans/deleteevent",
            data: {
                idplanedit: idplanedit,
                eventId: eventId,
            },
            dataType: "json",
            success: function (response) {
                if (response.status === "ok") {
                    alert(response.message);
                } else {
                    alert(response.message);
                }
            },
            error: function (xhr) {
                // Maneja la respuesta de error del servidor
                alert(errorMessage);
            },
        });
    });

    $(".js-deleteUserPlan").on("click", function (e) {
        e.preventDefault();

        var idplan = $(this).attr("data-id");

        $("#modalDeleteUserPlan .js-deleteUserPlanConfirm").attr(
            "data-id",
            idplan
        );
        $("#modalDeleteUserPlan .modal-title .js-nombreplan").html(
            $(this).attr("data-title")
        );

        modalDeleteUserPlan.show();
    });

    $(".js-deleteUserPlanConfirm").on("click", function (e) {
        e.preventDefault();

        var idplan = $(this).attr("data-id");

        modalDeleteUserPlan.hide();

        window.deleteUserPlanConfirm(idplan);
    });

    window.deleteUserPlanConfirm = function (idplan) {
        $.ajax({
            method: "DELETE",
            url: "/plans/delete",
            data: {
                plan_id: idplan,
            },
            dataType: "json",
            success: function (response) {
                if (response.status === "ok") {
                    document.location.reload();
                } else {
                    window.mostrarAlerta(response.title, response.error);
                }
            },
            error: function (xhr) {
                // Maneja la respuesta de error del servidor
                alert(errorMessage);
            },
        });
    };

    $(".js-deleteEventPlanConfirm").on("click", function (e) {
        e.preventDefault();

        var idevent = $(this).attr("data-id");

        modalDeleteEventPlan.hide();

        $(".js-deleteevent-v2_" + idevent).attr("data-confirmado", "true");

        $(".js-deleteevent-v2_" + idevent)[0].click();
    });

    $(".js-irAvisoLogin").on("click", function (e) {
        e.preventDefault();

        modalAvisoIrLogin.show();
    });

    $("#btcreateplan_home").on("click", function () {
        console.log("Crear plan desde home");

        let formCreatePlan = $("#Fcreateplan");
        console.log("formCreatePlan:", formCreatePlan);
        let ignoreDate = formCreatePlan.data("ignoredate");

        console.log("ignoreDate:", ignoreDate);

        if ($("#itDesde").val() == "" && $("#itHasta").val() == "" && !ignoreDate) {
            window.mostrarAlerta("UPS!", $("#itValidacionHome").val());
        } else {
            if (
                !ignoreDate &&
                (($("#itDesde").val() == "" && $("#itHasta").val() != "") ||
                    ($("#itHasta").val() == "" && $("#itDesde").val() != ""))
            ) {
                window.mostrarAlerta("UPS!", $("#itValidacionHome").val());
            } else {
                var desde = $("#itDesde").val();
                var hasta = $("#itHasta").val();

                var desdeDate = new Date(desde);
                var hastaDate = new Date(hasta);

                if (hastaDate >= desdeDate || ignoreDate) {
                    if (ignoreDate) {
                        console.log("ignore date - limpiando fechas");
                        $("#itDesde").val("");
                        $("#itHasta").val("");
                    }

                    formCreatePlan.submit();
                } else {
                    window.mostrarAlerta("UPS!", $("#itValidacionHome2").val());
                }
            }
        }
    });

    // V3: Calendario único con selección de rango
    let dateRangeV3 = {
        startDate: null,
        endDate: null,
        currentMonth: new Date(),
        isSelecting: false
    };

    // Formatear fecha a DD/MM/YYYY
    function formatDateDisplay(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    // Formatear fecha a YYYY-MM-DD (para hidden inputs)
    function formatDateISO(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // Renderizar calendario con dos meses
    function renderCalendar() {
        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

        // Renderizar mes 1 (mes actual)
        renderMonth(dateRangeV3.currentMonth, ".month-1", ".month-1-days");

        // Renderizar mes 2 (mes siguiente)
        const nextMonth = new Date(dateRangeV3.currentMonth);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        renderMonth(nextMonth, ".month-2", ".month-2-days");
    }

    // Renderizar un mes específico
    function renderMonth(monthDate, monthLabelSelector, daysContainerSelector) {
        const $monthLabel = $(monthLabelSelector);
        const $days = $(daysContainerSelector);

        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();

        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

        $monthLabel.text(`${monthNames[month]} ${year}`);

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const startDayOfWeek = (firstDay.getDay() + 6) % 7; // Lunes = 0

        $days.empty();

        // Fecha de hoy (sin hora) para comparaciones
        const today = new Date();
        today.setHours(0,0,0,0);

        // Días vacíos al inicio
        for (let i = 0; i < startDayOfWeek; i++) {
            $days.append('<div class="calendar-day empty"></div>');
        }

        // Días del mes
        for (let day = 1; day <= lastDay.getDate(); day++) {
            const currentDate = new Date(year, month, day);
            const dateStr = formatDateISO(currentDate);
            const $dayEl = $('<div class="calendar-day" data-date="' + dateStr + '">' + day + '</div>');

            // Si la fecha es anterior a hoy, marcarla como pasada y deshabilitarla
            if (currentDate < today) {
                $dayEl.addClass('past-day disabled');
                $dayEl.attr('aria-disabled', 'true');
            }

            // Marcar si está en el rango seleccionado
            if (dateRangeV3.startDate && dateStr === formatDateISO(dateRangeV3.startDate)) {
                $dayEl.addClass('selected-start');
            }
            if (dateRangeV3.endDate && dateStr === formatDateISO(dateRangeV3.endDate)) {
                $dayEl.addClass('selected-end');
            }
            if (dateRangeV3.startDate && dateRangeV3.endDate) {
                const start = new Date(dateRangeV3.startDate);
                const end = new Date(dateRangeV3.endDate);
                if (currentDate > start && currentDate < end) {
                    $dayEl.addClass('in-range');
                }
            }

            $days.append($dayEl);
        }
    }

    // Variable para controlar el cierre del calendario
    let preventClose = false;

    // Click en input para mostrar/ocultar calendario
    $(document).on("click", "#dateRangeDisplay", function (e) {
        e.stopPropagation();
        e.preventDefault();
        const $calendar = $("#dateRangeCalendar");

        preventClose = true; // Evitar que el evento global lo cierre

        // Toggle simple y directo
        if ($calendar.css("display") === "none" || !$calendar.is(":visible")) {
            // Abrir
            renderCalendar();
            $calendar.css("display", "flex");
            $calendar.parent().addClass("active");
        } else {
            // Cerrar
            $calendar.hide();
            $calendar.parent().removeClass("active");
        }

        setTimeout(() => {
            preventClose = false;
        }, 100);
    });

    // Navegación de meses
    $(document).on("click", ".btn-prev-month", function (e) {
        e.stopPropagation();
        preventClose = true;
        dateRangeV3.currentMonth.setMonth(dateRangeV3.currentMonth.getMonth() - 1);
        renderCalendar();
        setTimeout(() => {
            preventClose = false;
        }, 100);
    });

    $(document).on("click", ".btn-next-month", function (e) {
        e.stopPropagation();
        preventClose = true;
        dateRangeV3.currentMonth.setMonth(dateRangeV3.currentMonth.getMonth() + 1);
        renderCalendar();
        setTimeout(() => {
            preventClose = false;
        }, 100);
    });

    // Click en un día
    $(document).on("click", ".calendar-day:not(.empty)", function (e) {
        e.stopPropagation();
        preventClose = true;
        // Ignorar clicks en días deshabilitados (fechas pasadas)
        if ($(this).hasClass('disabled')) {
            setTimeout(() => { preventClose = false; }, 50);
            return;
        }

        const dateStr = $(this).data("date");
        const selectedDate = new Date(dateStr + 'T00:00:00');

        if (!dateRangeV3.startDate || (dateRangeV3.startDate && dateRangeV3.endDate)) {
            // Iniciar nueva selección
            dateRangeV3.startDate = selectedDate;
            dateRangeV3.endDate = null;
            dateRangeV3.isSelecting = true;
        } else if (dateRangeV3.isSelecting) {
            // Completar selección
            if (selectedDate >= dateRangeV3.startDate) {
                dateRangeV3.endDate = selectedDate;
            } else {
                dateRangeV3.endDate = dateRangeV3.startDate;
                dateRangeV3.startDate = selectedDate;
            }
            dateRangeV3.isSelecting = false;

            // Actualizar hidden inputs
            $("#desde").val(formatDateISO(dateRangeV3.startDate));
            $("#hasta").val(formatDateISO(dateRangeV3.endDate));

            // Actualizar display
            $("#dateRangeDisplay").val(
                formatDateDisplay(dateRangeV3.startDate) + " - " + formatDateDisplay(dateRangeV3.endDate)
            );

            // Calcular número de días (para referencia)
            const timeDiff = dateRangeV3.endDate - dateRangeV3.startDate;
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
            const totalDays = daysDiff + 1;

            // Cerrar calendario
            $("#dateRangeCalendar").hide();
            $("#dateRangeCalendar").parent().removeClass("active");

        }

        renderCalendar();
        setTimeout(() => {
            preventClose = false;
        }, 100);
    });

    // Cerrar calendario al hacer click fuera
    $(document).on("click", function (e) {
        if (preventClose) return;

        const isClickOnCalendar = $(e.target).closest(".date-range-calendar").length > 0;
        const isClickOnInput = $(e.target).closest("#dateRangeDisplay").length > 0;

        if (!isClickOnInput && !isClickOnCalendar) {
            $("#dateRangeCalendar").hide();
            $("#dateRangeCalendar").parent().removeClass("active");
        }
    });

    // Non-V3: Manejar dateDesde y dateHasta como calendarios separados
    $("#dateDesde").on("change", function () {
        const desde = $(this).val();
        if (desde) {
            $("#desde").val(desde);
        }
    });

    $("#dateHasta").on("change", function () {
        const hasta = $(this).val();
        if (hasta) {
            $("#hasta").val(hasta);
        }
    });

    // Botón para limpiar fechas (ambas versiones)
    $(".js-deletefechas").on("click", function () {
        $("#desde").val("");
        $("#hasta").val("");

        // V3: Limpiar calendario de rango
        $("#dateRangeDisplay").val("");
        dateRangeV3.startDate = null;
        dateRangeV3.endDate = null;
        dateRangeV3.isSelecting = false;
        $("#dateRangeCalendar").hide();
        $("#dateRangeCalendar").parent().removeClass("active");

        // Non-V3: Limpiar dateDesde y dateHasta
        $("#dateDesde").val("");
        $("#dateHasta").val("");

        // Recargar la página para que se actualice el resumen
        location.reload();
    });

    // Botón para crear itinerario nuevo
    $(".js-crearplannuevo").on("click", function () {
        var desde = $("#desde").val();
        var hasta = $("#hasta").val();

        // remove new_itinerary from the localStorage
        console.log(
            "%cRemoving new_itinerary from localStorage",
            "color: red; font-weight: bold;"
        );
        localStorage.removeItem("new_itinerary");

        var isAccompanimentSelected =
            $('input[name="accompaniments[]"]:checked').length > 0;
        var isInterestSelected =
            $('input[name="interests[]"]:checked').length > 0;
        var isSiteSelected = $('input[name="sites[]"]:checked').length > 0;
        if (
            isAccompanimentSelected &&
            isInterestSelected &&
            isSiteSelected &&
            desde != "" &&
            hasta != ""
        ) {
            var desdeDate = new Date(desde);
            var hastaDate = new Date(hasta);
            if (hastaDate >= desdeDate) {
                $("#fCreateIti").submit();
            } else {
                window.mostrarAlerta("UPS!", $("#itValidacionHome2").val());
            }
        } else {
            window.mostrarAlerta("UPS!", $("#itValidacionHome3").val());
        }
    });

    $(".js-generalSearch").on("click", function () {
        $("#formSearchFilter #searchSearch").val(
            $("#formSearchFilterAux").find("input").val()
        );
        $("#formSearchFilter").submit();
    });

    $(".js-searchPpp").on("click", function () {
        $(this)
            .closest(".dropdown")
            .find(".dropdown-toggle span")
            .html($(this).attr("data-value"));

        var elementoFiltro = "#searchPpp";
        if (typeof $(this).attr("data-tipo") !== "undefined") {
            elementoFiltro = "#searchPpp_" + $(this).attr("data-tipo");
        }

        $("#formSearchFilter " + elementoFiltro).val(
            $(this).attr("data-value")
        );
        $("#formSearchFilter").submit();
    });

    $("#formSearchFilterAux").on("submit", function (e) {
        e.preventDefault();

        $("#formSearchFilter #searchSearch").val(
            $("#formSearchFilterAux").find("input").val()
        );

        $("#formSearchFilter").submit();
    });

    $(".js-deleteFilters").on("click", function () {
        $("#formSearchFilter").find("input[type=text]").val("");
        $("#formSearchFilter").find("input[type=date]").val("");
        $("#formSearchFilter").find("input[type=radio]").prop("checked", false);
        $("#formSearchFilter")
            .find("input[type=checkbox]")
            .prop("checked", false);
        $("#formSearchFilter").submit();
    });

    $(".js-deleteFilter").on("click", function () {
        $("#" + $(this).attr("data-target")).prop("checked", false);
        $("#formSearchFilter").submit();
    });

    $(".js-searchGoPag").on("click", function () {
        var elementoFiltro = "#searchPag";
        if (typeof $(this).attr("data-tipo") !== "undefined") {
            elementoFiltro = "#searchPag_" + $(this).attr("data-tipo");
        }

        $("#formSearchFilter " + elementoFiltro).val($(this).attr("data-pag"));
        $("#formSearchFilter").submit();

        // $("#formSearchFilter #searchPag").val($(this).attr("data-pag"));
        // $("#formSearchFilter").submit();
    });

    $(".js-searchViewList").on("click", function () {
        $(".js-searchViewList").addClass("active");
        $(".js-searchViewMap").removeClass("active");

        $(".tab-pane-list").show();
        $(".tab-pane-map").hide();
    });

    $(".js-searchViewMap").on("click", function () {
        $(".js-searchViewList").removeClass("active");
        $(".js-searchViewMap").addClass("active");

        $(".tab-pane-list").hide();
        $(".tab-pane-map").show();
    });

    window.initClicksPanels = function () {
        console.log("inicializo clicks paneles");

        $(".js-openSiteModal").off("click");

        $(".js-openSiteModal").click(function (e) {
            e.preventDefault();

            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var originalUrl = window.location.href;

            // disconnect the observer if it is connected
            let observer;
            try {
                observer = window.cookieyes._nodeListObserver;
                observer.disconnect();
                console.log("disconnected observer");
            } catch (e) {
                console.log("error disconnect observer");
            }

            console.log('pasa con:: ' + id);
            $.ajax({
                method: "GET",
                url: $(this).attr("data-slugmodal"), //$(this).attr("href"),
                type: "html",
                success: function (html) {
                    $("#modalSite .contenido").html(html);
                    history.pushState(null, null, slugModal);
                    // console.log("site");

                    setTimeout(function () {

                        //$("#modalSite .placeModal").css("right", "0%");
                        // $("#modalSite .placeModal").removeClass("hide");
                        $("#modalSite").show();

                        setTimeout(function () {
                            $("#modalSite .placeModal").removeClass("hide");

                            // Inicializar swipers para el contenido cargado por AJAX (site modal)
                            setTimeout(function () {
                                try {
                                    initializeEventSwipers();
                                } catch (err) {
                                    console.error('Error inicializando swipers en modalSite:', err);
                                }
                            }, 50);
                        }, 50);

                        $("#modalSite .placeModal .js-closePanel").click(
                            function (e) {
                                e.preventDefault();

                                //$("#modalSite .placeModal").css("right", "-100%");
                                $("#modalSite .placeModal").addClass("hide");
                                $("#modalSite").hide();

                                // Destruir swipers inicializados para este modal
                                try { destroyEventSwipers(); } catch (err) { console.error(err); }

                                history.replaceState(null, null, originalUrl);

                                $("#modalSite .placeModal .js-closePanel").off(
                                    "click"
                                );
                                $("#modalSite").off("click");
                            }
                        );

                        $("#modalSite").click(function (e) {
                            e.preventDefault();
                            // Verificar si el clic fue fuera de `.contenido`
                            if (!$(e.target).closest(".contenido").length) {
                                $("#modalSite .placeModal").addClass("hide");
                                $("#modalSite").hide();

                                // Destruir swipers inicializados para este modal
                                try { destroyEventSwipers(); } catch (err) { console.error(err); }

                                history.replaceState(null, null, originalUrl);

                                $("#modalSite .placeModal .js-closePanel").off(
                                    "click"
                                );
                                $("#modalSite").off("click");
                            }
                        });

                        // connect the observer if it was connected
                        try {
                            observer.observe();
                            console.log("connect observer");
                        } catch (e) {
                            console.log("error connect observer");
                        }
                    }, 500);
                },
                error: function (xhr) { },
            });
        });


        $(".js-openSectioncardModal").off("click");

        $(".js-openSectioncardModal").click(function (e) {
            e.preventDefault();

            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var originalUrl = window.location.href;
            //console.log(id);
            //console.log('event');
            $.ajax({
                method: "GET",
                url: $(this).attr("data-slugmodal"), //$(this).attr("href"),
                type: "html",
                success: function (html) {
                    $("#modalSectioncard .contenido").html(html);
                    history.pushState(null, null, slugModal);
                    //console.log('pasa');
                    setTimeout(function () {
                        //$("#modalSite .placeModal").css("right", "0%");
                        $("#modalSectioncard").show();

                        setTimeout(function () {
                            $("#modalSectioncard .modEventPanelv2").removeClass("hide");
                                // Inicializar swipers para el contenido cargado por AJAX (sectioncard modal)
                                setTimeout(function () {
                                    try {
                                        initializeEventSwipers();
                                    } catch (err) {
                                        console.error('Error inicializando swipers en modalSectioncard:', err);
                                    }
                                }, 50);
                        }, 50);

                        //console.log('muestra');
                        $("#modalSectioncard .modEventPanelv2 .js-closePanel").click(
                            function (e) {
                                e.preventDefault();

                                //$("#modalSite .placeModal").css("right", "-100%");
                                $("#modalSectioncard .modEventPanelv2").addClass(
                                    "hide"
                                );
                                $("#modalSectioncard").hide();
                                // Destruir swipers inicializados para este modal
                                try { destroyEventSwipers(); } catch (err) { console.error(err); }
                                history.replaceState(null, null, originalUrl);

                                $(
                                    "#modalSectioncard .modEventPanelv2 .js-closePanel"
                                ).off("click");
                                $("#modalSectioncard").off("click");
                            }
                        );

                        $("#modalSectioncard").click(function (e) {
                            e.preventDefault();
                            // Verificar si el clic fue fuera de `.contenido`
                            if (!$(e.target).closest(".contenido").length) {
                                $("#modalSectioncard .modEventPanelv2").addClass(
                                    "hide"
                                );
                                $("#modalSectioncard").hide();
                                try { destroyEventSwipers(); } catch (err) { console.error(err); }
                                history.replaceState(null, null, originalUrl);

                                $(
                                    "#modalSectioncard .modEventPanelv2 .js-closePanel"
                                ).off("click");
                                $("#modalSectioncard").off("click");
                            }
                        });
                    }, 500);
                },
                error: function (xhr) { },
            });
        });



        // Event delegation para js-openEventModal
        $(document).off("click.eventModal", ".js-openEventModal");
        $(document).on("click.eventModal", ".js-openEventModal", function (e) {
            e.preventDefault();

            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var originalUrl = window.location.href;
            console.log("Opening event modal:", id);

            $.ajax({
                method: "GET",
                url: $(this).attr("data-slugmodal"),
                type: "html",
                success: function (html) {
                    $("#modalEvent .contenido").html(html);
                    history.pushState(null, null, slugModal);

                    setTimeout(function () {
                        $("#modalEvent").show();

                        setTimeout(function () {
                            $("#modalEvent .modEventPanelv2").removeClass("hide");
                        }, 50);

                        let swiperImageTitleCardModal = null;

                        function initSwiperImageTitleCardModal() {
                            if (swiperImageTitleCardModal) {
                                swiperImageTitleCardModal.destroy(true, true);
                            }

                            swiperImageTitleCardModal = new Swiper("#modalEvent .swiperImageTitleCard", {
                                loop: false,
                                pagination: {
                                    el: "#modalEvent .swiper-pagination",
                                    dynamicBullets: true,
                                    dynamicMainBullets: 3,
                                },
                                navigation: {
                                    nextEl: "#modalEvent .swiper-button-next",
                                    prevEl: "#modalEvent .swiper-button-prev",
                                },
                                slidesPerView: 1,
                                spaceBetween: 20,
                            });
                        }

                        initSwiperImageTitleCardModal();

                        // Cleanup previous handlers and bind new ones
                        $("#modalEvent .modEventPanelv2 .js-closePanel").off("click.eventModal");
                        $("#modalEvent").off("click.eventModal");

                        $("#modalEvent .modEventPanelv2 .js-closePanel").on("click.eventModal", function (e) {
                            e.preventDefault();
                            console.log("Closing event modal via close button");

                            $("#modalEvent .modEventPanelv2").addClass("hide");
                            $("#modalEvent").hide();
                            history.replaceState(null, null, originalUrl);

                            // Cleanup handlers
                            $("#modalEvent .modEventPanelv2 .js-closePanel").off("click.eventModal");
                            $("#modalEvent").off("click.eventModal");
                        });

                        $("#modalEvent").on("click.eventModal", function (e) {
                            // Verificar si el clic fue fuera de `.contenido`
                            if (!$(e.target).closest(".contenido").length) {
                                e.preventDefault();
                                console.log("Closing event modal via background click");

                                $("#modalEvent .modEventPanelv2").addClass("hide");
                                $("#modalEvent").hide();
                                history.replaceState(null, null, originalUrl);

                                // Cleanup handlers
                                $("#modalEvent .modEventPanelv2 .js-closePanel").off("click.eventModal");
                                $("#modalEvent").off("click.eventModal");
                            }
                        });
                    }, 500);
                },
                error: function (xhr) {
                    console.error("Error loading event modal:", xhr.status, xhr.responseText);
                },
            });
        });

        //$(".js-openPlaceModal").off("click");

        $(document).on("click", ".js-openPlaceModal", function (e) {
            console.log('js-openPlaceModal click handler fired');
            e.preventDefault();

            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var originalUrl = window.location.href;
            var dataSlugModal = $(this).attr("data-slugmodal");

            console.log('js-openPlaceModal', { id: id, slug: slugModal, dataSlugModal: dataSlugModal });

            //console.log("place: " + dataSlugModal);

            // Verifica que el data-slugmodal no sea nulo o vacío
            if (!dataSlugModal || dataSlugModal.trim() === "") {
                console.error("El atributo data-slugmodal está vacío.");
                return;
            }
            // console.log("siiii");
            $.ajax({
                method: "GET",
                url: dataSlugModal,
                type: "html",
                success: function (html) {
                    //console.log("llega");
                    //console.log("Respuesta del servidor recibida:", html);

                    // Verifica si la respuesta es válida
                    if (!html || html.trim() === "") {
                        console.error(
                            "El servidor devolvió una respuesta vacía."
                        );
                        return;
                    }

                    // Inserta el HTML recibido en el modal
                    $("#modalPlace .contenido").html(html);
                    //console.log("HTML insertado correctamente en el modal.");

                    // Se utiliza swiperEventGallerySingleFluid ya inicializado anteriormente

                    // Cambia la URL a la del modal
                    history.pushState(null, null, slugModal);
                    //console.log("URL cambiada a:", slugModal);

                    // Muestra el modal
                    $("#modalPlace .placeModal").removeClass("hide");
                    $("#modalPlace").show();

                    // Inicializar swipers para el contenido cargado por AJAX (place modal)
                    try {
                        initializeEventSwipers();
                    } catch (err) {
                        console.error('Error inicializando swipers en modalPlace:', err);
                    }
                    //console.log("Modal mostrado.");

                    // Lógica de cierre del modal
                    $("#modalPlace .placeModal .js-closePanel").click(function (
                        e
                    ) {
                        e.preventDefault();
                        //  console.log("Cerrando modal...");

                        $("#modalPlace .placeModal").addClass("hide");
                        $("#modalPlace").hide();

                        // Destruir swipers inicializados para este modal
                        try { destroyEventSwipers(); } catch (err) { console.error(err); }

                        // Cambia la URL de vuelta al original
                        history.replaceState(null, null, originalUrl);
                        console.log("URL restaurada a:", originalUrl);

                        // Elimina event listeners para evitar duplicados
                        $("#modalPlace .placeModal .js-closePanel").off(
                            "click"
                        );
                        $("#modalPlace").off("click");
                    });

                    // Cierre del modal al hacer clic fuera del contenido
                    /*$("#modalPlace").click(function (e) {
                        e.preventDefault();
                        if (!$(e.target).closest(".contenido").length) {
                            console.log(
                                "Cerrando modal al hacer clic fuera del contenido..."
                            );

                            $("#modalPlace .placeModal").addClass("hide");
                            $("#modalPlace").hide();

                            // Cambia la URL de vuelta al original
                            history.replaceState(null, null, originalUrl);
                            console.log("URL restaurada a:", originalUrl);

                            // Elimina event listeners para evitar duplicados
                            $("#modalPlace .placeModal .js-closePanel").off(
                                "click"
                            );
                            $("#modalPlace").off("click");
                        }
                    });*/
                    $("#modalPlace").click(function (e) {
                        // Solo cerramos el modal si el clic fue fuera del contenido, si no lo hago así, no abre los links del contenido
                        if (!$(e.target).closest(".contenido").length) {
                            e.preventDefault();

                            //console.log("Cerrando modal al hacer clic fuera del contenido...");

                            $("#modalPlace .placeModal").addClass("hide");
                            $("#modalPlace").hide();

                            history.replaceState(null, null, originalUrl);
                            //console.log("URL restaurada a:", originalUrl);

                            $("#modalPlace .placeModal .js-closePanel").off("click");
                            $("#modalPlace").off("click");
                        }
                    });
                },
                error: function (xhr) {
                    console.error(
                        "Error en la solicitud AJAX:",
                        xhr.status,
                        xhr.statusText
                    );
                },
            });
        });



        $(".js-openItineraryModal").off("click");

        $(".js-openItineraryModal").click(function (e) {
            e.preventDefault();

            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var originalUrl = window.location.href;
            //console.log(id);
            //console.log('event');
            $.ajax({
                method: "GET",
                url: $(this).attr("data-slugmodal"), //$(this).attr("href"),
                type: "html",
                success: function (html) {
                    $("#modalItinerary .contenido").html(html);
                    history.pushState(null, null, slugModal);
                    setTimeout(function () {

                        $("#modalItinerary").show();

                        setTimeout(function () {
                            $("#modalItinerary .modEventPanelv2").removeClass("hide");
                        }, 50);


                        $("#modalItinerary .modEventPanelv2 .js-closePanel").click(
                            function (e) {
                                e.preventDefault();

                                $("#modalItinerary .modEventPanelv2").addClass(
                                    "hide"
                                );
                                $("#modalItinerary").hide();
                                history.replaceState(null, null, originalUrl);

                                $(
                                    "#modalItinerary .modEventPanelv2 .js-closePanel"
                                ).off("click");
                                $("#modalItinerary").off("click");
                            }
                        );

                        $("#modalItinerary").click(function (e) {
                            e.preventDefault();
                            // Verificar si el clic fue fuera de `.contenido`
                            if (!$(e.target).closest(".contenido").length) {
                                $("#modalItinerary .modEventPanelv2").addClass(
                                    "hide"
                                );
                                $("#modalItinerary").hide();
                                history.replaceState(null, null, originalUrl);

                                $(
                                    "#modalItinerary .modEventPanelv2 .js-closePanel"
                                ).off("click");
                                $("#modalItinerary").off("click");
                            }
                        });
                    }, 500);
                },
                error: function (xhr) { },
            });
        });


        // Event delegation para js-openArticleModal
        $(document).off("click.articleModal", ".js-openArticleModal");
        $(document).on("click.articleModal", ".js-openArticleModal", function (e) {
            e.preventDefault();
            var id = $(this).attr("data-id");
            var slugModal = $(this).attr("href");
            var dataSlugModal = $(this).attr("data-slugmodal");
            var originalUrl = window.location.href;
            console.log("Opening article modal:", id, "URL:", dataSlugModal);

            // Verificar que data-slugmodal existe
            if (!dataSlugModal || dataSlugModal.trim() === "") {
                console.error("El atributo data-slugmodal está vacío o no existe");
                return;
            }

            $.ajax({
                method: "GET",
                url: dataSlugModal,
                type: "html",
                success: function (html) {
                    console.log("Article modal HTML received, length:", html ? html.length : 0);

                    // Verificar que el HTML no esté vacío
                    if (!html || html.trim() === "") {
                        console.error("El servidor devolvió una respuesta vacía");
                        return;
                    }

                    $("#modalArticle .contenido").html(html);
                    history.pushState(null, null, slugModal);

                    setTimeout(function () {
                        // Verificar que los elementos existen antes de manipularlos
                        if ($("#modalArticle").length === 0) {
                            console.error("modalArticle no existe en el DOM");
                            return;
                        }

                        $("#modalArticle").show();

                        setTimeout(function () {
                            const panelSelector = "#modalArticle [class*='modEventPanel']";
                            if ($(panelSelector).length > 0) {
                                $(panelSelector).removeClass("hide");

                                // Reinicializar el swiper del artículo dentro del modal
                                setTimeout(function () {
                                    const swiperElement = document.querySelector("#modalArticle .swiperNews");
                                    if (swiperElement) {
                                        console.log("Elemento .swiperNews encontrado, inicializando swiper");
                                        // Destruir cualquier swiper previo del modal
                                        if (window.swiperNewsModal && typeof window.swiperNewsModal.destroy === 'function') {
                                            try {
                                                window.swiperNewsModal.destroy(true, true);
                                            } catch (e) {
                                                console.warn("Error al destruir swiper anterior:", e);
                                            }
                                        }

                                        // Crear nuevo swiper para el modal
                                        try {
                                            window.swiperNewsModal = new Swiper("#modalArticle .swiperNews", {
                                                loop: true,
                                                slidesPerView: 1.2,
                                                spaceBetween: 20,
                                                navigation: {
                                                    nextEl: "#modalArticle .swiper-btn-news-next",
                                                    prevEl: "#modalArticle .swiper-btn-news-prev",
                                                },
                                                breakpoints: {
                                                    640: {
                                                        slidesPerView: 2,
                                                    },
                                                },
                                                on: {
                                                    init: function () {
                                                        console.log("swiperNews dentro del modal se ha inicializado");
                                                    }
                                                },
                                            });
                                        } catch (e) {
                                            console.error("Error inicializando swiper del modal:", e);
                                        }
                                    } else {
                                        console.warn("Elemento .swiperNews no encontrado en el modal");
                                    }
                                }, 150);
                            } else {
                                console.error("modalArticle modEventPanel no existe");
                            }
                        }, 50);

                        // Cleanup previous handlers and bind new ones
                        const panelSelector = "#modalArticle [class*='modEventPanel']";
                        $(panelSelector + " .js-closePanel").off("click.articleModal");
                        $("#modalArticle").off("click.articleModal");

                        $(panelSelector + " .js-closePanel").on("click.articleModal", function (e) {
                            e.preventDefault();
                            console.log("Closing article modal via close button");

                            $(panelSelector).addClass("hide");
                            $("#modalArticle").hide();
                            history.replaceState(null, null, originalUrl);

                            // Cleanup handlers
                            $(panelSelector + " .js-closePanel").off("click.articleModal");
                            $("#modalArticle").off("click.articleModal");
                        });

                        $("#modalArticle").on("click.articleModal", function (e) {
                            // Verificar si el clic fue fuera de `.contenido`
                            if (!$(e.target).closest(".contenido").length) {
                                e.preventDefault();
                                console.log("Closing article modal via background click");

                                $(panelSelector).addClass("hide");
                                $("#modalArticle").hide();
                                history.replaceState(null, null, originalUrl);

                                // Cleanup handlers
                                $(panelSelector + " .js-closePanel").off("click.articleModal");
                                $("#modalArticle").off("click.articleModal");
                            }
                        });
                    }, 500);
                },
                error: function (xhr, status, error) {
                    console.error("Error loading article modal:", {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        error: error,
                        responseText: xhr.responseText
                    });
                },
            });
        });




    };



    window.initClicksPanels();

    $("#btSuscribirte").on("click", function () {
        var email_suscription = $("#email_suscription").val();
        var legal = $("#terms").is(":checked");
        var locale = $("#locale_suscription").val();

        if (email_suscription == "" || !legal) {
            window.mostrarAlerta("UPS!", $("#itValidacionHome3").val());
        } else {
            $.ajax({
                method: "POST",
                url: "/savesuscription",
                data: {
                    email: email_suscription,
                    locale: locale
                },
                dataType: "json",
            }).done(function (response) {
                if (response.status === "ok") {
                    window.mostrarAlerta(response.title, response.message);
                } else {
                    window.mostrarAlerta(response.title, response.error);
                }
            });
        }
    });

    window.swiperAgenda = document.querySelector("#swiperAgenda") ? new Swiper("#swiperAgenda", {
        loop: false,
        pagination: {
            el: "#swiperAgenda .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
        },
        navigation: {
            nextEl: "#swiperAgenda .swiper-button-next",
            prevEl: "#swiperAgenda .swiper-button-prev",
        },
        slidesPerView: themeVersion == 'v3' ? 4.3 : 3.3,
        spaceBetween: 42,
        breakpoints: {
            // Cuando el ancho es < 990px, mostrar 2 elementos
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2.3,
            },
            990: {
                slidesPerView: 3.3,
            },
            1536: {
            slidesPerView: themeVersion == 'v3' ? 4.3 : 3.3,
        }
        }
    }) : null;

    window.siteSwiperAgenda = document.querySelector("#siteSwiperAgenda") ? new Swiper("#siteSwiperAgenda", {
        loop: false,
        pagination: {
            el: "#siteSwiperAgenda .swiper-pagination",
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3,
        },
        slidesPerView: themeVersion == 'v3' ? 4.3 : 3.3,
        spaceBetween: 42,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2.3,
            },
            990: {
                slidesPerView: 3.3,
            },
            1536: {
                slidesPerView: themeVersion == 'v3' ? 4.3 : 3.3,
            }
        }
    }) : null;




    const scrubSection = $(".info-ponferrada");
    if (scrubSection.length === 0) {
        console.log("No scrub section found");
        return;
    } else {

        /**
         * Configuration for the scrub / highlight effect.
         * Tweak these values to adjust behavior.
         */
        const scrubConfig = {
            // Extra area before the section starts “activating” (px)
            paddingTop: -200,
            // Extra area after the section stops “activating” (px)
            paddingBottom: 1000,
            // Percentage of section that must be visible to be considered “in view”
            minVisiblePercent: 40,
            // CSS class names
            classes: {
                inView: "in-view",
                word: "scrub-word",
                wordHighlighted: "highlighted",
                line: "scrub-line"
            },
            // Selector for the lines inside the scrub section
            lineSelector: "p"
        };

        // State
        let seenWordIndexes = new Set();
        let lastScrollY = window.scrollY;
        let words = [];

        /**
         * Check if jQuery element is in viewport with optional visible percent and paddings.
         */
        function getPercentageVisible($el, {
            minPercent = 0,
            paddingTop = 0,
            paddingBottom = 0
        } = {}) {
            if (!$el || $el.length === 0) return false;

            const rect = $el[0].getBoundingClientRect();

            const viewportTop = window.scrollY;
            const viewportBottom = viewportTop + window.innerHeight;

            const elTop = rect.top + window.scrollY;
            const elBottom = rect.bottom + window.scrollY;
            const elHeight = elBottom - elTop;

            const inView =
                viewportBottom > (elTop - paddingTop) &&
                viewportTop < (elBottom + paddingBottom);

            if (!inView) return 0;

            const visibleTop = Math.max(elTop, viewportTop);
            const visibleBottom = Math.min(elBottom, viewportBottom);
            const visible = Math.max(0, visibleBottom - visibleTop);
            const percent = (visible / elHeight) * 100;

            return percent;
        }

        /**
         * Split each configured line into word spans and collect them.
         */
        function prepareScrubText() {
            const lineSelector = scrubConfig.lineSelector;
            const lineClass = scrubConfig.classes.line;
            const wordClass = scrubConfig.classes.word;

            const lines = scrubSection.find(lineSelector).each(function () {
                $(this).addClass(lineClass);
            });

            lines.each(function () {
                const $line = $(this);
                const lineContent = $line.html();
                const lineClasses = $line.attr("class") || "";
                const lineStyle = $line.attr("style") ? `style="${$line.attr("style")}"` : "";

                const $newLine = $(`<div class="${lineClasses}" ${lineStyle}></div>`);

                const wordsInLine = lineContent.split(" ");
                wordsInLine.forEach((word, idx) => {
                    if (!word.trim()) return;

                    const $span = $(
                        `<span class="${wordClass}" data-index="${idx}">${word} </span>`
                    );
                    $newLine.append($span);
                    words.push($span[0]);
                });

                $line.replaceWith($newLine);
            });
        }

        /**
         * Highlight / unhighlight words based on scroll progress and direction.
         * scrollProgress is expected to be in [0, 1]
         */
        function updateWordHighlights(scrollProgress, scrollingDown) {
            const totalWords = words.length;
            if (totalWords === 0) return;

            // Asegurar que scrollProgress está entre 0 y 1
            const clampedProgress = Math.min(Math.max(scrollProgress, 0), 1);

            const targetIndex = Math.min(
                Math.floor(clampedProgress * totalWords),
                totalWords - 1
            );

            if (scrollingDown) {
                for (let i = 0; i <= targetIndex; i++) {
                    if (!seenWordIndexes.has(i)) {
                        seenWordIndexes.add(i);
                        $(words[i]).classList
                            ? words[i].classList.add(scrubConfig.classes.wordHighlighted)
                            : $(words[i]).addClass(scrubConfig.classes.wordHighlighted);
                    }
                }
            } else {
                for (let i = totalWords - 1; i >= targetIndex; i--) {
                    if (seenWordIndexes.has(i)) {
                        seenWordIndexes.delete(i);
                        words[i].classList
                            ? words[i].classList.remove(scrubConfig.classes.wordHighlighted)
                            : $(words[i]).removeClass(scrubConfig.classes.wordHighlighted);
                    }
                }
            }
        }

        /**
         * Main scroll handler for the scrub section.
         */
        function onScroll(e) {
            const percentageVisible = getPercentageVisible(scrubSection, {
                minPercent: scrubConfig.minVisiblePercent,
                paddingTop: scrubConfig.paddingTop,
                paddingBottom: scrubConfig.paddingBottom
            });

            let inViewport = false;

            if (
                percentageVisible !== false &&
                percentageVisible >= scrubConfig.minVisiblePercent
            ) {
                inViewport = true;
            }

            const currentScrollY = window.scrollY;
            const scrollingDown = currentScrollY > lastScrollY;
            lastScrollY = currentScrollY;

            if (inViewport) {
                scrubSection.addClass(scrubConfig.classes.inView);
            } else {
                scrubSection.removeClass(scrubConfig.classes.inView);
            }

            // --- NUEVO CÁLCULO DE scrollProgress TENIENDO EN CUENTA minVisiblePercent Y paddingBottom ---

            let scrollProgress = 0;

            if (percentageVisible !== false) {
                // Normalizamos el porcentaje visible a [0, 1] y
                // desplazamos el inicio al minVisiblePercent.
                const min = scrubConfig.minVisiblePercent;
                const max = 100;

                if (percentageVisible <= min) {
                    scrollProgress = 0;
                } else if (percentageVisible >= max) {
                    scrollProgress = 1;
                } else {
                    scrollProgress = (percentageVisible - min) / (max - min);
                }
            }


            updateWordHighlights(scrollProgress, scrollingDown);
        }

        // Initialize
        prepareScrubText();
        window.addEventListener("scroll", onScroll, { passive: false });
    }


});

// Para el itinerario personalizado

let dragging;

// TODO: meter en itinerary_new este script que recibe el itinerario de php y lo pasa a la variable window.itinerary

// let dayIndex = day - 1;

let itineraryManager;
let dragManager;

let itinerary;
let day;
let dayIndex;

document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.video-thumbnail').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const videoUrl = this.dataset.video;

            const video = document.createElement('video');
            video.src = videoUrl;
            video.controls = true;
            video.classList.add('w-100');
            video.setAttribute('playsinline', '');
            video.setAttribute('preload', 'metadata');

            this.replaceWith(video);
            video.play();
        });
    });

    // Bloques de contenido con vídeo (pages-pueblos)
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.block-video-play');
        if (!trigger) return;
        e.preventDefault();

        var videoUrl = trigger.dataset.video;
        var player   = document.getElementById('blockVideoPlayer');
        var modalEl  = document.getElementById('modalBlockVideo');
        if (!player || !modalEl) return;

        player.src = videoUrl;
        player.load();

        var modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);

        modalEl.addEventListener('shown.bs.modal', function onShown() {
            modalEl.removeEventListener('shown.bs.modal', onShown);
            player.play().catch(function () {});
        });

        modal.show();
    });

    document.addEventListener('hidden.bs.modal', function (e) {
        if (e.target.id === 'modalBlockVideo') {
            var player = document.getElementById('blockVideoPlayer');
            if (player) {
                player.pause();
                player.src = '';
            }
        }
    });

    // Botón pantalla completa del vídeo de bloques
    document.addEventListener('click', function (e) {
        if (!e.target.closest('#blockVideoFullscreenBtn')) return;
        var player = document.getElementById('blockVideoPlayer');
        if (!player) return;
        if (player.requestFullscreen) {
            player.requestFullscreen();
        } else if (player.webkitRequestFullscreen) {
            player.webkitRequestFullscreen();
        } else if (player.mozRequestFullScreen) {
            player.mozRequestFullScreen();
        }
    });

    // Manejador para ampliar imágenes del swiper (usando delegación de eventos)
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-ampliarImaenSwiper')) {
            e.preventDefault();
            const link = e.target.closest('.js-ampliarImaenSwiper');
            const imagenUrl = link.href || link.dataset.imagen || link.src || link.getAttribute('src');
            console.log("hay click en imagen");
            if (imagenUrl) {
                console.log("hay imagenUrl", imagenUrl);
                $("#imagenAmpliada").attr('src', imagenUrl);
                const modalAmpliacionImagen = new bootstrap.Modal(document.getElementById('modalAmpliacionImagen'));
                modalAmpliacionImagen.show();
            }
        }
    }, true);

    const viewerContainer = document.querySelector('#viewer360');

    if (viewerContainer && viewerContainer.dataset.image360) {
        const modal = document.getElementById('modalViewer360');
        if (!modal) return;

        const bootstrapModal = new bootstrap.Modal(modal);
        const instructionModal = document.getElementById('viewerInstruction');
        const confirmBtn = document.getElementById('instructionConfirm');
        const closeBtn = instructionModal.querySelector('.btn-close');

        // Ocultar el aviso al confirmar o cerrar
        confirmBtn.addEventListener('click', () => {
            instructionModal.classList.add('d-none');
        });
        closeBtn.addEventListener('click', () => {
            instructionModal.classList.add('d-none');
        });

        // Inicializar visor al mostrar el modal si no está cargado
        modal.addEventListener('shown.bs.modal', () => {
            const container = document.getElementById('viewer360');

            if (!container.dataset.loaded) {
                const imageUrl = container.dataset.image360; // ya viene la URL
                //console.log('URL válida:', !!(imageUrl && imageUrl !== ''));

                // Detectar si estamos dentro de otro modal y manejar backdrops
                const allBackdrops = document.querySelectorAll('.modal-backdrop');
                const isInsideModal = document.querySelector('.modal.show') !== null;
                //console.log('Modales detectados:', document.querySelectorAll('.modal.show').length);
                //console.log('Backdrops detectados:', allBackdrops.length);

                if (isInsideModal && allBackdrops.length > 1) {
                    //console.log('Ajustando backdrops para modales anidados');
                    // Ocultar backdrops adicionales
                    allBackdrops.forEach((backdrop, index) => {
                        if (index > 0) { // Mantener solo el primer backdrop
                            backdrop.style.display = 'none';
                        } else {
                            backdrop.style.zIndex = '9998';
                        }
                    });
                }

                // Asegurar que el modal 360 esté por encima
                modal.style.zIndex = '9999';

                if (imageUrl && imageUrl !== '') {
                    console.log('Intentando crear PhotoSphereViewer...');
                    try {
                        window.viewer360 = new window.PhotoSphereViewer.Viewer({
                            container,
                            panorama: imageUrl,
                            navbar: ['zoom', 'fullscreen'],
                            loadingImg: '/images/loading.gif',
                        });
                    } catch (error) {
                        console.error('Error al crear PhotoSphereViewer:', error);
                    }
                } else {
                    console.error('No se encontró URL de imagen 360 válida:', imageUrl);
                }
                container.dataset.loaded = true;
            } else {
                console.log('Container ya tiene imagen cargada, omitiendo inicialización');
            }

            // Mostrar instrucciones solo la primera vez
            instructionModal.classList.remove('d-none');
        });

        // Limpiar backdrops al cerrar el modal 360
        modal.addEventListener('hidden.bs.modal', () => {
            // Restaurar backdrops ocultos
            const allBackdrops = document.querySelectorAll('.modal-backdrop');
            allBackdrops.forEach(backdrop => {
                backdrop.style.display = '';
                backdrop.style.zIndex = '';
            });

            // Destruir el visor
            if (window.viewer360) {
                window.viewer360.destroy();
                window.viewer360 = null;
            }
        });

        // Botón personalizado para cerrar el visor
        const closeButton = document.querySelector('.close-viewer');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                bootstrapModal.hide();
            });
        }

        // Nuevo botón "Volver a la vista normal"
        const btnCloseViewer = document.getElementById('btnCloseViewer360');
        if (btnCloseViewer) {
            btnCloseViewer.addEventListener('click', () => {
                bootstrapModal.hide();
            });
        }
    }

    // Función para detectar y configurar PhotoSphereViewer dinámicamente
    function setupPhotoSphereViewer() {
        console.log('🔄 Buscando viewers360 para configurar...');

        const viewerContainers = document.querySelectorAll('#viewer360');

        viewerContainers.forEach(viewerContainer => {
            if (viewerContainer && viewerContainer.dataset.image360 && !viewerContainer.dataset.configured) {
                console.log('🔄 Configurando nuevo viewer360:', viewerContainer.dataset.image360);

                const modal = document.getElementById('modalViewer360');
                if (!modal) return;

                const bootstrapModal = new bootstrap.Modal(modal);
                const instructionModal = modal.querySelector('#viewerInstruction');
                const confirmBtn = modal.querySelector('#instructionConfirm');
                const closeBtn = modal.querySelector('.btn-close');

                console.log('🔄 Elementos encontrados:', {
                    instructionModal: !!instructionModal,
                    confirmBtn: !!confirmBtn,
                    closeBtn: !!closeBtn
                });

                // Ocultar el aviso al confirmar o cerrar
                if (confirmBtn) {
                    confirmBtn.addEventListener('click', () => {
                        console.log('🔄 Botón confirmar clickeado');
                        if (instructionModal) {
                            instructionModal.classList.add('d-none');
                            instructionModal.style.display = 'none';
                        }
                    });
                }
                if (closeBtn) {
                    closeBtn.addEventListener('click', () => {
                        console.log('🔄 Botón cerrar instrucciones clickeado');
                        if (instructionModal) {
                            instructionModal.classList.add('d-none');
                            instructionModal.style.display = 'none';
                        }
                    });
                }

                // Inicializar visor al mostrar el modal si no está cargado
                modal.addEventListener('shown.bs.modal', () => {
                    console.log('🔄 Modal 360 shown evento disparado');
                    const container = document.getElementById('viewer360');

                    if (container && !container.dataset.loaded) {
                        const imageUrl = container.dataset.image360;
                        console.log('🔄 Inicializando con URL:', imageUrl);

                        // Gestionar backdrops para modales anidados
                        const allBackdrops = document.querySelectorAll('.modal-backdrop');
                        const isInsideModal = document.querySelector('.modal.show') !== null;

                        console.log('🔄 Backdrops encontrados:', allBackdrops.length);
                        console.log('🔄 ¿Está dentro de otro modal?', isInsideModal);

                        if (isInsideModal && allBackdrops.length > 1) {
                            console.log('🔄 Ajustando backdrops para modales anidados');
                            allBackdrops.forEach((backdrop, index) => {
                                console.log(`🔄 Backdrop ${index}:`, backdrop);
                                if (index > 0) {
                                    // Ocultar backdrops adicionales
                                    backdrop.style.display = 'none';
                                    console.log(`🔄 Backdrop ${index} ocultado`);
                                } else {
                                    // Primer backdrop: ponerlo por detrás del modal 360 pero sin opacidad
                                    backdrop.style.zIndex = '9998';
                                    backdrop.style.opacity = '0';
                                    backdrop.style.pointerEvents = 'none';
                                    console.log(`🔄 Backdrop ${index} z-index ajustado a 9998 sin opacidad`);
                                }
                            });
                        } else if (allBackdrops.length > 0) {
                            // Si solo hay un backdrop, asegurar que no interfiera
                            console.log('🔄 Ajustando backdrop único');
                            allBackdrops.forEach((backdrop, index) => {
                                backdrop.style.zIndex = '9998';
                                // Permitir clics a través del backdrop del modal 360
                                backdrop.style.pointerEvents = 'none';
                                // Quitar la opacidad para que no se vea oscuro
                                backdrop.style.opacity = '0';
                                console.log(`🔄 Backdrop ${index} configurado sin opacidad y sin interceptar clics`);
                            });
                        }

                        // Asegurar que el modal 360 esté por encima y sea interactivo
                        modal.style.zIndex = '9999';
                        modal.style.pointerEvents = 'auto';

                        // Asegurar que el container del viewer sea interactivo
                        setTimeout(() => {
                            if (container) {
                                container.style.pointerEvents = 'auto';
                                container.style.position = 'relative';
                                container.style.zIndex = '10000';
                                console.log('🔄 Container configurado para ser interactivo');
                            }
                        }, 100);

                        modal.style.zIndex = '9999';

                        if (imageUrl && imageUrl !== '') {
                            try {
                                window.viewer360 = new window.PhotoSphereViewer.Viewer({
                                    container,
                                    panorama: imageUrl,
                                    navbar: ['zoom', 'fullscreen'],
                                    loadingImg: '/images/loading.gif',
                                });
                                console.log('� ✅ PhotoSphereViewer creado exitosamente');
                            } catch (error) {
                                console.error('🔄 ❌ Error al crear PhotoSphereViewer:', error);
                            }
                        }
                        container.dataset.loaded = true;
                    }

                    // Mostrar instrucciones
                    console.log('🔄 Buscando y mostrando instrucciones...');
                    const instructionModalShow = modal.querySelector('#viewerInstruction');
                    console.log('🔄 InstructionModal encontrado:', instructionModalShow);
                    if (instructionModalShow) {
                        console.log('🔄 Clases antes de mostrar:', instructionModalShow.classList.toString());
                        instructionModalShow.classList.remove('d-none');
                        instructionModalShow.style.display = 'block';
                        instructionModalShow.style.zIndex = '10001';
                        instructionModalShow.style.position = 'absolute';
                        console.log('🔄 Instrucciones mostradas, clases después:', instructionModalShow.classList.toString());
                        console.log('🔄 Display style:', instructionModalShow.style.display);
                    }

                    // Verificar botón de cerrar
                    const closeButton = modal.querySelector('.close-viewer');
                    console.log('🔄 Botón de cerrar encontrado:', closeButton);
                    if (closeButton) {
                        closeButton.style.display = 'block';
                        closeButton.style.zIndex = '10001';
                        closeButton.style.position = 'absolute';
                        console.log('🔄 Botón de cerrar configurado');
                    }
                });

                // Limpiar al cerrar el modal
                modal.addEventListener('hidden.bs.modal', () => {
                    console.log('🔄 Cerrando modal 360, restaurando backdrops');
                    const allBackdrops = document.querySelectorAll('.modal-backdrop');
                    allBackdrops.forEach((backdrop, index) => {
                        console.log(`🔄 Restaurando backdrop ${index}`);
                        backdrop.style.display = '';
                        backdrop.style.zIndex = '';
                        backdrop.style.pointerEvents = '';
                        backdrop.style.opacity = '';
                    });

                    if (window.viewer360) {
                        console.log('🔄 Destruyendo PhotoSphereViewer');
                        window.viewer360.destroy();
                        window.viewer360 = null;
                        const container = document.getElementById('viewer360');
                        if (container) {
                            container.dataset.loaded = false;
                            container.style.pointerEvents = '';
                            container.style.position = '';
                            container.style.zIndex = '';
                        }
                    }
                });

                // Botón para cerrar el visor
                const closeButton = modal.querySelector('.close-viewer');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        bootstrapModal.hide();
                    });
                }

                viewerContainer.dataset.configured = true;
                console.log('🔄 ✅ Viewer360 configurado correctamente');
            }
        });
    }

    // Ejecutar al cargar la página
    setupPhotoSphereViewer();

    // Ejecutar cuando se añada contenido dinámico
    const observer = new MutationObserver((mutations) => {
        let hasNewContent = false;
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.querySelector && node.querySelector('#viewer360')) {
                        hasNewContent = true;
                    }
                }
            });
        });

        if (hasNewContent) {
            console.log('🔄 Contenido dinámico detectado, reconfigurándo viewers...');
            setTimeout(() => {
                setupPhotoSphereViewer();
            }, 200);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });



    const resetButton = document.querySelector('.js-reestablecer');

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            document.querySelectorAll('input:not([type="checkbox"]):not([type="hidden"])').forEach(input => {
                input.value = '';
            });

            // Desmarcar todos los checkboxes excepto los de name="sites[]" que tienen que marcarse todos para quedarse como estaban al cargar la página
            document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                if (checkbox.name !== 'sites[]') {
                    checkbox.checked = false;
                } else {
                    checkbox.checked = true;
                }
            });

            // Limpiar fechas del calendario v3
            $("#desde").val("");
            $("#hasta").val("");
            $("#dateRangeDisplay").val("");
            dateRangeV3.startDate = null;
            dateRangeV3.endDate = null;
            dateRangeV3.isSelecting = false;
            $("#dateRangeCalendar").hide();
            $("#dateRangeCalendar").parent().removeClass("active");


            // Recargar la página
            location.reload();
        });
    }

    //filtro para qué ver y qué hacer (filtros planes y eventos)
    function initializeFilterButtons() {
        const filterButtonsContainer = document.querySelector('#filter-buttons');
        const items = document.querySelectorAll('.js-itemfilter');
        
        if (filterButtonsContainer && items.length > 0) {
            // Buscar botones dentro del contenedor (funciona con swiper)
            const buttons = filterButtonsContainer.querySelectorAll('button');

            buttons.forEach(button => {
                button.addEventListener('click', function () {
                    const selectedId = this.getAttribute('data-filter');
                    
                    // Actualizar clase active en botones
                    buttons.forEach(btn => btn.classList.remove('active'));
                    this.classList.add('active');
                    
                    // Filtrar items - mostrar/ocultar CADA ITEM individualmente
                    items.forEach(item => {
                        const filterAttr = item.getAttribute('data-filterevent');

                        // Si no hay filtro definido
                        if (!filterAttr || filterAttr.trim() === '') {
                            item.style.display = selectedId === 'all' ? '' : 'none';
                            return;
                        }

                        const itemFilters = filterAttr.split(',').map(id => id.trim());

                        // Mostrar si coincide el filtro o si es "todos"
                        if (selectedId === 'all' || itemFilters.includes(String(selectedId))) {
                            item.style.display = '';
                        } else {
                            item.style.display = 'none';
                        }
                    });
                    
                    // Ajustar visibilidad de eventos de relleno en Manresa después del filtrado
                    adjustManresaFillerEvents();
                });
            });
        }
    }

    const searchInput = document.getElementById("search-input");

    if (searchInput) {
        searchInput.addEventListener("keyup", function () {
            let query = this.value.trim().toLowerCase();  // Convertir búsqueda a minúsculas

            // Obtener todas las tarjetas
            let cards = document.querySelectorAll(".card-item");

            // Iterar sobre todas las tarjetas
            cards.forEach(card => {
                let cardName = card.getAttribute("data-name"); // Obtener el nombre de la tarjeta en minúsculas
                if (cardName.includes(query)) {
                    card.style.display = "block"; // Mostrar tarjeta
                } else {
                    card.style.display = "none"; // Ocultar tarjeta
                }
            });
        });
    }

    const selectAllButton = document.querySelector(".js-todaszonas");

    if (selectAllButton) {
        // Marcar el checkbox por defecto
        selectAllButton.checked = true;

        // Añadir el evento click al botón
        selectAllButton.addEventListener("click", function () {
            // Seleccionar todos los checkboxes que tengan el atributo name="sites[]"
            const checkboxes = document.querySelectorAll(
                'input[name="sites[]"]'
            );

            // Marcar todos los checkboxes
            checkboxes.forEach((checkbox) => {
                checkbox.checked = true;
            });
        });

        // Disparar el evento click para que se ejecute la lógica al cargar
        selectAllButton.dispatchEvent(new Event("click"));

    }

    if (!document.getElementById("custom-itinerary")) {
        console.log("No custom-itinerary found");
        return;
    }
    console.log("DOMContentLoaded (itinerary_new in public.js)");

    // log all cookies
    // console.log("cookie", document.cookie);

    const dataContainer = document.getElementById("data-container");
    const textDataItinerary = dataContainer.getAttribute("data-itinerary");
    const textDataDay = dataContainer.getAttribute("data-day");

    // if the route is /plan-personalizado/editar/...
    if (
        window.location.pathname.includes("/plan-personalizado") &&
        !window.location.pathname.includes("/editar")
    ) {
        console.log("the route is /plan-personalizado/...");
        // if new_itinerary is in the localStorage, we will use it
        if (localStorage.getItem("new_itinerary")) {
            console.log("new_itinerary is in the localStorage");

            itinerary = JSON.parse(localStorage.getItem("new_itinerary"));
            console.log("using the data from local storage", itinerary);

            document
                .querySelector(".itinerary-day-link")
                .addEventListener("click", function (e) {
                    console.log("itinerary-day-link click");
                    e.preventDefault();
                    window.location.href = this.href;
                });
        } else {
            itinerary = JSON.parse(textDataItinerary);
            console.log("using the data from php", itinerary);
            document
                .querySelector(".itinerary-day-link")
                .addEventListener("click", function (e) {
                    console.log("itinerary-day-link click");
                    e.preventDefault();
                    saveItinerary();
                    window.location.href = this.href;
                });

            // add new_itinerary to the localStorage
            localStorage.setItem("new_itinerary", JSON.stringify(itinerary));
        }
    } else if (
        window.location.pathname.includes("/plan-personalizado/editar")
    ) {
        console.log("the route is /plan-personalizado/editar/...");
        console.log("forcing the data from php");
        itinerary = JSON.parse(textDataItinerary);
        console.log("itinerary", itinerary);
    }

    day = JSON.parse(textDataDay);
    console.log("day", day);

    dayIndex = day - 1;

    if (!itinerary) {
        console.error("No itinerary found");
        return;
    }
    if (dayIndex === undefined) {
        console.error("No dayIndex found");
        return;
    }

    itineraryManager = new ItineraryManager(itinerary, dayIndex);

    // if we are in mobile, we will not enable drag and drop
    if (window.innerWidth < 768) {
        console.log("mobile");
        document.getElementById("toggleDragDrop").style.display = "none";
    } else {
        dragManager = new DragManager();
    }
    itineraryManager.renderItineraryItems();

    // remove the data-container
    dataContainer.remove();

    document
        .querySelector("#toggleDragDrop")
        .addEventListener("click", function () {
            console.log("toggleDragDrop");
            dragManager.toggleListDragAndDrop();

            this.classList.toggle("off");
        });

    document
        .querySelector("#dismiss-addEvent")
        .addEventListener("click", function () {
            $("body").removeClass("noscroll");
            console.log("dismissAddEvent");
            document.getElementById("wrapper-addEvent").style.visibility =
                "hidden";
            document.getElementById("wrapper-addEvent").style.opacity = 0;
            document.getElementById("wrapper-addEvent").style.transform =
                "translateX(100%)";
        });

    document
        .querySelector("#confirm-addEvent")
        .addEventListener("click", function (e) {
            $("body").removeClass("noscroll");
            console.log("confirmAddEvent");
            document.getElementById("wrapper-addEvent").style.visibility =
                "hidden";
            document.getElementById("wrapper-addEvent").style.opacity = 0;
            document.getElementById("wrapper-addEvent").style.transform =
                "translateX(100%)";

            itineraryManager.handleClickConfirmAddEvent(e);
        });

    document.querySelectorAll(".itinerary-day-link").forEach((link) => {
        link.addEventListener("click", function (e) {
            console.log("itinerary-day-link click");
            e.preventDefault();
            // add new_itinerary to the localStorage
            localStorage.setItem(
                "new_itinerary",
                JSON.stringify(itineraryManager.itinerary)
            );
            window.location.href = this.href;
        });
    });

    // Este listener envía un objeto formateado para la api tal como estaba programada
    //Pero es un desastre, el objeto que me veo obligado a crear tiene demasiados niveles innecesarios
    //Revisar si se puede cambiar la api para que reciba un objeto más sencillo, por ejemplo tal como itineraryManager.itinerary

    //Revisado: al final este es el único lugar en el que se usa este endpoint así que queda pendiente dejarlo estable
    let new_itinerary_confirmSave = $("#modalSaveCustomItinerary").find(
        "#btguardarplan"
    );

    let form_itinerary = document.getElementById("formUserPlan");

    console.log("new_itinerary_confirmSave", new_itinerary_confirmSave);
    // on submit, preventDefault and click the new_itinerary_confirmSave
    form_itinerary.addEventListener("submit", function (e) {
        console.log("form_itinerary submit");
        e.preventDefault();
        new_itinerary_confirmSave[0].click();
    });

    new_itinerary_confirmSave.on("click", function (e) {
        saveItinerary();
    });
});

function sortDomEventsAsItinerary() {
    console.log("sortDomEventsAsItinerary");

    let morningEvents = document.querySelectorAll(".morning .event");
    let afternoonEvents = document.querySelectorAll(".afternoon .event");

    let morningEventsArray = Array.from(morningEvents);
    let afternoonEventsArray = Array.from(afternoonEvents);

    console.log("day Index", dayIndex);
    console.log("itineraryManager.itinerary", itineraryManager.itinerary);

    // we want to sort them using their data-index attribute
    // we will use itineraryManager.itinerary to get the order
    let morningEventsRef =
        itineraryManager.itinerary.days[dayIndex + 1]?.[0]?.["events"] ?? [];
    let afternoonEventsRef =
        itineraryManager.itinerary.days[dayIndex + 1]?.[1]?.["events"] ?? [];
    console.log("morningEventsRef", morningEventsRef);
    console.log("afternoonEventsRef", afternoonEventsRef);

    let morningEventsSorted = [];
    let afternoonEventsSorted = [];

    morningEventsRef.forEach((event) => {
        let index = event.index;
        console.log("index", index);

        let eventEl = morningEventsArray.find((el) => {
            return (
                parseInt(
                    el.querySelector(".number").getAttribute("data-index")
                ) === index
            );
        });
        console.log("eventEl", eventEl);
        morningEventsSorted.push(eventEl);
    });

    afternoonEventsRef.forEach((event) => {
        let index = event.index;
        console.log("index", index);

        let eventEl = afternoonEventsArray.find((el) => {
            return (
                parseInt(
                    el.querySelector(".number").getAttribute("data-index")
                ) === index
            );
        });
        console.log("eventEl", eventEl);
        afternoonEventsSorted.push(eventEl);
    });

    console.log("morningEventsSorted", morningEventsSorted);
    console.log("afternoonEventsSorted", afternoonEventsSorted);

    let morning = document.querySelector(".morning");
    let afternoon = document.querySelector(".afternoon");

    console.log("morning", morning);
    console.log("afternoon", afternoon);


    morningEventsSorted.forEach((event) => {
        morning.appendChild(event);
    });

    afternoonEventsSorted.forEach((event) => {
        afternoon.appendChild(event);
    });
}

function refreshSiteHeaders() {
    const reduceHeaders = (period) => {
        // console.log("reduceHeaders");

        let events = period.querySelectorAll(".event");

        let currentPlace = null;
        events.forEach((event) => {
            let place = event.querySelector(".place").textContent;
            // console.log("Thnking about removing header for", place);

            if (place === currentPlace) {
                // console.log("removing header for", place);
                // select the closest headerItinerayList
                let header = event.querySelector(".headerItinerayList");
                // console.log("header", header);
                header.style.display = "none";
            } else {
                // console.log("showing header for", place);
                let header = event.querySelector(".headerItinerayList");
                // console.log("header", header);
                header.style.display = "flex";
                currentPlace = place;
            }
        });

        // add dispplay:none to all .time elements that are not the first one
        let times = period.querySelectorAll(".headerItinerayList .time");
        // console.log("erasing times", times);
        times.forEach((time, index) => {
            if (index > 0) {
                time.style.display = "none";
            }
        });
    };

    console.log("refreshSiteHeaders");
    // We will do the following in the morning and afternoon divs
    let morning = document.querySelector(".morning");
    let afternoon = document.querySelector(".afternoon");

    reduceHeaders(morning);
    reduceHeaders(afternoon);
}

function refreshActivityNumbers() {
    console.log("refreshActivityNumbers2");
    // we are going to get all .event elements and change the inner-html of their children element .number-me to the index of the event +1
    console.log("events: ");
    let events = document.querySelectorAll("#itineraryList .event");

    events.forEach((event, index) => {
        console.log("index: ", index);
        console.log("event: ", event);
        let number = event.querySelector(".number");
        number.innerHTML = index + 1;
        number.setAttribute("data-index", index);
    });
}

function saveItinerary() {
    // console.log("saveItinerary");

    // console.log("itinerary", itineraryManager.itinerary);

    let errors = [];
    let nombre_plan = $("#nombre_plan").val();
    let plancreado_id = $("#plancreado_id").val();
    let isEditing = plancreado_id && plancreado_id !== "";

    if (!nombre_plan) {
        // console.log("nombre_plan is missing", nombre_plan);
        errors.push($("#nombre_plan").attr("data-error"));
    }

    if (errors.length == 0) {
        const formElement = $("#formUserPlan");
        const formData = new FormData(formElement[0]);
        
        let endpoint, data;
        
        if (isEditing) {
            // Modo edición - usar endpoint /plans/edit
            // console.log("Mode: EDIT - plan_id:", plancreado_id);
            // console.log("itineraryManager.itinerary:", itineraryManager.itinerary);
            // console.log("Days keys:", Object.keys(itineraryManager.itinerary.days));
            
            // Construir el array de días con sus actividades
            let days = [];
            
            // Usar directamente los días del itinerario, en el orden que existen
            Object.keys(itineraryManager.itinerary.days).forEach(dayKey => {
                // console.log("Processing dayKey:", dayKey);
                let dayData = itineraryManager.itinerary.days[dayKey];
                // console.log("dayData:", dayData);
                // console.log("dayData[0]:", dayData[0]);
                // console.log("dayData[1]:", dayData[1]);
                
                let morning_activities = [];
                let afternoon_activities = [];
                
                // Obtener eventos de la mañana (periodo 0)
                if (dayData[0] && dayData[0].events && dayData[0].events.length > 0) {
                    // console.log("Morning events found:", dayData[0].events.length);
                    morning_activities = dayData[0].events.map(event => ({ id: event.id }));
                }
                
                // Obtener eventos de la tarde (periodo 1)
                if (dayData[1] && dayData[1].events && dayData[1].events.length > 0) {
                    // console.log("Afternoon events found:", dayData[1].events.length);
                    afternoon_activities = dayData[1].events.map(event => ({ id: event.id }));
                }
                
                // El número de día es la clave (puede ser 0, 1, 2, 3... o 1, 2, 3...)
                let dayNum = parseInt(dayKey);
                // console.log("Pushing day:", dayNum, "morning:", morning_activities.length, "afternoon:", afternoon_activities.length);
                
                days.push({
                    day: dayNum,
                    morning_activities: morning_activities,
                    afternoon_activities: afternoon_activities
                });
            });
            
            data = {
                plan_id: parseInt(plancreado_id),
                name: nombre_plan,
                number_days: Object.keys(itineraryManager.itinerary.days).length,
                days: days
            };
            endpoint = "/plans/edit";
            
            // console.log("=== EDIT MODE - SENDING NAME ===");
            // console.log("nombre_plan from input:", nombre_plan);
            // console.log("Data object to send:", data);
        } else {
            // Modo creación - usar endpoint /plans/save
            // console.log("Mode: CREATE");
            
            data = {
                name: formData.get("nombre_plan"),
                id: formData.get("plan_id"),
                number_days: formData.get("number_days"),
                start_date: itineraryManager.itinerary.desde,
                itinerary: itineraryManager.itinerary,
            };
            endpoint = "/plans/save";
        }

        // console.log("data to save: ", data);

        $.ajax({
            method: "POST",
            url: endpoint,
            contentType: "application/json",
            data: JSON.stringify(data),
            success: function (response) {
                if (response.status === "ok") {
                    // console.log("response", response);
                    // console.log(".itinerarySaveOK", $(".itinerarySaveOK"));
                    let confirmSaveModal = $("#modalConfirmSaveCustomItinerary");
                    
                    // Obtener el nombre del plan (para CREATE viene en data.name, para EDIT lo sacamos del input)
                    let planName = isEditing ? $("#nombre_plan").val() : data.name;

                    if (confirmSaveModal.length && !isEditing) {
                        // console.log("mostrar mensaje OK (MODAL)");
                        // open the modal sólo para creaciones
                        $(".itinerarySaveOK").removeClass("d-none");
                        $(".js-avisoGuardarPlan").addClass("d-none");
                        $("#modalSaveCustomItinerary .btn-close")[0].click();
                        let namePlaceholder = confirmSaveModal.find(".plan-name");
                        namePlaceholder.text(planName);

                        let modalConfirmSaveCustomItinerary =
                            new bootstrap.Modal(
                                document.getElementById(
                                    "modalConfirmSaveCustomItinerary"
                                )
                            );
                        modalConfirmSaveCustomItinerary.show();
                    } else {
                        // console.log("mostrar mensaje OK (ALERTA)");
                        $(".itinerarySaveOK").removeClass("d-none");
                        $(".js-avisoGuardarPlan").addClass("d-none");
                        $("#modalSaveCustomItinerary .btn-close")[0].click();
                        
                        // Para edición, mostrar alerta de éxito
                        if (isEditing) {
                            // console.log("Plan actualizado correctamente");
                            // Mostrar alerta simple sin dependencias externas
                            alert('Tu plan se ha actualizado correctamente');
                        }
                    }

                    // Actualizar el enlace de descarga si es creación (cuando se devuelve plan_id)
                    if (response.plan_id) {
                        updateDownloadLink(response.plan_id);
                    }
                } else {
                    alert(response.message);
                }
            },
            error: function (xhr) {
                // Maneja la respuesta de error del servidor
                // console.error("AJAX Error Response:", xhr);
                // console.error("Response JSON:", xhr.responseJSON);
                
                let errorMessage = "Error al guardar el itinerario";
                
                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    let errors = xhr.responseJSON.errors;
                    // console.log("Validation errors:", errors);
                    errorMessage = "Errores de validación:\n" + Object.entries(errors).map(([key, value]) => key + ": " + value).join("\n");
                } else if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                }
                
                alert(errorMessage);
            },
        });

        // console.log("data", data);
    } else {
        // console.log("errors", errors);
    }
}

function updateDownloadLink(planId) {
    // console.log("updateDownloadLink");

    //#disabled-download
    let downloadLink = document.getElementById("disabled-download");
    // console.log("downloadLink", downloadLink);
    // remove all event listeners
    let newDownloadLink = downloadLink.cloneNode(true);
    downloadLink.parentNode.replaceChild(newDownloadLink, downloadLink);
    downloadLink = newDownloadLink;

    // remove class disabled
    // opacity 1
    downloadLink.style.opacity = 1;

    //href /generate-pdf/{{ $item['id'] }}/custom
    let url = `/generate-pdf/${planId}/custom`;
    downloadLink.setAttribute("href", url);

    // add event listener
}

function updateRestaurants(tempItinerary) {
    // console.log("updateRestaurants");
    // https://www.google.es/maps/search/Restaurantes/@<?php echo $lastLatitude; ?>,{{ $lastLontitude }}z

    let restaurantLink = document.querySelector(".pauseTimeItinerayList");
    
    // Si es Ponferrada, usar la URL de sección personalizada
    if (restaurantLink && restaurantLink.getAttribute("data-theme") === "ponferrada") {
        // console.log("Ponferrada detectado, usando URL de sección personalizada");
        let sectionUrl = restaurantLink.getAttribute("data-section-url");
        restaurantLink.setAttribute("href", sectionUrl);
        return;
    }
    
    let events = tempItinerary.days[dayIndex + 1][0]["events"];
    if (
        events.length === 0 ||
        !events[events.length - 1].site.latitude ||
        !events[events.length - 1].site.longitude
    ) {
        // console.log("No se pudo obtener latitude o longitude");
        return; // Sale de la función si no hay datos válidos
    }

    let lastLatitude = events[events.length - 1].site.latitude;
    let lastLongitude = events[events.length - 1].site.longitude;
    // console.log("lastLatitude", lastLatitude);
    // console.log("lastLongitude", lastLongitude);

    let url = `https://www.google.es/maps/search/Restaurantes+/@${lastLatitude},${lastLongitude},15z`;
    
    restaurantLink.setAttribute("href", url);
}

class ItineraryManager {
    constructor(itinerary, dayIndex) {
        this.itinerary = itinerary;
        this.dayIndex = dayIndex;
        this.targetAddEvent = null;
        this.activeRecommendedItems = [];
    }

    deleteEventv2 = (e) => {
        console.group("🗑️ deleteEventv2");
        e.preventDefault();
        // debugger;

        if (
            e.target
                .closest(".js-deleteevent-v2")
                .getAttribute("data-confirmado") == "false"
        ) {
            let idBtnDelete = e.target
                .closest(".event")
                .getAttribute("data-id");

            console.log(idBtnDelete);

            $("#modalDeleteEventPlan .js-deleteEventPlanConfirm").attr(
                "data-id",
                idBtnDelete
            );

            modalDeleteEventPlan.show();
        } else {
            let event = e.target.closest(".event");
            let id = event.getAttribute("data-id");

            let found = false;

            found = this.findEventById(id);
            if (!found) {
                console.error(
                    "%cEvent not found in itinerary",
                    "color: red; font-weight: bold;"
                );
            }

            // también lo podríamos sacar de found
            let eventPlaceId = event.getAttribute("data-placeid");
            console.log("eventPlaceId", eventPlaceId);
            let eventDuration = found.duration;

            let addEventTemplate =
                document.getElementById("add-event-template").innerHTML;
            let addEventElement = document.createElement("div");
            addEventElement.innerHTML = addEventTemplate;

            event.parentElement.insertBefore(addEventElement, event);

            addEventElement
                .querySelector(".js-addEvent")
                .addEventListener(
                    "click",
                    itineraryManager.handleClickAnadirEvento
                );

            addEventElement
                .querySelector(".js-addEvent")
                .setAttribute("data-placeid", eventPlaceId);
            addEventElement
                .querySelector(".js-addEvent")
                .setAttribute("data-duration", eventDuration);

            event.remove();
            // delete found from this.itinerary
            let deleteResult = this.deleteEventFromItineraryById(id);
            this.itinerary = deleteResult.itinerary;
            
            // Guardar el índice exacto en el botón para usar luego
            addEventElement
                .querySelector(".js-addEvent")
                .setAttribute("data-insertion-index", deleteResult.foundIndex);
            addEventElement
                .querySelector(".js-addEvent")
                .setAttribute("data-insertion-period", deleteResult.foundPeriod);
            
            console.log("Event deleted at index:", deleteResult.foundIndex, "period:", deleteResult.foundPeriod);
            window.refreshMap();

            console.groupEnd();
        }
    };

    deleteEventFromItineraryById = (id) => {
        console.group("deleteEventFromItineraryById");
        console.log("Deleting event with ID:", id);
        let newItinerary = JSON.parse(JSON.stringify(this.itinerary));
        let found = false;
        let dayIndex = this.dayIndex + 1;
        let morningEvents = newItinerary.days[dayIndex][0].events;
        let afternoonEvents = newItinerary.days[dayIndex][1].events;

        let foundIndex = -1;
        let foundPeriod = null;

        found = morningEvents.find((event, index) => {
            if (event.id == id) {
                foundIndex = index;
                foundPeriod = "morning";
                return true;
            }
        });

        if (found) {
            console.log("Found in morning events at index:", foundIndex);
            morningEvents.splice(foundIndex, 1);
        } else {
            found = afternoonEvents.find((event, index) => {
                if (event.id == id) {
                    foundIndex = index;
                    foundPeriod = "afternoon";
                    return true;
                }
            });
            if (found) {
                console.log("Found in afternoon events at index:", foundIndex);
                afternoonEvents.splice(foundIndex, 1);
            } else {
                console.error("Event not found in itinerary");
            }
        }

        console.log("Updated Itinerary:", newItinerary);
        console.groupEnd();

        return { itinerary: newItinerary, foundIndex: foundIndex, foundPeriod: foundPeriod };
    };

    getItemView = async (item, editMode, selectMode = false) => {
        console.log("getItemView");
        console.log("item", item);

        return fetch("/api/plans/get-itinerary-item-partial", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                item: item,
                editMode: editMode,
                selectMode: selectMode,
            }),
        })
            .then((response) => response.text())
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    getItemModal = async (item) => {
        return fetch("/api/plans/get-itinerary-item-modal", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                item: item,
            }),
        })
            .then((response) => response.text())
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    renderItineraryTiming = () => {
        // get an
    };

    renderItineraryItems = (day = this.dayIndex + 1) => {
        console.group("🔄 renderItineraryItems");
        console.log(day + ">>" + this.dayIndex);
        console.log(this.itinerary);
        var stop = this.itinerary.stop;

        updateRestaurants(this.itinerary);

        let newItinerary = JSON.parse(JSON.stringify(this.itinerary));

        let eventsMorning;
        try {
            eventsMorning = newItinerary.days[day]?.[0]?.events ?? [];
        } catch (e) {
            console.error("Error getting eventsMorning", e);
        }

        let eventsAfternoon;
        try {
            eventsAfternoon = newItinerary.days[day]?.[1]?.events ?? [];
        } catch (e) {
            console.error("Error getting eventsAfternoon", e);
        }

        let eventTemplate = document.getElementById("event-template").innerHTML;

        let allEvents = [];
        if (eventsMorning) {
            allEvents.push(eventsMorning);
        }
        if (eventsAfternoon) {
            allEvents.push(eventsAfternoon);
        }

        console.log("Pushed events to allEvents", allEvents);

        // clear the morning and afternoon divs
        document.querySelector(".morning").innerHTML = "";
        document.querySelector(".afternoon").innerHTML = "";

        // remove the modEventPanel
        // document.querySelectorAll(".modEventPanel").forEach((panel) => {
        //     panel.remove();
        // });

        let renderPromises = [];

        for (let i = 0; i < allEvents.length; i++) {
            let periodEvents = allEvents[i];
            periodEvents.forEach((event, eventIndexInPeriod) => {
                //console.log(event);
                let itemViewPromise = this.getItemView(event, false).then(
                    (view) => {
                        let item = eventTemplate.replace("<%id>", event.id);
                        item = item.replace(
                            "<%siteName>",
                            event.site.name ? event.site.name : "??"
                        );
                        item = item.replaceAll(
                            "<%siteId>",
                            event.site.id ? event.site.id : "??"
                        );
                        item = item.replaceAll(
                            "<%linkModal>",
                            event.site.linkmodal ? event.site.linkmodal : "??"
                        );
                        item = item.replaceAll(
                            "<%siteSlug>",
                            event.site.urlseo ? event.site.urlseo : "??"
                        );
                        /*item = item.replace(
                            "<%timePeriod>",
                            i === 0 ? "Mañana" : "Tarde"
                        );*/
                        item = item.replace(
                            "<%timePeriod>",
                            i === 0 ? window._arrTraducciones.txt_mañana : window._arrTraducciones.txt_tarde
                        );
                        item = item.replace(
                            "<%timeRange>",
                            i === 0 ? "9:00 - 16:00" : "16:00 - 21:00"
                        );
                        item = item.replace(
                            "<%weatherIcon>",
                            event.weather_icon ? event.weather_icon : ""
                        );
                        item = item.replace(
                            "<%weather>",
                            event.weather ? event.weather : "??"
                        );
                        item = item.replace(
                            "<%walkingIcon>",
                            event.walking_icon ? event.walking_icon : "??"
                        );
                        item = item.replace(
                            "<%walkingTime>",
                            event.walking_time ? event.walking_time : "??"
                        );
                        item = item.replace("<%itineraryItemList>", view);

                        let eventElement = document.createElement("div");
                        eventElement.innerHTML = item;
                        eventElement = eventElement.firstElementChild;

                        console.log("eventElement", eventElement);

                        switch (i) {
                            case 0:
                                // we have to place the event in the correct position at the morning div
                                // the correct position is the eventIndexInPeriod
                                // we dont know if other events have been rendered yet
                                // so we have to check if the eventIndexInPeriod is greater than the number of events already rendered
                                let morningEvents = document.querySelectorAll(".morning .event");

                                if (eventIndexInPeriod < morningEvents.length) {
                                    document
                                        .querySelector(".morning")
                                        .insertBefore(
                                            eventElement,
                                            morningEvents[eventIndexInPeriod]
                                        );
                                    console.log("insertBefore");
                                } else {
                                    document
                                        .querySelector(".morning")
                                        .appendChild(eventElement);
                                }
                                break;
                            case 1:
                                // we have to place the event in the correct position at the afternoon div
                                // the correct position is the eventIndexInPeriod

                                // we dont know if other events have been rendered yet
                                // so we have to check if the eventIndexInPeriod is greater than the number of events already rendered

                                // if it is, we have to append the event to the end of the afternoon div
                                let afternoonEvents =
                                    document.querySelectorAll(".afternoon .event");
                                if (
                                    eventIndexInPeriod < afternoonEvents.length
                                ) {
                                    document
                                        .querySelector(".afternoon")
                                        .insertBefore(
                                            eventElement,
                                            afternoonEvents[eventIndexInPeriod]
                                        );
                                    console.log("insertBefore");
                                } else {
                                    document
                                        .querySelector(".afternoon")
                                        .appendChild(eventElement);
                                }
                                break;
                            default:
                                console.error("Event not found in itinerary");
                                break;
                        }
                        try {
                            eventElement
                                .querySelector(".js-deleteevent-v2")
                                .addEventListener("click", (e) =>
                                    this.deleteEventv2(e)
                                );
                        } catch (e) { }

                        let more_info = eventElement.querySelector(
                            ".js-loadActivityPanel"
                        );
                        if (more_info) {
                            more_info.addEventListener("click", (e) =>
                                this.loadActivtyPanel(e)
                            );
                        }
                    }
                );

                renderPromises.push(itemViewPromise);

                let modalPromise = this.getItemModal(event).then((data) => {
                    console.log("Got item modal for event ID:", event.id);
                    let modalElement = document.createElement("div");
                    let id = "modal-" + event.id;
                    let closeModal = document.createElement("a");
                    closeModal.innerHTML = "+";
                    closeModal.classList.add("js-closePanel", "closePanel");
                    closeModal.addEventListener("click", (e) => this.closePanel(e));

                    modalElement.classList.add("modEventPanel");
                    modalElement.classList.add("hide");
                    modalElement.id = id;
                    modalElement.innerHTML = data;
                    document.body.appendChild(modalElement);

                    modalElement.insertBefore(
                        closeModal,
                        modalElement.firstChild
                    );

                    let addToPlanButton =
                        modalElement.querySelector(".btnaction");

                    if (!addToPlanButton) {
                        console.warn("No addToPlanButton found in modal for event ID:", event.id);
                        return;
                    }

                    addToPlanButton.remove();
                });

                renderPromises.push(modalPromise);
            });
        }

        console.log("Waiting for all events to be rendered...");

        Promise.all(renderPromises).then(() => {
            // sort the event elements such as in the itinerary object, as we may have changed the order of the events
            // debugger;
            sortDomEventsAsItinerary();
            // debugger;
            refreshSiteHeaders();
            refreshActivityNumbers();
            itineraryManager.renderPlaceModals();

            if (itinerary.stop) {
                setTimeout(() => {
                    // debugger;
                    insertStopMsg();
                }, 500); // Ajusta el tiempo si es necesario
            }

            setTimeout(() => {
                window.initClicksPanels();
            }, 1500);
        });

        setTimeout(function () {
            window.initClicksPanels();
        }, 1500);

        console.groupEnd();
    };

    // Los eventos vienen de php con una propiedad redundante, day_period, que indica si es de mañana o tarde
    // Esta información también está en la propia estructura del objeto itinerary.days[day] que es un array de 2 elementos, 0 para mañana y 1 para tarde
    // Yo he programado todo en base a la estructura del array, así que uso esta función para actualizar la propiedad day_period de los eventos según la estructura del objeto itinerary
    refreshEventsPeriods = (tempItinerary) => {
        let morningEvents = tempItinerary.days[this.dayIndex + 1][0].events;
        let afternoonEvents = tempItinerary.days[this.dayIndex + 1][1].events;

        morningEvents.forEach((event) => {
            event.day_period = "morning";
        });

        afternoonEvents.forEach((event) => {
            event.day_period = "afternoon";
        });

        return tempItinerary;
    };

    // Esta funcion reorganiza el objeto itinerary según el orden de los eventos en el DOM
    //	se usa en el drag and drop
    updateEventsOrder = () => {
        console.group("🔄 updateEventsOrder");

        let newItinerary = JSON.parse(JSON.stringify(this.itinerary));
        console.log("Current Itinerary:", newItinerary);

        let domOrder = this.getDomEventsOrder();
        console.log("DOM Order:", domOrder);

        let currentEvents = [
            ...newItinerary.days[dayIndex + 1][0].events,
            ...newItinerary.days[dayIndex + 1][1].events,
        ];
        console.log("Current Events:", currentEvents);

        newItinerary.days[dayIndex + 1][0].events = [];
        newItinerary.days[dayIndex + 1][1].events = [];

        const updateEvents = (ids, period) => {
            ids.forEach((id) => {
                let found = currentEvents.find((event) => event.id == id);
                if (found) {
                    found.day_period = period;
                    newItinerary.days[dayIndex + 1][
                        period === "morning" ? 0 : 1
                    ].events.push(found);
                } else {
                    console.error("Item not found in activeRecommendedItems");
                }
            });
            return newItinerary;
        };

        console.log("updating morning events");
        newItinerary = updateEvents(domOrder.morning, "morning");
        console.log("updating afternoon events");
        newItinerary = updateEvents(domOrder.afternoon, "afternoon");

        console.groupEnd();

        return newItinerary;
    };

    getDomEventsOrder = () => {
        console.group("🔍 getDomEventsOrder");
        let itineraryList = document.getElementById("itineraryList");
        let events = itineraryList.querySelectorAll(".event");
        let morning = [];
        let afternoon = [];

        events.forEach((event) => {
            let period = event.closest(".morning") ? "morning" : "afternoon";
            let id = event.getAttribute("data-id");
            if (period === "morning") {
                morning.push(id);
            } else {
                afternoon.push(id);
            }
        });

        console.log("Morning:", morning);
        console.log("Afternoon:", afternoon);

        console.groupEnd();

        return {
            morning,
            afternoon,
        };
    };

    renderPlaceModals = () => {
        console.group("🔄 renderPlaceModals");
        // create a simple right sliding modal

        let allEvents = document.querySelectorAll(".event");
        console.log("All Events:", allEvents);

        let uniquePlaces = new Set();

        allEvents.forEach((event) => {
            // console.log("Event:", event);
            let placeId = event.getAttribute("data-placeId");

            // if the id is not in the set, we add it
            uniquePlaces.add(placeId);
        });

        // remove null values
        uniquePlaces.delete(null);

        console.log("Unique Places:", uniquePlaces);
        // Clear all previous .placeModal
        let previousModals = document.querySelectorAll(".placeModal");
        console.log("Previous Modals:", previousModals);
        previousModals.forEach((modal) => {
            modal.remove();
        });

        uniquePlaces.forEach((placeId) => {
            // debugger;
            fetch("/api/plans/get-itinerary-place-modal-partial", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    placeId: placeId,
                }),
            })
                .then((response) => response.text())
                .then((data) => {
                    console.log(
                        "Recieved Response modal for Place ID:",
                        placeId
                    );
                    // console.log("Data:");
                    // console.log(data);

                    let modalElement = document.createElement("div");
                    modalElement.innerHTML = data;
                    modalElement = modalElement.firstElementChild;
                    console.log("Place Modal Element:", modalElement);
                    modalElement.classList.add("hide");
                    document.body.appendChild(modalElement);

                    let closeButton = modalElement.querySelector(".closePanel");
                    closeButton.addEventListener("click", (e) => this.closePanel(e));
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        });

        //JB 180924 esto ahora carga por ajax.
        // remove all previous event listeners
        // document.querySelectorAll(".openPlaceModal").forEach((button) => {
        //     button.removeEventListener("click", (e) => {
        //         openModal(e);
        //     });
        // });

        // // add event listeners to all .openPlaceModal
        // document.querySelectorAll(".openPlaceModal").forEach((button) => {
        //     button.addEventListener("click", (e) => {
        //         openModal(e);
        //     });
        // });

        function openModal(e) {
            console.log("Opening Place Modal");

            let placeId = e.target
                .closest(".event")
                .getAttribute("data-placeId");
            console.log("Place ID:", placeId);
            let modal = document.getElementById("placeModal-" + placeId);
            console.log("Modal:", modal);
            // remove the hide class from the modal
            modal.classList.remove("hide");

            // hide all other modals
            document.querySelectorAll(".placeModal").forEach((modal) => {
                if (modal.id !== "placeModal-" + placeId) {
                    modal.classList.add("hide");
                }
            });
        }

        console.groupEnd();
    };

    handleClickConfirmAddEvent = (e) => {
        console.group("handleClickConfirmAddEvent");
        console.log(e.target);
        console.log("targetAddEvent", this.targetAddEvent);
        
        // there will be some checkboxes in #recommended-events
        // we have to settle with the items in this.activeRecommendedItems that correspond to the checked checkboxes
        let checkedItems = document.querySelectorAll(
            "#recommended-events input[type=checkbox]:checked"
        );

        console.log("=== DIAGNOSTICS ===");
        console.log("Checked items found:", checkedItems.length);
        console.log("activeRecommendedItems count:", this.activeRecommendedItems.length);
        console.log("activeRecommendedItems:", this.activeRecommendedItems);
        
        if (checkedItems.length === 0) {
            console.warn("No checkboxes are checked. Please select at least one activity.");
            alert("Por favor selecciona al menos una actividad antes de guardar.");
            console.groupEnd();
            return;
        }

        let newEvents = [];
        checkedItems.forEach((item, index) => {
            console.log(`Processing checked item ${index}:`, item);
            let parent = item.closest(".event");
            console.log("Parent element:", parent);
            let id = parent.getAttribute("data-id");
            console.log("Event ID from parent:", id);
            
            let found = this.activeRecommendedItems.find(
                (element) => element.id == id
            );
            console.log("Found item in activeRecommendedItems:", found);
            
            if (found) {
                newEvents.push(found);
            } else {
                console.error("Item not found in activeRecommendedItems. ID was:", id);
            }
        });

        console.log("=== END DIAGNOSTICS ===");
        console.log("newEvents to add:", newEvents);

        let targetDay = this.dayIndex + 1;
        let targetPeriod = this.targetAddEvent.closest(".morning")
            ? "morning"
            : "afternoon";
        let targetPeriodIndex = targetPeriod === "morning" ? 0 : 1;
        
        // ESTRATEGIA SIMPLE: Leer el índice exacto del botón "Añadir actividad"
        let targetIndexInPeriod = parseInt(this.targetAddEvent.getAttribute("data-insertion-index"));
        let storedPeriod = this.targetAddEvent.getAttribute("data-insertion-period");
        
        console.log("=== USING STORED INDEX ===");
        console.log("Stored insertion index:", targetIndexInPeriod);
        console.log("Stored period:", storedPeriod);
        console.log("Current target period:", targetPeriod);

        let newItinerary = JSON.parse(JSON.stringify(this.itinerary));
        console.log("=== BEFORE INSERTION ===");
        console.log("Current events in day", targetDay, "period", targetPeriodIndex, ":", this.itinerary.days[targetDay][targetPeriodIndex].events.map(e => ({ id: e.id, name: e.name })));
        console.log("Will insert at exact position:", targetIndexInPeriod);
        
        // insert the new events in the right place
        newEvents.forEach((event, index) => {
            console.log("Inserting event:", event.name, "at position:", targetIndexInPeriod + index);

            event.day_period = targetPeriod;

            // IMPORTANT, WE HAVE TO CREATE A NEW OBJECT, NOT TO USE THE SAME REFERENCE
            let targetDayPeriod =
                newItinerary.days[targetDay][targetPeriodIndex];
            if (!targetDayPeriod) {
                newItinerary.days[targetDay][targetPeriodIndex] = {
                    events: [],
                };
            }

            newItinerary.days[targetDay][targetPeriodIndex].events.splice(
                targetIndexInPeriod + index,
                0,
                event
            );
        });

        this.itinerary = newItinerary;

        // itineraryManager.itinerary = newItinerary;
        console.log(
            "Updated Itinerary before rendering items:",
            this.itinerary
        );

        // render the new events
        this.renderItineraryItems(targetDay);

        console.log(
            "Updated Itinerary after rendering items:",
            this.itinerary
        );
        // refresh the eventPeriods
        this.itinerary = this.refreshEventsPeriods(this.itinerary);

        console.log("Final Itinerary:", this.itinerary);
        console.groupEnd();
    };

    handleClickAnadirEvento = (e) => {
        $("body").addClass("noscroll");

        console.group("handleClickAnadirEvento");
        console.log(e.target);
        let pantallaAnadirEvento = document.getElementById("wrapper-addEvent");
        pantallaAnadirEvento.style.visibility = "hidden";
        pantallaAnadirEvento.style.opacity = 0;
        pantallaAnadirEvento.style.transform = "translateX(100%)";

        window.refreshMap();

        console.groupEnd();
    };

    handleClickConfirmAddSingleEvent = (e) => {
        console.group("handleClickConfirmAddSingleEvent");
        console.log(e.target);
        console.log("targetAddEvent", this.targetAddEvent);
        // there will be some checkboxes in #recommended-events
        // we have to settle with the items in this.activeRecommendedItems that correspond to the checked checkboxes

        // get the id of the selected event id="modal-"
        let selectedId = e.target
            .closest(".modEventPanel")
            .id.replace("modal-", "");

        console.log("selectedId", selectedId);

        console.log("activeRecommendedItems", this.activeRecommendedItems);

        // find the event in the activeRecommendedItems
        let newEvent = this.activeRecommendedItems.filter(
            (item) => item.id == selectedId
        );

        // there should be only one event

        if (newEvent.length > 1) {
            console.error("More than one event found with the same ID");
        }

        console.log("newEvent", newEvent);
        newEvent = newEvent[0];

        let targetDay = this.dayIndex + 1;
        let targetPeriod = this.targetAddEvent.closest(".morning")
            ? "morning"
            : "afternoon";
        let targetPeriodIndex = targetPeriod === "morning" ? 0 : 1;
        // we have to figure out the index where the new events will be inserted
        // it depends on where the e.target is relative to the other events in the period
        // we only have to count the events in the same period before the targetAddEvent
        let targetIndexInPeriod = 0;
        // select all child nodes of the targetPeriod
        let periodChildren = this.targetAddEvent.closest(
            "." + targetPeriod
        ).childNodes;
        console.log("periodChildren", periodChildren);
        for (let i = 0; i < periodChildren.length; i++) {
            if (periodChildren[i].classList.contains("event")) {
                if (periodChildren[i] == this.targetAddEvent) {
                    break;
                }
                targetIndexInPeriod++;
            }
        }

        let newItinerary = JSON.parse(JSON.stringify(this.itinerary));
        console.log("newItinerary", newItinerary);
        // insert the new event in the right place

        console.log("Inserting event:", newEvent);
        console.log("At day:", targetDay);
        console.log("At period index:", targetPeriodIndex);
        console.log("At index:", targetIndexInPeriod);

        newEvent.day_period = targetPeriod;

        // IMPORTANT, WE HAVE TO CREATE A NEW OBJECT, NOT TO USE THE SAME REFERENCE
        newItinerary.days[targetDay][targetPeriodIndex].events.splice(
            targetIndexInPeriod,
            0,
            newEvent
        );

        this.itinerary = newItinerary;

        // itineraryManager.itinerary = newItinerary;
        console.log(
            "Updated Itinerary before rendering items and refreshing periods:",
            itineraryManager.itinerary
        );

        this.renderItineraryItems(targetDay);

        // refresh the eventPeriods
        this.itinerary = this.refreshEventsPeriods(this.itinerary);

        console.log(
            "Updated Itinerary after refreshing periods:",
            itineraryManager.itinerary
        );

        // hide the modal screen
        let modal = e.target.closest(".modEventPanel");
        console.log("modal", modal);
        modal.classList.add("hide");

        // close wrapper-addEvent by transforming it to the right
        let pantallaAnadirEvento = document.getElementById("wrapper-addEvent");
        // pantallaAnadirEvento.style.visibility = "hidden";
        // pantallaAnadirEvento.style.opacity = 0;
        pantallaAnadirEvento.style.transform = "translateX(100%)";

        window.refreshMap();

        console.groupEnd();
    };

    handleClickAnadirEvento = (e) => {
        $("body").addClass("noscroll");

        console.group("handleClickAnadirEvento");
        console.log(e.target);
        let pantallaAnadirEvento = document.getElementById("wrapper-addEvent");

        // slide left
        pantallaAnadirEvento.style.visibility = "visible";
        pantallaAnadirEvento.style.opacity = 1;
        pantallaAnadirEvento.style.transform = "translateX(0)";

        this.targetAddEvent = e.target;

        let duration = e.target.getAttribute("data-duration");
        let siteId = e.target.getAttribute("data-placeid");

        console.log("duration", duration);
        console.log("siteId", siteId);

        let recommendedItems = this.getRecommendedItems(duration, siteId);
        // clear the recommended events
        document.querySelector("#recommended-events").innerHTML = "";

        recommendedItems.then((items) => {
            // console.log("recommended items", items);
            // clear the recommended events and the modEventPanel
            document.querySelector("#recommended-events").innerHTML = "";
            document.querySelectorAll(".modEventPanel").forEach((panel) => {
                panel.remove();
            });
            items.forEach((item) => {
                this.renderRecommendedItem(item);
            });
        });

        setTimeout(function () {
            window.initClicksPanels();
        }, 1500);

        console.groupEnd();
    };

    renderRecommendedItem = (item) => {
        console.log("renderRecommendedItem");
        console.log(item);
        // will append to #recommended-events
        this.getItemView(item, false, true).then((view) => {
            let recommendedItemTemplate = document.getElementById(
                "recommended-item-template"
            ).innerHTML;
            recommendedItemTemplate = recommendedItemTemplate.replace(
                "<%itineraryItemList>",
                view
            );
            recommendedItemTemplate = recommendedItemTemplate.replace(
                "<%id>",
                item.id
            );

            // create the element without any wrapper
            let itemElement = document.createElement("div");
            itemElement.classList.add("modItineraryEdit");
            itemElement.innerHTML = recommendedItemTemplate;

            // console.log("itemElement", itemElement);

            let more_info = itemElement.querySelector(".js-loadActivityPanel");
            // console.log("more_info", more_info);

            if (more_info) {
                more_info.addEventListener("click", (e) =>
                    this.loadActivtyPanel(e)
                );
            }

            // Agregar listener para poder seleccionar el checkbox haciendo clic en cualquier parte de la actividad
            let eventElement = itemElement.querySelector(".event");
            let checkbox = itemElement.querySelector("input[type=checkbox]");
            
            if (eventElement && checkbox) {
                console.log("Adding click listener to event element for checkbox toggle");
                
                // Listener para el elemento completo (toggle checkbox)
                eventElement.addEventListener("click", (e) => {
                    // No procesar si el clic fue en el link "Ver más" o en otro elemento interactivo
                    if (e.target.closest(".js-openEventModal") || e.target.closest(".js-loadActivityPanel")) {
                        return;
                    }
                    console.log("Event clicked, toggling checkbox");
                    checkbox.checked = !checkbox.checked;
                    updateCheckboxVisualFeedback();
                });
                
                // Listener directo al checkbox
                checkbox.addEventListener("change", (e) => {
                    console.log("Checkbox changed:", checkbox.checked);
                    updateCheckboxVisualFeedback();
                });
                
                // Función para actualizar el visual feedback
                const updateCheckboxVisualFeedback = () => {
                    const bodyItemItinerary = eventElement.querySelector(".bodyItemItineraryList");
                    if (checkbox.checked) {
                        bodyItemItinerary.style.backgroundColor = "rgba(200, 220, 255, 0.3)";
                        bodyItemItinerary.style.borderLeft = "4px solid #007bff";
                        bodyItemItinerary.style.paddingLeft = "12px";
                    } else {
                        bodyItemItinerary.style.backgroundColor = "";
                        bodyItemItinerary.style.borderLeft = "";
                        bodyItemItinerary.style.paddingLeft = "";
                    }
                };
                
                // Hacer que el cursor cambie cuando pases por encima
                eventElement.style.cursor = "pointer";
            }

            document
                .querySelector("#recommended-events")
                .appendChild(itemElement);
        });

        this.getItemModal(item).then((data) => {
            let modalElement = document.createElement("div");
            let id = "modal-" + item.id;
            // href=javascript:; class="js-closePanel closePanel"
            let closeModal = document.createElement("a");
            closeModal.innerHTML = "+";
            closeModal.classList.add("js-closePanel");
            closeModal.classList.add("closePanel");
            closeModal.addEventListener("click", (e) => this.closePanel(e));

            modalElement.classList.add("modEventPanel");
            modalElement.classList.add("hide");
            modalElement.id = id;
            modalElement.innerHTML = data;
            document.body.appendChild(modalElement);

            modalElement.insertBefore(closeModal, modalElement.firstChild);

            let addToPlanButton = modalElement.querySelector(".btnaction");

            // add listener to add the event to the itinerary
            addToPlanButton.addEventListener("click", (e) => {
                console.log("add to plan button clicked");
                this.handleClickConfirmAddSingleEvent(e);
            });
            // remove the button from the modal
            // addToPlanButton.remove();
        });

        // add listener
    };

    getRecommendedItems = async (time, siteId) => {
        console.log("getRecommendedItems()");
        // Esta función debe devolver items recomendados para una duración y un lugar dados
        let self = this;

        console.log("itinerary", this.itinerary);
        console.log("dayIndex", this.dayIndex);
        let morningAlreadyPresent;
        try {
            morningAlreadyPresent =
                this.itinerary.days[this.dayIndex + 1][0].events ?? [];
        } catch {
            morningAlreadyPresent = [];
        }

        let afternoonAlreadyPresent;
        try {
            afternoonAlreadyPresent =
                this.itinerary.days[this.dayIndex + 1][1].events ?? [];
        } catch {
            afternoonAlreadyPresent = [];
        }

        console.log("morningAlreadyPresent", morningAlreadyPresent);
        console.log("afternoonAlreadyPresent", afternoonAlreadyPresent);

        let alreadyPresent = afternoonAlreadyPresent.concat(
            morningAlreadyPresent
        );
        let alreadyPresentIds = alreadyPresent.map((item) => item.id);

        return fetch("/api/plans/get-itinerary-recommended-items", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                time: time,
                siteId: siteId,
                alreadyPresent: alreadyPresentIds,
            }),
        })
            .then((response) => response.text())
            .then((data) => {
                let items = JSON.parse(data);
                self.activeRecommendedItems = items;
                return items;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    loadActivtyPanel = (e) => {
        console.log("loadActivtyPanel");
        console.log(e.target);

        let eventId = e.target.closest(".event").getAttribute("data-id");
        let modal = document.getElementById("modal-" + eventId);

        console.log("eventId", eventId);
        console.log("modal", modal);

        modal.classList.remove("hide");
    };

    closePanel = (e) => {
        console.log("closePanel");
        console.log(e.target);
        let modal = e.target.closest(".modEventPanel");
        console.log("modal", modal);
        modal.classList.add("hide");
    };

    findEventById = (id) => {
        console.group("🔍 findEventById");

        console.log("Looking for ID:", id);

        let found = null;
        let currentEvents = [];
        currentEvents.push(this.itinerary.days[dayIndex + 1][0].events);
        currentEvents.push(this.itinerary.days[dayIndex + 1][1].events);

        console.log("Current Events:", currentEvents);

        for (let i = 0; i < currentEvents.length; i++) {
            for (let j = 0; j < currentEvents[i].length; j++) {
                if (currentEvents[i][j].id == id) {
                    found = currentEvents[i][j];
                    console.log("found", found);
                    break;
                }
            }

            if (found) {
                console.log("found", found);
                break;
            }

            for (let j = 0; j < currentEvents[i].length; j++) {
                if (currentEvents[i][j].id == id) {
                    found = currentEvents[i][j];
                    console.log("found", found);
                    break;
                }
            }

            if (found) {
                console.log("found", found);
                break;
            }
        }

        if (!found) {
            console.error("Event not found in itinerary");
        }

        console.groupEnd();

        return found;
    };
}

class DragManager {
    constructor() {
        this.dragging = null;
    }

    makeItemsDraggable = () => {
        let events = document.querySelectorAll("#itineraryList .event");
        events.forEach((event) => {
            event.setAttribute("draggable", "true");
        });
        this.addEventsEventListeners();
    };

    makeItemsNotDraggable = () => {
        let events = document.querySelectorAll("#itineraryList .event");
        events.forEach((event) => {
            event.setAttribute("draggable", "false");
        });
    };

    addEventsEventListeners = () => {
        console.log("addEventsEventListeners");
        console.log("current itinerary", itineraryManager.itinerary);

        let events = document.querySelectorAll(".event");
        events.forEach((event) => {
            event.addEventListener("dragstart", function (e) {
                dragging = this;
                this.classList.add("dragging");
            });

            event.addEventListener("dragend", function (e) {
                dragging = null;
                this.classList.remove("dragging");
            });

            event.addEventListener("dragover", function (e) {
                // cant drag over itself
                // console.log('dragover');
                // console.log(this);
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                // add classes to show where the element will be dropped
                if (dragging) {
                    if (dragging === this) {
                        return;
                    }
                    let rect = this.getBoundingClientRect();
                    // take the padding into account
                    let top = rect.top + rect.height / 2;
                    let bottom = rect.bottom - rect.height / 2;
                    let y = e.clientY;
                    if (y < top) {
                        // if the item doesnt come directly after the dragging item, add a margin
                        if (this.previousElementSibling !== dragging) {
                            this.classList.add("dragging-over-top");
                            this.classList.remove("dragging-over-bottom");
                        }
                    } else if (y > bottom) {
                        // if the item doesnt come directly before the dragging item, add a margin
                        if (this.nextElementSibling !== dragging) {
                            this.classList.add("dragging-over-bottom");
                            this.classList.remove("dragging-over-top");
                        }
                    } else {
                        this.classList.remove("dragging-over-top");
                        this.classList.remove("dragging-over-bottom");
                    }
                }
            });

            event.addEventListener("dragleave", function (e) {
                // console.log('dragleave');
                // console.log(this);
                this.classList.remove("dragging-over-top");
                this.classList.remove("dragging-over-bottom");
            });

            event.addEventListener("drop", function (e) {
                console.log("drop");
                //
                console.log(itineraryManager);
                // console.log(this);
                e.preventDefault();
                if (dragging) {
                    let rect = this.getBoundingClientRect();
                    // take into account the padding
                    let top = rect.top + rect.height / 2;
                    let bottom = rect.bottom - rect.height / 2;
                    let y = e.clientY;
                    let dropBefore = y < top;
                    let parent = this.parentElement;
                    let draggingIndex = Array.from(parent.children).indexOf(
                        dragging
                    );
                    let dropIndex = Array.from(parent.children).indexOf(this);
                    // remove the dragging-over classes
                    this.classList.remove("dragging-over-top");
                    this.classList.remove("dragging-over-bottom");

                    if (dropBefore) {
                        parent.insertBefore(dragging, this);
                    } else {
                        parent.insertBefore(dragging, this.nextElementSibling);
                    }

                    let newItinerary = itineraryManager.updateEventsOrder(
                        this.itinerary
                    );
                    itineraryManager.itinerary = newItinerary;
                    console.log("itinerary", itineraryManager.itinerary);

                    // refresh headers
                    // console.log("refreshSiteHeaders");
                    refreshSiteHeaders();
                    refreshActivityNumbers();
                    window.refreshMap();
                }
            });
        });

        let morning = document.querySelector(".morning");
        let afternoon = document.querySelector(".afternoon");

        // we may be able to move an event inside .morning to .afternoon and vice versa
        //the target, wether it is morning or afternoon, must be empty of any event
        morning.addEventListener("dragover", function (e) {
            // console.log('dragover');
            let innerEvents = morning.querySelectorAll(".event");
            // console.log('innerEvents', innerEvents);
            if (innerEvents.length === 0) {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                morning.classList.add("dragging-over");
            }
        });

        morning.addEventListener("dragleave", function (e) {
            let innerEvents = morning.querySelectorAll(".event");
            if (innerEvents.length === 0) {
                e.preventDefault();
                morning.classList.remove("dragging-over");
                dragging.classList.remove("dragging");
            }
        });

        morning.addEventListener("drop", function (e) {
            e.preventDefault();
            let innerEvents = morning.querySelectorAll(".event");
            if (innerEvents.length === 0) {
                if (dragging) {
                    if (dragging.parentElement === afternoon) {
                        let innerEvents = dragging.querySelectorAll(".event");
                        if (innerEvents.length === 0) {
                            morning.appendChild(dragging);
                            morning.classList.remove("dragging-over");
                        }
                    }
                }
            }
        });

        afternoon.addEventListener("dragover", function (e) {
            let innerEvents = afternoon.querySelectorAll(".event");
            if (innerEvents.length === 0) {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                afternoon.classList.add("dragging-over");
            }
        });

        afternoon.addEventListener("dragleave", function (e) {
            let innerEvents = afternoon.querySelectorAll(".event");
            if (innerEvents.length === 0) {
                e.preventDefault();
                afternoon.classList.remove("dragging-over");
                dragging.classList.remove("dragging");
            }
        });

        afternoon.addEventListener("drop", function (e) {
            let innerEvents = afternoon.querySelectorAll(".event");
            if (innerEvents.length === 0) {
                e.preventDefault();
                if (dragging) {
                    if (dragging.parentElement === morning) {
                        let innerEvents = dragging.querySelectorAll(".event");
                        if (innerEvents.length === 0) {
                            afternoon.appendChild(dragging);
                            afternoon.classList.remove("dragging-over");
                        }
                    }
                }
            }
        });
    };

    // handleDragStart = (e, event) => {
    //     console.log("handleDragStart");
    //     this.dragging = event;
    //     event.classList.add("dragging");
    // };

    // handleDragEnd = (e, event) => {
    //     this.dragging = null;
    //     event.classList.remove("dragging");
    // };

    handleDragOver = (e, event) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        if (this.dragging && this.dragging !== event) {
            let rect = event.getBoundingClientRect();
            let top = rect.top + rect.height / 2;
            let bottom = rect.bottom - rect.height / 2;
            let y = e.clientY;
            if (y < top) {
                if (event.previousElementSibling !== this.dragging) {
                    event.classList.add("dragging-over-top");
                    event.classList.remove("dragging-over-bottom");
                }
            } else if (y > bottom) {
                if (event.nextElementSibling !== this.dragging) {
                    event.classList.add("dragging-over-bottom");
                    event.classList.remove("dragging-over-top");
                }
            } else {
                event.classList.remove("dragging-over-top");
                event.classList.remove("dragging-over-bottom");
            }
        }
    };

    handleDragLeave = (e, event) => {
        event.classList.remove("dragging-over-top");
        event.classList.remove("dragging-over-bottom");
    };

    handleDrop = (e, event) => {
        e.preventDefault();
        if (this.dragging && this.dragging !== event) {
            let rect = event.getBoundingClientRect();
            let y = e.clientY;
            if (y < rect.top + rect.height / 2) {
                event.parentElement.insertBefore(this.dragging, event);
            } else {
                event.parentElement.insertBefore(this.dragging, event.nextElementSibling);
            }
            event.classList.remove("dragging-over-top");
            event.classList.remove("dragging-over-bottom");
        }
    };

    toggleListDragAndDrop = () => {
        let list = document.getElementById("itineraryList");
        let IsEnabled = list.getAttribute("data-drag-enabled") === "true";
        console.log("IsEnabled", IsEnabled);
        list.setAttribute("data-drag-enabled", !IsEnabled);
        if (IsEnabled) {
            dragManager.makeItemsNotDraggable();
        } else {
            dragManager.makeItemsDraggable();
        }
    };
}

// // console.log('itineraryManager', itineraryManager);
// // console.log('dragManager', dragManager);

// function returnradomitemview() {
//     console.log("returnradomitemview");
//     console.log(itinerary.days[day][0].events[0]);
//     return itineraryManager.getItemView(
//         itinerary.days[day][0].events[0],
//         false
//     );
// }

function copyToClipboard(url) {
    const tempInput = document.createElement("input");
    tempInput.value = url;
    document.body.appendChild(tempInput);

    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // mobile only
    document.execCommand("copy");

    document.body.removeChild(tempInput);
    alert("URL copiada!");
}

const swiperNews = new Swiper(".swiperNews", {
    //modules: [Navigation, Pagination],
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-btn-news-next",
        prevEl: ".swiper-btn-news-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
    },
    on: {
        init: function () {
            console.log("swiperNews se ha inicializado");
        },
        slideChange: function () {
            // Actualizar el título de la imagen grande cuando cambia la slide
            const currentSlide = this.slides[this.activeIndex];
            const imageTitle = currentSlide?.getAttribute('data-image-title') || '';
            const descriptionDiv = document.querySelector('.articleSingle .description');

            if (descriptionDiv) {
                const titleP = descriptionDiv.querySelector('p');
                if (titleP) {
                    titleP.textContent = imageTitle;
                    // Mostrar/ocultar el párrafo según si hay título
                    titleP.style.display = imageTitle ? 'block' : 'none';
                } else if (imageTitle) {
                    // Si no existe el párrafo, crearlo
                    const newP = document.createElement('p');
                    newP.textContent = imageTitle;
                    descriptionDiv.appendChild(newP);
                }
            }
        }
    },
});

const swiperNewsBlock = new Swiper(".swiperNewsBlock", {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination", // si la añades después
        dynamicBullets: true,
        dynamicMainBullets: 3,
        clickable: true
    },
    navigation: {
        nextEl: ".cont-swiper .swiper-button-next-news",
        prevEl: ".cont-swiper .swiper-button-prev-news",
    },
    breakpoints: {
        // 640: {
        //     slidesPerView: 2.3,
        // },
        // 1024: {
        //     slidesPerView: 2.3,
        // },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 2.5 : 1.5,
            spaceBetween: 20,
        }
    },
    on: {
        init: function () {
            // console.log("swiperNewsBlock se ha inicializado");
        },
    },
});

// Carrusel global (single instance selector)
const swiperCarrusel = new Swiper(".swiperCarrusel", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next-carrusel",
        prevEl: ".swiper-button-prev-carrusel",
    },
    on: {
        init: function () {
            // console.log("swiperCarrusel inicializado");
        },
    },
});

// Inicialización por instancia para contenedores de bloque (.swiperCarruselBlock)
document.querySelectorAll('.swiperCarruselBlock').forEach(function(container){
    try {
        const wrap = container.closest('.cont-swiper') || document;
        const nextBtn = wrap.querySelector('.swiper-button-next-carrusel');
        const prevBtn = wrap.querySelector('.swiper-button-prev-carrusel');
        const paginationEl = wrap.querySelector('.swiper-pagination');

        new Swiper(container, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: paginationEl ? { el: paginationEl, dynamicBullets: true, clickable: true } : {},
            navigation: { nextEl: nextBtn, prevEl: prevBtn },
            on: { init: function(){ /* initialized */ } }
        });
    } catch(e) { console.error('swiperCarruselBlock init error', e); }
});




const swiperPueblos = new Swiper(".swiperPueblos", {
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 20,
    pagination: {
        el: ".cont-swiper .swiper-pagination", // si la añades después
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".cont-swiper .swiper-button-next",
        prevEl: ".cont-swiper .swiper-button-prev",
    },
    breakpoints: {
        // 640: {
        //     slidesPerView: 2.3,
        // },
        // 1024: {
        //     slidesPerView: 2.3,
        // },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 2.5 : 1.5,
            spaceBetween: 20,
        }
    },
    on: {
        init: function () {
            // console.log("swiperPueblos se ha inicializado");
        },
    },
});

// Swiper para filtros de eventos (Ponferrada)
const swiperEventFilters = new Swiper(".swiperEventFilters", {
    loop: false,
    slidesPerView: 4,
    spaceBetween: 15,
    freeMode: true,
    navigation: {
        nextEl: ".swiper-button-next-eventFilters",
        prevEl: ".swiper-button-prev-eventFilters",
    },
    on: {
        init: function () {
            console.log("swiperEventFilters se ha inicializado");
        },
    },
});

// Swiper para galería de imágenes en evento single (es_single)
const swiperEventGallerySingle = new Swiper(".swiperEventGallerySingle", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination-eventGallerySingle",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".swiper-button-next-eventGallerySingle",
        prevEl: ".swiper-button-prev-eventGallerySingle",
    },
    on: {
        init: function () {
            console.log("swiperEventGallerySingle se ha inicializado");
        },
    },
});

const swiperEventGallerySingleFluid = new Swiper(".swiperEventGallerySingleFluid", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 24,
    freeMode: true,
    scrollbar: {
        el: ".swiper-scrollbar-eventGallerySingle",
        hide: false,
        draggable: true,
    },
    on: {
        init: function () {
            console.log("swiperEventGallerySingleFluid se ha inicializado");
        },
    },
});

const swiperEventHeaderGallery = document.querySelector(".swiperEventHeaderGallery") ? new Swiper(".swiperEventHeaderGallery", {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination-eventHeaderGallery",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
    },
}) : null;

// Objeto para almacenar referencias a los swipers
const eventSwipers = {
    proximos: null,
    annual: null,
    imprescindibles: null,
    sectioncard: null
};

// Función para destruir los swipers existentes
function destroyEventSwipers() {
    if (eventSwipers.proximos) {
        eventSwipers.proximos.destroy();
        eventSwipers.proximos = null;
    }
    if (eventSwipers.annual) {
        eventSwipers.annual.destroy();
        eventSwipers.annual = null;
    }
    if (eventSwipers.imprescindibles) {
        eventSwipers.imprescindibles.destroy();
        eventSwipers.imprescindibles = null;
    }
    if (eventSwipers.sectioncard) {
        eventSwipers.sectioncard.destroy();
        eventSwipers.sectioncard = null;
    }
}

// Función para inicializar swipers cuando estén disponibles
function initializeEventSwipers() {
    console.log('initializeEventSwipers() called');
    // Inicializar proximosEventosV3
    if (document.querySelector('.event-image-gallery-proximos .swiperEventGalleryProximos')) {
        if (eventSwipers.proximos) {
            eventSwipers.proximos.destroy();
        }
        eventSwipers.proximos = new Swiper('.event-image-gallery-proximos .swiperEventGalleryProximos', {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            scrollbar: {
                el: '.event-image-gallery-proximos .swiper-scrollbar-eventGalleryProximos',
                hide: false,
                draggable: true,
            },
            on: {
                init: function () {
                    console.log("swiperEventGalleryProximos inicializado");
                },
            },
        });
    }

    // Inicializar annualV3
    // Inicializar annualV3 (soporta múltiples instancias y contenido en modales)
    const annualEls = document.querySelectorAll('.swiperEventGalleryAnnual');
    if (annualEls.length) {
        // Si hay instancia previa global, destrúyela
        if (eventSwipers.annual) {
            try { eventSwipers.annual.destroy(); } catch (e) { console.warn(e); }
            eventSwipers.annual = null;
        }

        annualEls.forEach(function (el, idx) {
            try {
                // Si este elemento ya tiene instancia, actualízala
                if (el.__swiperInstance) {
                    try { el.__swiperInstance.update(); } catch (e) { console.warn(e); }
                    return;
                }

                const scrollbarEl = el.querySelector('.swiper-scrollbar-eventGalleryAnnual') || el.querySelector('.swiper-scrollbar');
                const swiper = new Swiper(el, {
                    loop: false,
                    slidesPerView: "auto",
                    spaceBetween: 24,
                    freeMode: true,
                    scrollbar: {
                        el: scrollbarEl,
                        hide: false,
                        draggable: true,
                    },
                    observer: true,
                    observeParents: true,
                    on: {
                        init: function () {
                           //console.log("swiperEventGalleryAnnual inicializado en elemento", el);
                        },
                    },
                });

                // Guardar referencia en el elemento y en el objeto global (última instancia)
                el.__swiperInstance = swiper;
                eventSwipers.annual = swiper;

                // Forzar actualización de tamaño y scrollbar
                try { swiper.update(); if (swiper.scrollbar && swiper.scrollbar.updateSize) swiper.scrollbar.updateSize(); } catch (e) { console.warn(e); }
            } catch (err) {
                //console.error('Error inicializando un swiperEventGalleryAnnual:', err);
            }
        });
    }

    // Forzar una actualización diferida para cubrir imágenes que carguen tarde
    setTimeout(function () {
        console.log('Delayed swiper update trigger');
        Object.keys(eventSwipers).forEach(function (key) {
            const s = eventSwipers[key];
            if (s) {
                try {
                    s.update();
                    if (s.scrollbar && s.scrollbar.updateSize) s.scrollbar.updateSize();
                    console.log('Updated swiper:', key, s);
                } catch (e) {
                    console.warn('Error updating swiper', key, e);
                }
            }
        });
    }, 350);

    // Inicializar swiperImprescindibles (galería de imágenes en event-single-v3, funciona en página y en modal)
    if (document.querySelector('.swiperImprescindibles')) {
        if (eventSwipers.imprescindibles) {
            eventSwipers.imprescindibles.destroy();
        }
        eventSwipers.imprescindibles = new Swiper('.swiperImprescindibles', {
            loop: false,
            pagination: {
                el: ".swiperImprescindibles .swiper-pagination",
                clickable: true, 
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            navigation: {
                nextEl: '.swiper-button-next-imprescindibles',
                prevEl: '.swiper-button-prev-imprescindibles',
            },
            slidesPerView: themeVersion == 'v3' ? 3.8 : 4,
            spaceBetween: 20,
            observer: false,
            observeParents: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: themeVersion == 'v3' ? 2.8 : 4,
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: themeVersion == 'v3' ? 3.8 : 4,
                    spaceBetween: 20,
                }
            },
        });
    }

    // Inicializar sectioncard gallery
    if (document.querySelector('.swiperSectioncardGallery')) {
        if (eventSwipers.sectioncard) {
            eventSwipers.sectioncard.destroy();
        }
        const slidesCount = document.querySelectorAll('.swiperSectioncardGallery .swiper-slide').length;
        const fullScrollbarContainer = document.querySelector('.contenedor-scrollbar');
        // Buscamos el elemento de la descripción
        const descriptionEl = document.querySelector('.sectioncard-image-gallery-modal .description');

        eventSwipers.sectioncard = new Swiper('.swiperSectioncardGallery', {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            // Solo mostramos el scrollbar si hay 4 o más slides
            // scrollbar: slidesCount < 4 ? false : {
            scrollbar: {
                el: '.swiper-scrollbar-sectioncardGallery',
                hide: false,
                draggable: true,
            },
            observer: true,
            observeParents: true,
            on: {
                init: function () {
                    /* Solo mostramos el scrollbar si hay 4 o más slides
                    if (slidesCount < 4 && fullScrollbarContainer) {
                        fullScrollbarContainer.style.display = 'none';
                        // Movemos la descripción a bottom: 10px
                        if (descriptionEl) {
                            descriptionEl.style.bottom = '10px';
                        }
                    } else if (fullScrollbarContainer) {
                        fullScrollbarContainer.style.display = 'block';
                        // Aplicamos el bottom original que tenía en el CSS
                        if (descriptionEl) {
                            descriptionEl.style.bottom = ''; 
                        }
                    } */
                  //  console.log("swiperSectioncardGallery inicializado");
                },
            },
        });
    }

    // Inicializar swiperProximosEventos
    if (document.querySelector('.swiperProximosEventos')) {
        if (eventSwipers.proximosEventos) {
            eventSwipers.proximosEventos.destroy();
        }
        eventSwipers.proximosEventos = new Swiper('.swiperProximosEventos', {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 20,
            pagination: {
                el: ".swiperProximosEventos .swiper-pagination",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            navigation: {
                nextEl: '.swiper-button-next-proximos-eventos',
                prevEl: '.swiper-button-prev-proximos-eventos',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            },
        });
    }
}

// Intentar inicializar en DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeEventSwipers);

// MutationObserver eliminado: causaba un bucle infinito porque Swiper modifica el DOM al inicializarse,
// lo que volvía a disparar el observer → destruía y recreaba el swiper sin parar → parpadeo.
// Los listeners shown.bs.modal / hidden.bs.modal cubren el caso del modal.

// Listener para cuando un modal con clase eventSingle se muestra
document.addEventListener('shown.bs.modal', function(e) {
    const modal = e.target;
    // Re-inicializar swipers si el modal contiene una galería de evento o de sectioncard
    if (modal && (modal.querySelector('.eventSingle') || modal.querySelector('.sectionCard') || modal.querySelector('.sectionCardModal') || modal.querySelector('.sectioncard-image-gallery-modal'))) {
        console.log("Modal mostrado con galería, reinicializando swipers");
        setTimeout(initializeEventSwipers, 100);
    }
});

// Listener para cuando un modal con clase eventSingle se cierra
document.addEventListener('hidden.bs.modal', function(e) {
    const modal = e.target;
    if (modal && (modal.querySelector('.eventSingle') || modal.querySelector('.sectionCard') || modal.querySelector('.sectionCardModal') || modal.querySelector('.sectioncard-image-gallery-modal'))) {
        console.log("Modal con galería cerrado, destruyendo swipers");
        destroyEventSwipers();
    }
});

// siteGalleryModal: inicialización lazy para funcionar tanto en página directa como en modal de evento
let _siteGallerySwiper = null;
let _siteGalleryBsModal = null;

function initSiteGalleryModal() {
    const modalEl = document.getElementById('siteGalleryModal');
    if (!modalEl) return null;

    // Si el modal está anidado dentro de otro elemento (ej: #modalEvent), moverlo al body
    // para que Bootstrap lo gestione correctamente sin conflictos de z-index/backdrop
    if (modalEl.parentElement !== document.body) {
        document.body.appendChild(modalEl);
    }

    if (!_siteGalleryBsModal) {
        _siteGalleryBsModal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);

        // Asegurar que el modal de galería siempre aparece por encima de cualquier otro modal
        modalEl.addEventListener('show.bs.modal', function () {
            // Calcular el z-index más alto de los modales visibles actualmente
            let maxZ = 1055; // z-index por defecto de Bootstrap modal
            document.querySelectorAll('.modal.show, [id="modalEvent"]').forEach(function (m) {
                const z = parseInt(window.getComputedStyle(m).zIndex, 10);
                if (!isNaN(z) && z >= maxZ) maxZ = z + 10;
            });
            modalEl.style.zIndex = maxZ;
        });

        // Elevar también el backdrop al nivel correcto
        modalEl.addEventListener('shown.bs.modal', function () {
            const backdrop = document.querySelector('.modal-backdrop:last-of-type');
            if (backdrop) {
                backdrop.style.zIndex = parseInt(modalEl.style.zIndex || 1055, 10) - 1;
            }
        });

        // Limpiar z-index al cerrar para no afectar futuros usos en página directa
        modalEl.addEventListener('hidden.bs.modal', function () {
            modalEl.style.zIndex = '';
        });
    }

    if (!_siteGallerySwiper) {
        _siteGallerySwiper = new Swiper(".swiperSiteGalleryModal", {
            slidesPerView: 1,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            autoHeight: true,
            pagination: {
                el: ".swiper-pagination-siteGalleryModal",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            navigation: {
                nextEl: ".swiper-button-next-siteGalleryModal",
                prevEl: ".swiper-button-prev-siteGalleryModal",
            },
            on: {
                slideChange: function () {
                    const currentSlide = this.slides[this.activeIndex];
                    const titleElement = modalEl.querySelector('.image-title-modal');
                    if (titleElement && currentSlide) {
                        titleElement.textContent = currentSlide.getAttribute('data-image-title') || '';
                    }
                },
                slideChangeTransitionStart: function () {
                    this.updateAutoHeight(300);
                },
                resize: function () {
                    this.update();
                }
            }
        });
    }

    return { swiper: _siteGallerySwiper, bsModal: _siteGalleryBsModal, modalEl };
}

// Delegación de eventos para .js-openSiteGallery — funciona en página directa y en modal de evento
document.addEventListener('click', function (e) {
    const img = e.target.closest('.js-openSiteGallery');
    if (!img) return;

    e.preventDefault();

    // Resetear caché si el siteGalleryModal ya no está en el DOM (era de otro evento)
    if (_siteGallerySwiper && !document.getElementById('siteGalleryModal')) {
        _siteGallerySwiper.destroy();
        _siteGallerySwiper = null;
        _siteGalleryBsModal = null;
    }

    const result = initSiteGalleryModal();
    if (!result) return;

    const { swiper, bsModal, modalEl } = result;
    const index = parseInt(img.getAttribute('data-gallery-index'), 10) || 0;

    swiper.slideTo(index, 0, false);

    const currentSlide = swiper.slides[index];
    const titleElement = modalEl.querySelector('.image-title-modal');
    if (titleElement && currentSlide) {
        titleElement.textContent = currentSlide.getAttribute('data-image-title') || '';
    }

    bsModal.show();
});

const swiperEventRelated = new Swiper(".swiperEventRelated", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination-eventRelated",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".swiper-button-next-eventRelated",
        prevEl: ".swiper-button-prev-eventRelated",
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 4 : 3,
        }
    },
});

const swiperSiteRelated = new Swiper(".swiperSiteRelated", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination-siteRelated",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
    navigation: {
        nextEl: ".swiper-button-next-siteRelated",
        prevEl: ".swiper-button-prev-siteRelated",
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1536: {
            slidesPerView: themeVersion == 'v3' ? 4 : 3,
        }
    },
    on: {
        init: function () {
            //console.log("swiperSiteRelated se ha inicializado");
        },
    },
});
function insertStopMsg() {
    let itineraryStopDiv = document.getElementById("itinerary-stop");
    if (itineraryStopDiv) {
        let stopEvent = itineraryStopDiv.cloneNode(true);
        stopEvent.classList.remove("d-none");

        // Recorremos los días del itinerario
        let lastDayKey = Object.keys(itinerary.days).pop(); // Último día
        let lastDay = itinerary.days[lastDayKey];

        // Recorrer los periodos del último día
        let lastPeriod = lastDay[lastDay.length - 1]; // Último periodo del último día
        let lastEvent = lastPeriod
            ? lastPeriod.events[lastPeriod.events.length - 1]
            : null;

        if (lastEvent) {
            console.log("Último evento encontrado, insertando después:");
            console.log(lastEvent);
            let eventElement = document.querySelector(
                `[data-id="${lastEvent.id}"]`
            );
            if (eventElement) {
                eventElement.after(stopEvent);
            }
        } else {
            console.log("No hay eventos, añadiendo al final del itinerario.");
            let lastSection = document.querySelector(
                ".itinerary-section:last-of-type"
            );
            if (lastSection) {
                lastSection.appendChild(stopEvent);
            }
        }
    } else {
        console.error("No se encontró el div con id 'itinerary-stop'.");
    }
}

// Filtro de eventos por categoría (filterevents)
const eventFilterForm = document.getElementById('eventFilterForm');
if (eventFilterForm) {
    const radioInputs = eventFilterForm.querySelectorAll('input[type="radio"][name="category"]');

    radioInputs.forEach(radio => {
        radio.addEventListener('change', function () {
            const selectedValue = this.value;
            const swiperSlides = document.querySelectorAll('.swiper-slide[data-filterevent]');

            swiperSlides.forEach(slide => {
                const filterEventIds = slide.getAttribute('data-filterevent')
                    .split(',')
                    .map(id => id.trim())
                    .filter(id => id !== '');

                if (selectedValue === 'all') {
                    slide.style.display = '';
                } else {
                    if (filterEventIds.includes(selectedValue)) {
                        slide.style.display = '';
                    } else {
                        slide.style.display = 'none';
                    }
                }
            });

            // Actualizar el swiper para que se ajuste correctamente
            if (window.swiperAgenda) {
                window.swiperAgenda.update();
            }
        });
    });

    // Manejar el click en "Ver el resto de noticias"
    const viewAllEventsLink = document.querySelector('.js-view-all-events');
    if (viewAllEventsLink) {
        viewAllEventsLink.addEventListener('click', function (e) {
            e.preventDefault();
            const selectedRadio = eventFilterForm.querySelector('input[type="radio"][name="category"]:checked');
            const selectedValue = selectedRadio ? selectedRadio.value : 'all';

            // Obtener la URL desde el atributo data del formulario
            const agendaUrl = eventFilterForm.getAttribute('data-agenda-url');

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = agendaUrl;

            // Añadir token CSRF
            const csrfToken = document.querySelector('meta[name="csrf-token"]');
            if (csrfToken) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = '_token';
                input.value = csrfToken.getAttribute('content');
                form.appendChild(input);
            }

            // Añadir el filterevent si no es 'all'
            if (selectedValue !== 'all') {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'filterevent';
                input.value = selectedValue;
                form.appendChild(input);
            }

            document.body.appendChild(form);
            form.submit();
        });
    }
}

// Manejo de favoritos
document.addEventListener('DOMContentLoaded', function () {
    const favoriteButtons = document.querySelectorAll('.js-favorito');

    // Modal de confirmación
    const modalFavoriteMessage = new bootstrap.Modal(
        document.getElementById('modalFavoriteMessage') || createFavoriteModal()
    );

    favoriteButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            const type = this.getAttribute('data-type');
            const contentId = this.getAttribute('data-id');
            const contentName = this.getAttribute('data-name');

            // Obtener textos traducidos de data-attributes
            const textAdded = this.getAttribute('data-text-added');
            const textRemoved = this.getAttribute('data-text-removed');
            const msgAdded = this.getAttribute('data-msg-added');
            const msgRemoved = this.getAttribute('data-msg-removed');
            const msgSuffix = this.getAttribute('data-msg-suffix');

            // Verificar si el usuario está logado
            const token = document.querySelector('meta[name="csrf-token"]');
            const isLoggedIn = document.querySelector('meta[name="user-id"]');

            if (!isLoggedIn) {
                // Redirigir a login
                localStorage.setItem('redirectAfterLogin', window.location.href);
                window.location.href = '/login';
                return;
            }

            // Realizar petición AJAX al endpoint
            $.ajax({
                url: '/api/favorite/toggle',
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': token.getAttribute('content'),
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + (document.querySelector('meta[name="user-token"]')?.getAttribute('content') || '')
                },
                data: {
                    type: type,
                    content_id: contentId
                },
                success: function (response) {
                    if (response.success) {
                        // Actualizar clase favorito-active del bookmark-ico
                        const bookmarkIcon = button.querySelector('.boookmark-ico');
                        if (bookmarkIcon) {
                            if (response.isFavorite) {
                                bookmarkIcon.classList.add('favorito-active');
                            } else {
                                bookmarkIcon.classList.remove('favorito-active');
                            }
                        }

                        // Mostrar modal con mensaje
                        showFavoriteModal(response.action, contentName, textAdded, textRemoved, msgAdded, msgRemoved, msgSuffix);

                        // Disparar evento personalizado para elementos removibles
                        if (response.action === 'removed') {
                            const event = new CustomEvent('favoriteRemoved', {
                                detail: { button: button }
                            });
                            document.dispatchEvent(event);
                        }
                    }
                },
                error: function (xhr) {
                    if (xhr.status === 401) {
                        localStorage.setItem('redirectAfterLogin', window.location.href);
                        window.location.href = '/login';
                    } else {
                        showFavoriteModal('Error al procesar la solicitud', 'error', '');
                    }
                }
            });
        });
    });

    function showFavoriteModal(action, contentName, textAdded, textRemoved, msgAdded, msgRemoved, msgSuffix) {
        const modal = document.getElementById('modalFavoriteMessage') || createFavoriteModal();
        const modalTitle = modal.querySelector('.modal-title');
        const modalDescription = modal.querySelector('.modal-description');

        if (action === 'added') {
            modalTitle.textContent = textAdded;
            modalDescription.innerHTML = msgAdded + ' <strong>' + contentName + '</strong> ' + msgSuffix + '.';
        } else if (action === 'removed') {
            modalTitle.textContent = textRemoved;
            // Cambiar el msgSuffix a la versión en modo "removed"
            const msgSuffixRemoved = msgSuffix.replace('a tus', 'de tus').replace('to your', 'from your').replace('dans vos', 'de vos').replace('als teus', 'dels teus');
            modalDescription.innerHTML = msgRemoved + ' <strong>' + contentName + '</strong> ' + msgSuffixRemoved + '.';
        } else {
            modalTitle.textContent = 'Aviso';
            modalDescription.textContent = 'Error al procesar la solicitud';
        }

        const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
        bsModal.show();
    }

    function createFavoriteModal() {
        const modalHtml = `
            <div class="modal fade" id="modalFavoriteMessage" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-0">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body text-center">
                            <h5 class="modal-title mb-3"></h5>
                            <p class="modal-description"></p>
                        </div>
                        <div class="modal-footer border-0 justify-content-center gap-2">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Seguir navegando</button>
                            <button type="button" class="btn btn-primary" id="btnVerFavoritos">Ver favoritos</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const div = document.createElement('div');
        div.innerHTML = modalHtml;
        const modalElement = div.firstElementChild;
        document.body.appendChild(modalElement);

        // Event listener para "Ver favoritos"
        document.getElementById('btnVerFavoritos').addEventListener('click', function () {
            const favoritesUrl = document.querySelector('meta[name="favourites-url"]')?.getAttribute('content');
            if (favoritesUrl) {
                bootstrap.Modal.getInstance(document.getElementById('modalFavoriteMessage')).hide();
                window.location.href = favoritesUrl;
            } else {
                bootstrap.Modal.getInstance(document.getElementById('modalFavoriteMessage')).hide();
            }
        });

        return document.getElementById('modalFavoriteMessage');
    }

    // Manejo especial para eliminar tarjetas de favoritos en la página de favoritos
    // Se dispara después de una acción de favorito en elementos con clase js-favorito-removable-card
    document.addEventListener('favoriteRemoved', function (e) {
        if (!e.detail) return;

        const button = e.detail.button;
        if (!button.classList.contains('js-favorito-removable-card')) return;

        // Obtener el elemento padre de la tarjeta
        const card = button.closest('.favorite-card');
        if (!card) return;

        const col = card.closest('.col-12');
        if (!col) return;

        // Eliminar la tarjeta
        col.remove();

        // Verificar si la sección está vacía
        const section = button.closest('.favoritos-section');
        if (section && section.querySelectorAll('.favorite-card').length === 0) {
            section.remove();
        }

        // Si no hay más favoritos, recargar la página para mostrar el mensaje de "sin favoritos"
        if (document.querySelectorAll('.favorite-card').length === 0) {
            setTimeout(function () {
                location.reload();
            }, 1500); // Esperar a que se cierre el modal (1.5 segundos)
        }
    });

    // if ($("#como-llegar").length) {
    //     console.log("Sección como-llegar detectada");
    //     initializeComoLLegarMap();
    // }else{
    //     console.log("Sección como-llegar NO detectada");
    // }
});

// Manejo de filtros en what-to-see-v3
document.addEventListener('DOMContentLoaded', function () {
    console.log('Inicializando manejo de filtros en what-to-see-v3');
    let module = document.getElementById('whatToSeeModuleV3');
    if (!module) {
        console.log('Módulo what-to-see-v3 no encontrado, saliendo.');
        return;
    }

    // Buscar elementos DENTRO del módulo whatToSeeModuleV3, no globalmente
    const toggleFiltersBtn = module.querySelector('#toggleFiltersBtn');
    const filtersPanel = module.querySelector('#filtersPanel');
    const applyFiltersBtn = module.querySelector('.js-applyFilters');
    const clearFiltersBtn = module.querySelector('.js-clearFilters');
    const searchInput = module.querySelector('.js-searchInput');
    const pageButtons = module.querySelectorAll('.js-pageButton');
    console.log("elementos encontrados en what-to-see-v3:", {
        toggleFiltersBtn,
        filtersPanel,
        applyFiltersBtn,
        clearFiltersBtn,
        pageButtons: pageButtons.length
    });

    // Función para obtener filtros guardados en sessionStorage
    function getStoredFilters() {
        const stored = sessionStorage.getItem('eventFilters');
        return stored ? JSON.parse(stored) : null;
    }

    // Función para guardar filtros en sessionStorage
    function storeFilters(filters) {
        sessionStorage.setItem('eventFilters', JSON.stringify(filters));
    }

    // Función para enviar formulario POST
    function submitFiltersForm(page = 1) {
        const storedFilters = getStoredFilters();

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = window.location.pathname;

        // Agregar token CSRF
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        // Agregar filtros si existen
        if (storedFilters) {
            ['filter', 'interest', 'accompaniment'].forEach(type => {
                if (storedFilters[type] && storedFilters[type].length > 0) {
                    storedFilters[type].forEach(value => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = type + '[]';
                        input.value = value;
                        form.appendChild(input);
                    });
                }
            });

            // Agregar fechas si existen
            if (storedFilters.date_from) {
                const dateFromInput = document.createElement('input');
                dateFromInput.type = 'hidden';
                dateFromInput.name = 'date_from';
                dateFromInput.value = storedFilters.date_from;
                form.appendChild(dateFromInput);
            }

            if (storedFilters.date_to) {
                const dateToInput = document.createElement('input');
                dateToInput.type = 'hidden';
                dateToInput.name = 'date_to';
                dateToInput.value = storedFilters.date_to;
                form.appendChild(dateToInput);
            }

            // Agregar término de búsqueda si existe
            if (storedFilters.search && storedFilters.search !== '') {
                const searchInputHidden = document.createElement('input');
                searchInputHidden.type = 'hidden';
                searchInputHidden.name = 'q';
                searchInputHidden.value = storedFilters.search;
                form.appendChild(searchInputHidden);
            }
        }

        // Agregar página
        const pageInput = document.createElement('input');
        pageInput.type = 'hidden';
        pageInput.name = 'page';
        pageInput.value = page;
        form.appendChild(pageInput);

        document.body.appendChild(form);
        form.submit();
    }

    // Restaurar estado de filtros al cargar la página
    function restoreFilters() {
        const storedFilters = getStoredFilters();

        if (storedFilters) {
            // Restaurar checkboxes marcados desde sessionStorage - CONTEXTO DEL MÓDULO
            module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
                const type = checkbox.dataset.type;
                const value = checkbox.value;

                if (storedFilters[type] && storedFilters[type].includes(value)) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            });

            // Restaurar fechas desde sessionStorage - CONTEXTO DEL MÓDULO
            if (storedFilters.date_from) {
                const dateFromInput = module.querySelector('#filterDateFrom');
                if (dateFromInput) {
                    dateFromInput.value = storedFilters.date_from;
                }
            }

            if (storedFilters.date_to) {
                const dateToInput = module.querySelector('#filterDateTo');
                if (dateToInput) {
                    dateToInput.value = storedFilters.date_to;
                }
            }

                // Restaurar búsqueda
                if (storedFilters.search && searchInput) {
                    searchInput.value = storedFilters.search;
                }

            // Mostrar panel si hay filtros activos
            if (filtersPanel) {
                filtersPanel.style.display = 'block';
                if (toggleFiltersBtn) {
                    toggleFiltersBtn.classList.add('active');
                }
            }

            // poner clase de filtros activos en listView y mapView - CONTEXTO DEL MÓDULO
            let listView = module.querySelector('#listView');
            let mapView = module.querySelector('#mapView');
            if (listView) {
                listView.classList.add('with-filters');
            }
            if (mapView) {
                mapView.classList.add('with-filters');
            }
        }
    }

    // Si la página se cargó vía GET (navegación normal), limpiar filtros guardados
    const isPostRequest = module.querySelector('#isPostRequest')?.value === '1';
    if (!isPostRequest) {
        sessionStorage.removeItem('eventFilters');
    }

    // Restaurar filtros al cargar
    restoreFilters();

    // Mostrar/ocultar panel de filtros
    if (toggleFiltersBtn && filtersPanel) {
        toggleFiltersBtn.addEventListener('click', function () {
            console.log('Toggle filters panel en what-to-see-v3');
            let listView = module.querySelector('#listView');
            let mapView = module.querySelector('#mapView');

            if (filtersPanel.style.display === 'none' || filtersPanel.style.display === '') {
                filtersPanel.style.display = 'block';
                toggleFiltersBtn.classList.add('active');
                if (listView) listView.classList.add('with-filters');
                if (mapView) mapView.classList.add('with-filters');

            } else {
                filtersPanel.style.display = 'none';
                toggleFiltersBtn.classList.remove('active');
                if (listView) listView.classList.remove('with-filters');
                if (mapView) mapView.classList.remove('with-filters');
            }
        });
    }

    // Aplicar filtros
    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function () {
            const selectedFilters = {
                filter: [],
                interest: [],
                accompaniment: [],
                date_from: '',
                date_to: '',
                search: ''
            };

            // Recopilar checkboxes seleccionados - CONTEXTO DEL MÓDULO
            module.querySelectorAll('.js-filterCheckbox:checked').forEach(checkbox => {
                const type = checkbox.dataset.type;
                console.log('Checkbox seleccionado:');
                console.log(" Type: " + type + ", Value: " + checkbox.value);
                selectedFilters[type].push(checkbox.value);
            });

            // Recopilar fechas - CONTEXTO DEL MÓDULO
            const dateFromInput = module.querySelector('#filterDateFrom');
            const dateToInput = module.querySelector('#filterDateTo');

            if (dateFromInput && dateFromInput.value) {
                selectedFilters.date_from = dateFromInput.value;
            }
            if (dateToInput && dateToInput.value) {
                selectedFilters.date_to = dateToInput.value;
            }

            // Recopilar búsqueda
            if (searchInput && searchInput.value) {
                selectedFilters.search = searchInput.value.trim();
            }

            const hasFilters = selectedFilters.filter.length > 0 ||
                selectedFilters.interest.length > 0 ||
                selectedFilters.accompaniment.length > 0 ||
                selectedFilters.date_from !== '' ||
                selectedFilters.date_to !== '' ||
                (selectedFilters.search && selectedFilters.search !== '');

            if (!hasFilters) {
                alert('Por favor selecciona al menos un filtro');
                return;
            }

            // Guardar filtros en sessionStorage
            storeFilters(selectedFilters);

            // Enviar formulario
            submitFiltersForm(1);
        });
    }

    // Limpiar filtros
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', function () {
            module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
                checkbox.checked = false;
            });

            // Limpiar campos de fecha - CONTEXTO DEL MÓDULO
            const dateFromInput = module.querySelector('#filterDateFrom');
            const dateToInput = module.querySelector('#filterDateTo');
            if (dateFromInput) dateFromInput.value = '';
            if (dateToInput) dateToInput.value = '';

            // Limpiar búsqueda - CONTEXTO DEL MÓDULO
            if (searchInput) searchInput.value = '';

            // Limpiar sessionStorage
            sessionStorage.removeItem('eventFilters');

            // Enviar formulario sin filtros
            submitFiltersForm(1);
        });
    }

    // Manejar clics en botones de paginación - CONTEXTO DEL MÓDULO
    pageButtons.forEach(button => {
        button.addEventListener('click', function () {
            const page = this.getAttribute('data-page');
            submitFiltersForm(page);
        });
    });

    // When clicking on a filter, we will click the "Apply Filters" button - CONTEXTO DEL MÓDULO
    module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            if (applyFiltersBtn) {
                applyFiltersBtn.click();
            }
        });
    });

    // Manejar búsqueda: enviar al salir del input o pulsar Enter
    if (searchInput) {
        searchInput.addEventListener('blur', function () {
            const val = this.value.trim();
            const stored = getStoredFilters() || { filter: [], interest: [], accompaniment: [], date_from: '', date_to: '', search: '' };
            stored.search = val;
            storeFilters(stored);
            submitFiltersForm(1);
        });

        searchInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.blur();
            }
        });
    }
});

// Manejo de filtros en upcoming-events-v3
document.addEventListener('DOMContentLoaded', function () {
    let module = document.getElementById('upcomingEventsModuleV3');
    if (!module) {
        return;
    }

    const toggleFiltersBtn = module.querySelector('#toggleFiltersBtn');
    const filtersPanel = module.querySelector('#filtersPanel');
    const applyFiltersBtn = module.querySelector('.js-applyFilters');
    const clearFiltersBtn = module.querySelector('.js-clearFilters');
    const pageButtons = module.querySelectorAll('.js-pageButton');

    const STORAGE_KEY = 'upcomingEventFilters';

    function getStoredFilters() {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
    }

    function storeFilters(filters) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
    }

    function submitFiltersForm(page) {
        page = page || 1;
        const storedFilters = getStoredFilters();

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = window.location.pathname;

        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        if (storedFilters) {
            ['filter', 'interest', 'accompaniment'].forEach(function (type) {
                if (storedFilters[type] && storedFilters[type].length > 0) {
                    storedFilters[type].forEach(function (value) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = type + '[]';
                        input.value = value;
                        form.appendChild(input);
                    });
                }
            });
        }

        const pageInput = document.createElement('input');
        pageInput.type = 'hidden';
        pageInput.name = 'page';
        pageInput.value = page;
        form.appendChild(pageInput);

        document.body.appendChild(form);
        form.submit();
    }

    function restoreFilters() {
        const storedFilters = getStoredFilters();
        if (storedFilters) {
            module.querySelectorAll('.js-filterCheckbox').forEach(function (checkbox) {
                const type = checkbox.dataset.type;
                const value = checkbox.value;
                checkbox.checked = !!(storedFilters[type] && storedFilters[type].includes(value));
            });

            if (filtersPanel) {
                filtersPanel.style.display = 'block';
                if (toggleFiltersBtn) toggleFiltersBtn.classList.add('active');
                let listView = module.querySelector('#listView');
                let mapView = module.querySelector('#mapView');
                if (listView) listView.classList.add('with-filters');
                if (mapView) mapView.classList.add('with-filters');
            }
        }
    }

    const isPostRequest = module.querySelector('#isPostRequest') && module.querySelector('#isPostRequest').value === '1';
    if (!isPostRequest) {
        sessionStorage.removeItem(STORAGE_KEY);
    }

    restoreFilters();

    if (toggleFiltersBtn && filtersPanel) {
        toggleFiltersBtn.addEventListener('click', function () {
            let listView = module.querySelector('#listView');
            let mapView = module.querySelector('#mapView');
            if (filtersPanel.style.display === 'none' || filtersPanel.style.display === '') {
                filtersPanel.style.display = 'block';
                toggleFiltersBtn.classList.add('active');
                if (listView) listView.classList.add('with-filters');
                if (mapView) mapView.classList.add('with-filters');
            } else {
                filtersPanel.style.display = 'none';
                toggleFiltersBtn.classList.remove('active');
                if (listView) listView.classList.remove('with-filters');
                if (mapView) mapView.classList.remove('with-filters');
            }
        });
    }

    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function () {
            const selectedFilters = { filter: [], interest: [], accompaniment: [] };
            module.querySelectorAll('.js-filterCheckbox:checked').forEach(function (checkbox) {
                selectedFilters[checkbox.dataset.type].push(checkbox.value);
            });

            const hasFilters = selectedFilters.filter.length > 0 ||
                selectedFilters.interest.length > 0 ||
                selectedFilters.accompaniment.length > 0;

            if (!hasFilters) {
                alert('Por favor selecciona al menos un filtro');
                return;
            }

            storeFilters(selectedFilters);
            submitFiltersForm(1);
        });
    }

    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', function () {
            module.querySelectorAll('.js-filterCheckbox').forEach(function (checkbox) {
                checkbox.checked = false;
            });
            sessionStorage.removeItem(STORAGE_KEY);
            submitFiltersForm(1);
        });
    }

    pageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            submitFiltersForm(this.getAttribute('data-page'));
        });
    });

    module.querySelectorAll('.js-filterCheckbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            if (applyFiltersBtn) applyFiltersBtn.click();
        });
    });
});

// SECTIONTAGS-V3: Sistema de filtros y búsqueda
document.addEventListener("DOMContentLoaded", () => {
    console.log("Inicializando filtros y búsqueda en sectiontags-v3");
    const searchInput = document.getElementById("search-input-card");
    const applyFiltersBtn = document.querySelector('.js-applyFilters');


    // No abortar si no estamos en sectiontags-v3 (modo totem puede omitir el input)
    if (!searchInput) {
        console.log("No se encontró el input de búsqueda. Inicializando filtros sin search input (totem mode?).");
    }

    function applyFiltersAndSearch() {
        console.log("Aplicando filtros y búsqueda...");

        const tagFilters = document.querySelectorAll(".tag-filter"); // Obtener dinámicamente
        const zoneFilters = document.querySelectorAll(".zone-filter"); // Obtener dinámicamente
        const selectedTags = Array.from(tagFilters)
            .filter(f => f.checked)
            .map(f => f.dataset.tagName);
        const selectedZones = Array.from(zoneFilters)
            .filter(f => f.checked)
            .map(f => String(f.dataset.zoneId));

        console.log("Selected Tags:", selectedTags);
        console.log("Selected Zones:", selectedZones);
        console.log("Search Term:", (searchInput ? searchInput.value : ''));

        const searchTerm = (searchInput ? searchInput.value : '').toLowerCase().trim();
        let visibleCount = 0;

        // Aplicar filtros a las tarjetas
        document.querySelectorAll(".card-item").forEach((card, idx) => {
            const cardName = (card.dataset.name || "").toLowerCase().trim();
            const cardTags = JSON.parse(card.dataset.tags || "[]");
            const cardZones = JSON.parse(card.dataset.zones || "[]");
            const cardDescription = (card.textContent || "").toLowerCase().trim();
            const cardCountry = (card.dataset.addressCountry || "").toLowerCase().trim();
            const cardProvince = (card.dataset.addressProvince || "").toLowerCase().trim();
            const cardLocality = (card.dataset.addressLocality || "").toLowerCase().trim();


            // Filtro de búsqueda - incluir campos de dirección (solo si no está vacío)
            let matchesSearch = true;
            if (searchTerm.length > 0) {
                matchesSearch =
                    cardName.indexOf(searchTerm) !== -1 ||
                    cardDescription.indexOf(searchTerm) !== -1 ||
                    (cardCountry.length > 0 && cardCountry.indexOf(searchTerm) !== -1) ||
                    (cardProvince.length > 0 && cardProvince.indexOf(searchTerm) !== -1) ||
                    (cardLocality.length > 0 && cardLocality.indexOf(searchTerm) !== -1);
            }

            // Filtro de tags
            const matchesTags = selectedTags.length === 0 || cardTags.some(t => selectedTags.includes(t));

            // Filtro de zonas
            const matchesZones = selectedZones.length === 0 || cardZones.some(z => selectedZones.includes(z));

            console.log("Evaluando tarjeta:", card);
            console.log(`matchesSearch: ${matchesSearch}, matchesTags: ${matchesTags}, matchesZones: ${matchesZones}`);

            if (matchesSearch && matchesTags && matchesZones) {
                card.classList.remove("hidden");
                card.removeAttribute('style');

                visibleCount++;
            } else {
                card.classList.add("hidden");
            }
        });

        setTimeout(() => {
            const visibleCards = document.querySelectorAll(".card-item:not(.hidden)");
        }, 100);


        window.dispatchEvent(new CustomEvent("sectionTagsFilter", {
            detail: { selectedTags, selectedZones, searchTerm }
        }));

    }

    // Event listeners - búsqueda (si existe el input)
    if (searchInput) {
        searchInput.addEventListener("input", (e) => {
            console.log("Input event fired on search-input:", e.target.value);
            applyFiltersAndSearch();

            // Observar cambios en las primeras 2 cards después de filtrar
            setTimeout(() => {
                const cards = document.querySelectorAll(".card-item");
                for (let i = 0; i < Math.min(2, cards.length); i++) {
                    const card = cards[i];
                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.attributeName === 'style') {
                                /* debug helper */
                            }
                        });
                    });

                    observer.observe(card, {
                        attributes: true,
                        attributeFilter: ['style']
                    });

                    // Desconectar después de 2 segundos
                    setTimeout(() => observer.disconnect(), 2000);
                }
            }, 50);
        });

        searchInput.addEventListener("blur", (e) => {
            // Monitorear el DOM después del blur
            setTimeout(() => {
                const visibleCards = document.querySelectorAll(".card-item:not(.hidden)");
                const allCards = document.querySelectorAll(".card-item");

                for (let i = 0; i < Math.min(2, allCards.length); i++) {
                    const card = allCards[i];
                    // debug helper
                }
            }, 50);
        });
    }

    // Escuchar cambios en checkboxes también
    document.addEventListener("change", (e) => {
        if (e.target.classList.contains("tag-filter")) {
            console.log("Tag filter changed:", e.target.dataset.tagName);
            applyFiltersAndSearch();
            if (applyFiltersBtn) {
                applyFiltersBtn.click();
            }
        }
        if (e.target.classList.contains("zone-filter")) {
            console.log("Zone filter changed:", e.target.dataset.zoneId);
            applyFiltersAndSearch();
            if (applyFiltersBtn) {
                applyFiltersBtn.click();
            }
        }
    });

    // Delegated click handler on sidebar to support environments where clicks
    // are intercepted (kiosk/totem). This ensures label clicks toggle the
    // corresponding checkbox and that filters are applied.
    const filtersSidebar = document.getElementById('filters-sidebar');
    if (filtersSidebar) {
        filtersSidebar.addEventListener('click', function(evt) {
            const clickedLabel = evt.target.closest('label');
            const clickedCheckbox = evt.target.closest('input[type="checkbox"]');

            // If user clicked a label, try to find linked checkbox by 'for' attr
            if (clickedLabel && !clickedCheckbox) {
                const forAttr = clickedLabel.getAttribute('for');
                if (forAttr) {
                    const cb = document.getElementById(forAttr);
                    if (cb && cb.type === 'checkbox') {
                        // Toggle checkbox and trigger change
                        cb.checked = !cb.checked;
                        cb.dispatchEvent(new Event('change', { bubbles: true }));
                        evt.preventDefault();
                        return;
                    }
                }
            }

            // If clicked directly on the checkbox input, ensure change handler runs
            if (clickedCheckbox) {
                // let native change event fire; but in some environments it may not,
                // so re-dispatch change to be safe
                setTimeout(() => {
                    clickedCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                }, 0);
            }
        }, true); // use capture to run before other handlers
    }

    // Manejador para el botón "Borrar filtros"
    const clearFiltersBtn = document.getElementById("clear-filters");
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener("click", function() {
            console.log("Limpiando todos los filtros...");
            
            // Limpiar todos los checkboxes de tags
            document.querySelectorAll(".tag-filter").forEach(checkbox => {
                checkbox.checked = false;
            });
            
            // Limpiar todos los checkboxes de zonas
            document.querySelectorAll(".zone-filter").forEach(checkbox => {
                checkbox.checked = false;
            });
            
            // Limpiar input de búsqueda
            if (searchInput) {
                searchInput.value = "";
            }
            
            // Aplicar filtros nuevamente
            applyFiltersAndSearch();
            
            if (applyFiltersBtn) {
                applyFiltersBtn.click();
            }
        });
    }
});

/**
 * Event Annual Image Gallery - Intercambia imágenes grandes y miniaturas
 * Usando delegación de eventos para funcionar con contenido cargado dinámicamente
 */
// DISTRIBUIDORAS-V3 PLACES: Filtro sidebar por tipología y zonas
document.addEventListener("DOMContentLoaded", () => {
    const module = document.getElementById("distribuidorasPlacesModule");
    if (!module) return;

    const sidebar = document.getElementById("filters-sidebar-places");
    const toggleBtn = document.getElementById("toggleFiltersPlacesBtn");
    const clearBtn = document.getElementById("clear-filters-places");
    const cardsContainer = document.getElementById("places-cards-container");

    // Toggle sidebar
    if (toggleBtn && sidebar) {
        toggleBtn.addEventListener("click", function () {
            if (sidebar.style.display === "none" || sidebar.style.display === "") {
                sidebar.style.display = "block";
                toggleBtn.classList.add("active");
                cardsContainer?.classList.add("with-filters");
            } else {
                sidebar.style.display = "none";
                toggleBtn.classList.remove("active");
                cardsContainer?.classList.remove("with-filters");
            }
        });
    }

    function applyPlacesFilters() {
        const selectedTags = Array.from(module.querySelectorAll(".dist-tag-filter:checked"))
            .map(f => String(f.dataset.filterId));
        const selectedZones = Array.from(module.querySelectorAll(".dist-zone-filter:checked"))
            .map(f => String(f.dataset.zoneId));

        module.querySelectorAll(".card-item").forEach(card => {
            const cardFilters = JSON.parse(card.dataset.filterplaces || "[]");
            const cardZones   = JSON.parse(card.dataset.placezones   || "[]");

            const matchesTags  = selectedTags.length  === 0 || cardFilters.some(id => selectedTags.includes(String(id)));
            const matchesZones = selectedZones.length === 0 || cardZones.some(id => selectedZones.includes(String(id)));

            if (matchesTags && matchesZones) {
                card.classList.remove("hidden");
            } else {
                card.classList.add("hidden");
            }
        });
    }

    // Listeners checkboxes
    module.addEventListener("change", function (e) {
        if (e.target.classList.contains("dist-tag-filter") || e.target.classList.contains("dist-zone-filter")) {
            applyPlacesFilters();
        }
    });

    // Borrar filtros
    if (clearBtn) {
        clearBtn.addEventListener("click", function () {
            module.querySelectorAll(".dist-tag-filter, .dist-zone-filter").forEach(cb => { cb.checked = false; });
            applyPlacesFilters();
        });
    }
});

/**
 * Event Annual Image Gallery - Intercambia imágenes grandes y miniaturas
 * Usando delegación de eventos para funcionar con contenido cargado dinámicamente
 */
document.addEventListener('click', function (e) {
    const thumbnail = e.target.closest('.thumbnail-item');
    if (!thumbnail) return;

    const gallery = thumbnail.closest('.event-image-gallery-annual');
    if (!gallery) return;

    const mainImage = gallery.querySelector('.main-image');
    const imageTitle = gallery.querySelector('.image-title');
    const thumbnailItems = gallery.querySelectorAll('.thumbnail-item');

    const imageUrl = thumbnail.getAttribute('data-image-url');
    const currentMainUrl = mainImage.style.backgroundImage.match(/url\("?([^"]*)"?\)/)[1];
    const currentThumbnailUrl = thumbnail.getAttribute('data-image-url');

    // Intercambiar la imagen principal con la miniatura
    mainImage.style.backgroundImage = `url('${currentThumbnailUrl}')`;
    thumbnail.style.backgroundImage = `url('${currentMainUrl}')`;

    // Actualizar el título de la imagen
    if (imageTitle) {
        const newTitle = thumbnail.getAttribute('data-image-title') || '';
        imageTitle.textContent = newTitle;
    }

    // Actualizar el borde de la miniatura activa
    thumbnailItems.forEach(item => {
        item.style.borderColor = 'transparent';
    });
    thumbnail.style.borderColor = '#ff6b35';
});



function initializeComoLLegarMap() {
    console.log("initializeComoLLegarMap()");
    // this will be a simple map that will tell you how to get to Ponferrada city center from a given point
    let startingPoint = $("#starting-point").data("coordinates") || [-5.66388, 42.48632]; // default to Ponferrada city center

    const comoLlegarMap = new mapbox.Map({
        container: "como-llegar-map",
        style: "mapbox://styles/mapbox/streets-v12",
        center: startingPoint,
        zoom: 10,
        accessToken: accessToken,
    });

    comoLlegarMap.addControl(
        new MapboxGeocoder({
            accessToken: accessToken,
            mapboxgl: mapbox,
        })
    );

    const directionsControl = new MapboxDirections({
        accessToken: accessToken,
        unit: "metric",
        profile: "mapbox/driving-traffic",
        interactive: true,
        controls: {
            inputs: true,
            instructions: true,
        },
    });

    comoLlegarMap.addControl(directionsControl, "top-left");

    // Set destination to Ponferrada city center
    directionsControl.setDestination([-5.66388, 42.48632]);

    // Set starting point
    directionsControl.setOrigin(startingPoint);
}

// ============================================================================
// LANGUAGE SELECTOR - Preserve current URL when changing language
// ============================================================================
document.addEventListener('DOMContentLoaded', function () {
    // Get available locale codes from data attribute or meta tag
    const languageCodesElement = document.querySelector('[data-language-codes]');
    const availableLocaleCodes = languageCodesElement
        ? JSON.parse(languageCodesElement.getAttribute('data-language-codes'))
        : [];

    const currentLocale = languageCodesElement
        ? languageCodesElement.getAttribute('data-current-locale')
        : (document.documentElement.lang || document.querySelector('html').getAttribute('data-locale') || 'es');

    function stripLocalePrefix(pathname) {
        const segments = pathname.split('/');
        if (segments[0] === '') {
            segments.shift();
        }
        if (segments.length > 0 && availableLocaleCodes.includes(segments[0])) {
            segments.shift();
        }
        return '/' + segments.join('/');
    }

    const langOptions = document.querySelectorAll('.lang-option');
    if (langOptions.length) {
        langOptions.forEach(option => {
            option.addEventListener('click', function (event) {
                if (option.classList.contains('active')) {
                    return;
                }

                event.preventDefault();

                const fullPathname = window.location.pathname;
                const cleanPathname = stripLocalePrefix(fullPathname);
                const queryString = window.location.search;
                const currentPath = cleanPathname + queryString;

                const langCode = option.getAttribute('data-lang-code');
                const targetUrl = '/' + langCode + '?redirect_to=' + encodeURIComponent(currentPath) + '&from_locale=' + currentLocale;

                window.location.href = targetUrl;
            });
        });
    }
});

// Modal para ver imágenes ampliadas
$(document).on('click', '.js-open-image-modal', function (e) {
    e.preventDefault();
    const imageSrc = $(this).data('image-src');
    $('#modalImage').attr('src', imageSrc);
    const imageModal = new bootstrap.Modal(document.getElementById('imageModal'));
    imageModal.show();
});

// ============================================================
// Validación del formulario de contacto para Ponferrada
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
    const contactForm = document.getElementById('contactFormElement');
    
    if (contactForm && $('body').attr('data-theme-active') === 'ponferrada') {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            let errors = [];
            let firstName = document.getElementById('firstName').value.trim();
            let email = document.getElementById('email').value.trim();
            let message = document.getElementById('message').value.trim();
            
            // Obtener mensajes traducidos
            const msgs = window.contactValidationMessages || {
                nameMissing: 'Name is required',
                emailMissing: 'Email is required',
                emailInvalid: 'Invalid email format',
                messageMissing: 'Message is required'
            };

            // Validar nombre
            if (!firstName) {
                errors.push(msgs.nameMissing);
            }

            // Validar email
            if (!email) {
                errors.push(msgs.emailMissing);
            } else if (!validateEmail(email)) {
                errors.push(msgs.emailInvalid);
            }

            // Validar mensaje
            if (!message) {
                errors.push(msgs.messageMissing);
            }

            if (errors.length > 0) {
                // Mostrar errores en el contenedor
                let errorList = document.getElementById('contactValidationList');
                if (errorList) {
                    errorList.innerHTML = '';
                    errors.forEach(function(error) {
                        let li = document.createElement('li');
                        li.textContent = error;
                        errorList.appendChild(li);
                    });
                    let errorMessage = document.getElementById('contactValidationMessage');
                    if (errorMessage) {
                        errorMessage.classList.remove('d-none');
                    }
                }
            } else {
                // Si está bien, ocultar errores y enviar el formulario
                let errorMessage = document.getElementById('contactValidationMessage');
                if (errorMessage) {
                    errorMessage.classList.add('d-none');
                }
                contactForm.submit();
            }
        });
    }
});

// ============================================================
// Mark/Unmark All filters functionality
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
    const markAllButtons = document.querySelectorAll('.btn-mark-all');
    
    markAllButtons.forEach(button => {
        button.addEventListener('click', handleMarkAllClick);
    });
});

/**
 * Handle mark all button click
 * @param {Event} e - Click event
 */
function handleMarkAllClick(e) {
    e.preventDefault();
    
    const button = e.currentTarget;
    const targetId = button.dataset.target;
    const container = document.getElementById(targetId);
    
    if (!container) return;
    
    // Get all checkboxes in the container (excluding the first filters div with the button)
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    
    // Check if all are currently checked
    const allChecked = Array.from(checkboxes).every(cb => cb.checked);
    
    // Toggle state
    checkboxes.forEach(checkbox => {
        checkbox.checked = !allChecked;
    });
    
    // Get translations from data attributes or use defaults
    const markAllText = button.getAttribute('data-mark-all') || 'Marcar todos';
    const unmarkAllText = button.getAttribute('data-unmark-all') || 'Desmarcar todos';
    
    // Update button text
    const newText = allChecked ? markAllText : unmarkAllText;
    button.textContent = newText;
}

// ============================================================================
// Handle clicks on swiper slides with links (banner links)
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
    const swiperSlideLinks = document.querySelectorAll('.swiper-slide-link');
    
    if (swiperSlideLinks.length) {
        swiperSlideLinks.forEach(link => {
            link.style.cursor = 'pointer';
            
            // Make the entire slide clickable
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const href = this.getAttribute('href');
                if (href) {
                    window.open(href, '_blank');
                }
            });
        });
    }
});

// ============================================================================
// Modal Aviso No Planes - Show on session flag
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
    // Check if there's a session flag to show the modal
    const hasSessionShowModal = document.body.dataset.showModalAvisoNoPlanes === 'true' || 
                                (window.showModalAvisoNoPlanes !== undefined && window.showModalAvisoNoPlanes === true);
    
    if (hasSessionShowModal) {
        const modalElement = document.getElementById('modalAvisoNoPlanes');
        if (modalElement) {
            // Initialize Bootstrap Modal and show it
            const bsModal = new bootstrap.Modal(modalElement);
            bsModal.show();
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {

    var cards = document.querySelectorAll('.js-click-card');

    cards.forEach(function(card) {

        var links = card.querySelectorAll('a[href]');
        var link = Array.from(links).find(function(anchor) {
            return !Array.from(anchor.classList).some(function(className) {
                return className.startsWith('js-');
            });
        });
        if (!link) return;

        card.style.cursor = 'pointer';

        card.addEventListener('click', function(e) {

            // Si el click ya fue en un enlace, no hacemos nada
            if (e.target.closest('a')) return;

            var url = link.getAttribute('href');
            var target = link.getAttribute('target');

            // Soporte para Ctrl/Cmd click (abrir en nueva pestaña)
            if (e.ctrlKey || e.metaKey || target === '_blank') {
                window.open(url, '_blank');
            } else {
                window.location.href = url;
            }

        });

    });

});

/**
 * Inicializar Swiper para Filter Buttons
 */
document.addEventListener('DOMContentLoaded', function() {
    const swiperFilterButtons = document.querySelector('.swiperFilterButtons');
    
    if (swiperFilterButtons) {
        new Swiper('.swiperFilterButtons', {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                //nextEl: '.swiperFilterButtons .swiper-button-next',
                //prevEl: '.swiperFilterButtons .swiper-button-prev',
            }
        });
    }
    
    // Inicializar filtros DESPUÉS del swiper
    const filterButtonsContainer = document.querySelector('#filter-buttons');
    const items = document.querySelectorAll('.js-itemfilter');
    
    if (filterButtonsContainer && items.length > 0) {
        const buttons = filterButtonsContainer.querySelectorAll('button');

        buttons.forEach(button => {
            button.addEventListener('click', function () {
                const selectedId = this.getAttribute('data-filter');
                
                // Actualizar clase active
                buttons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
                
                // Filtrar items
                items.forEach(item => {
                    const filterAttr = item.getAttribute('data-filterevent');
                    // v3: el item ES el elemento a ocultar (todos comparten un único js-divFiltro)
                    // v2: hay que ocultar el wrapper col (js-divFiltro individual por tarjeta)
                    // Usamos setProperty con 'important' para sobrescribir reglas CSS con !important
                    const target = item.classList.contains('v3')
                        ? item
                        : (item.closest('.js-divFiltro') || item);

                    const show = () => target.style.removeProperty('display');
                    const hide = () => target.style.setProperty('display', 'none', 'important');

                    if (!filterAttr || filterAttr.trim() === '') {
                        selectedId === 'all' ? show() : hide();
                        return;
                    }

                    const itemFilters = filterAttr.split(',').map(id => id.trim());

                    if (selectedId === 'all' || itemFilters.includes(String(selectedId))) {
                        show();
                    } else {
                        hide();
                    }
                });
            });
        });
    }
});

// Trigger click on the inner link when clicking on .js-trigger-click or .js-trigger-totem cards
document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        const triggerEl = e.target.closest('.js-trigger-click, .js-trigger-totem');
        if (!triggerEl) return;

        // If the click originated inside an interactive element...
        const interactive = e.target.closest('a, button, input, label');
        if (interactive) {
            // If it's a favorito control (or inside one), do nothing (skip trigger)
            if (interactive.closest('.js-favorito')) return;
            // Otherwise let the native element handle the click
            return;
        }

        // Find the first clickable element inside the trigger that is NOT a favorito
        const candidates = Array.from(triggerEl.querySelectorAll('a[href], button, input, label'));
        const candidate = candidates.find(el => !el.closest('.js-favorito'));
        if (candidate) {
            candidate.click();
            return;
        }

        // Fallback: click the first link if any
        const link = triggerEl.querySelector('a[href]');
        if (link) link.click();
    });
});

// Modal de guías oficiales
document.addEventListener('DOMContentLoaded', function () {
    const modalEl = document.getElementById('modalGuide');
    if (!modalEl) return;

    const guideModal = new bootstrap.Modal(modalEl);

    document.addEventListener('click', function (e) {
        const card = e.target.closest('.guide-card-trigger');
        if (!card) return;

        const name     = card.dataset.guideName    || '';
        const image    = card.dataset.guideImage   || '';
        const link     = card.dataset.guideLink    || '';
        const email    = card.dataset.guideEmail   || '';
        const phone    = card.dataset.guidePhone   || '';
        const langs    = JSON.parse(card.dataset.guideLanguages || '[]');

        document.getElementById('guideModalName').textContent = name;
        document.getElementById('guideModalImage').src = image;
        document.getElementById('guideModalImage').alt = name;

        const linkEl = document.getElementById('guideModalLink');
        linkEl.innerHTML = link
            ? `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`
            : '';

        const langsEl = document.getElementById('guideModalLanguages');
        if (langs.length) {
            let html = '<strong>Idiomas</strong><div class="guide-modal-langs mt-1">';
            langs.forEach(l => {
                if (l.icon) {
                    html += `<img src="${l.icon}" alt="${l.name}" title="${l.name}" class="guide-modal-lang-icon">`;
                } else {
                    html += `<span class="guide-modal-lang-name">${l.name}</span>`;
                }
            });
            html += '</div>';
            langsEl.innerHTML = html;
        } else {
            langsEl.innerHTML = '';
        }

        const emailEl = document.getElementById('guideModalEmail');
        emailEl.innerHTML = email
            ? `<span class="guide-modal-icon">✉</span> Email: <a href="mailto:${email}">${email}</a>`
            : '';

        const phoneEl = document.getElementById('guideModalPhone');
        phoneEl.innerHTML = phone
            ? `<span class="guide-modal-icon">📞</span> Teléfono: <a href="tel:${phone}">${phone}</a>`
            : '';

        guideModal.show();
    });
});

// Página de vídeos de Ponferrada

document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector(".one-slide-video.test-video-page");
    if (!root) return;

    document.body.classList.add("has-test-video-page");

    const MOBILE_BREAKPOINT = 768;
    const ASSET_BASE = `/storage/images/front/theme_${themeActive}/`;

    // Build dynamic maps from panel dataset attributes (populated in blade)
    function buildModuleMaps() {
        const vDesktop = {};
        const vMobile = {};
        const cDesktop = {};
        const cMobile = {};

        panels.forEach(panel => {
            const key = panel.dataset.key;
            if (!key) return;
            vDesktop[key] = panel.dataset.videoDesktop || '';
            vMobile[key] = panel.dataset.videoMobile || '';
            cDesktop[key] = panel.dataset.imageDesktop || '';
            cMobile[key] = panel.dataset.imageMobile || '';
        });

        return { vDesktop, vMobile, cDesktop, cMobile };
    }

    // moduleMaps se inicializa tras declarar `panels` más abajo

    const iconSoundOn = `${ASSET_BASE}icon-on.svg`;
    const iconSoundOff = `${ASSET_BASE}icon-off.svg`;

    const ICON_PLAY = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 5.14v13.72c0 .72.78 1.17 1.4.8l10.1-6.86a.93.93 0 0 0 0-1.6L9.4 4.34A.93.93 0 0 0 8 5.14Z"/>
        </svg>`;

    const ICON_PAUSE = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 5h3.5v14H7zm6.5 0H17v14h-3.5z"/>
        </svg>`;

    const COUNTDOWN_SECONDS = 10;
    const COUNTDOWN_RING_RADIUS = 9;
    const COUNTDOWN_RING_CIRCUMFERENCE = 2 * Math.PI * COUNTDOWN_RING_RADIUS;

    const experience = document.getElementById("experience");
    const panels = [...document.querySelectorAll(".panel")];
    let moduleMaps = buildModuleMaps();
    const navButtons = [...document.querySelectorAll(".side-nav button")];
    const soundToggle = document.getElementById("soundToggle");
    const videoProgress = document.getElementById("videoProgress");
    const videoProgressFill = document.getElementById("videoProgressFill");
    const countdownOverlay = document.getElementById("countdownOverlay");
    const countdownRingProgress = document.getElementById("countdownRingProgress");
    const countdownPill = document.querySelector(".countdown-pill");
    const footerRevealSpace = document.querySelector(".footer-reveal-space");
    const footerScrollHitbox = document.getElementById("footerScrollHitbox");
    const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

    const panelState = new Map();
    let activeIndex = 0;
    let isAutoScrolling = false;
    let wheelLock = false;
    let touchStartY = 0;
    let soundEnabled = false;
    let isMobileView = mobileQuery.matches;
    let countdownAdvanceLock = false;
    let liveUiFrame = null;

    const TITLE_HOLD_MS = 1900;
    const TITLE_SLIDE_MS = 520;
    const HINT_MS = 700;

    function getVideoMap() {
        return isMobileView ? moduleMaps.vMobile : moduleMaps.vDesktop;
    }

    function getCoverMap() {
        return isMobileView ? moduleMaps.cMobile : moduleMaps.cDesktop;
    }

    function getVideoSrc(key) {
        return getVideoMap()[key] || '';
    }

    function getCoverSrc(key) {
        return getCoverMap()[key] || '';
    }

    function getFooter() {
        return document.querySelector("footer.footer.footer-v3, footer.footer");
    }

    function getFooterHeight() {
        const footer = getFooter();
        return footer ? footer.offsetHeight || 0 : 0;
    }

    function updateCreditsForPanel(panel) {
        if (!panel) return;
        const creditsEl = document.querySelector('.credits');
        if (!creditsEl) return;
        const links = creditsEl.querySelectorAll('.credits-links .credit-link');
        const web = panel.dataset.creditsWeb || '';
        const instagram = panel.dataset.creditsInstagram || '';
        const tiktok = panel.dataset.creditsTiktok || '';
        const youtube = panel.dataset.creditsYoutube || '';
        const hrefs = [web, instagram, tiktok, youtube];

        links.forEach((a, i) => {
            const url = hrefs[i] || '';
            if (!url || url === '#') {
                a.style.display = 'none';
                a.setAttribute('aria-hidden', 'true');
            } else {
                a.style.display = '';
                a.removeAttribute('aria-hidden');
                a.href = url;
            }
        });

        const labelEl = creditsEl.querySelector('.credits-label');
        const name = panel.dataset.creditsName || '';
        const prefix = creditsEl.dataset.creditsPrefix || 'Vídeos cedidos por';
        if (labelEl) {
            if (name) {
                labelEl.innerHTML = `${prefix} <strong>${name}</strong>`;
                creditsEl.style.display = '';
            } else {
                // No hay nombre: ocultar label pero mantener links si existen
                labelEl.innerHTML = '';
                // If no links either, hide whole credits
                const anyLinkVisible = Array.from(links).some(a => a.style.display !== 'none');
                if (!anyLinkVisible) {
                    creditsEl.style.display = 'none';
                }
            }
        }
    }

    function updateFooterMetrics() {
        const footerHeight = getFooterHeight();
        document.documentElement.style.setProperty("--footer-space", `${footerHeight}px`);

        if (footerRevealSpace) {
            footerRevealSpace.style.height = `${footerHeight}px`;
            footerRevealSpace.style.minHeight = `${footerHeight}px`;
        }

        if (footerScrollHitbox) {
            footerScrollHitbox.style.height = `${footerHeight}px`;
        }

        updateFooterRevealFromScroll();
    }

    function updateFooterRevealFromScroll() {
        const footer = getFooter();
        if (!footer) return;

        const lastPanel = panels[panels.length - 1];
        const footerHeight = getFooterHeight();
        const extraScroll = Math.max(0, experience.scrollTop - lastPanel.offsetTop);
        const reveal = Math.max(0, Math.min(footerHeight, extraScroll));
        const hidden = Math.max(0, footerHeight - reveal);

        footer.style.setProperty("--footer-reveal", `${hidden}px`);
        footer.style.pointerEvents = reveal > 2 ? "auto" : "none";
        experience.classList.toggle("is-footer-zone", extraScroll > 0);

        if (footerScrollHitbox) {
            footerScrollHitbox.classList.toggle("is-active", reveal > 0);
        }
    }

    function bindFooterHitbox() {
        if (!footerScrollHitbox) return;

        footerScrollHitbox.addEventListener("wheel", (event) => {
            event.preventDefault();
            experience.scrollTop += event.deltaY;
        }, { passive: false });

        let hitboxTouchStartY = 0;
        let hitboxLastY = 0;

        footerScrollHitbox.addEventListener("touchstart", (event) => {
            hitboxTouchStartY = event.changedTouches[0].clientY;
            hitboxLastY = hitboxTouchStartY;
        }, { passive: true });

        footerScrollHitbox.addEventListener("touchmove", (event) => {
            const currentY = event.changedTouches[0].clientY;
            const delta = hitboxLastY - currentY;
            experience.scrollTop += delta;
            hitboxLastY = currentY;
            event.preventDefault();
        }, { passive: false });
    }

    function updateSoundButton() {
        soundToggle.innerHTML = `<img src="${soundEnabled ? iconSoundOn : iconSoundOff}" alt="">`;
        soundToggle.setAttribute("aria-label", soundEnabled ? "Desactivar sonido" : "Activar sonido");
        soundToggle.setAttribute("aria-pressed", soundEnabled ? "true" : "false");
    }

    function applyVideoAttributes(video) {
        video.autoplay = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.disablePictureInPicture = true;
        video.setAttribute("autoplay", "");
        video.setAttribute("muted", "");
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        video.setAttribute("loop", "");
        video.preload = isMobileView ? "auto" : "metadata";
    }

    function enableFallbackOnly(state) {
        state.requested = true;
        state.ready = true;
        state.failed = true;
        state.autoplayBlocked = false;
        state.titleDismissed = false;
        state.panel.classList.add("is-ready", "is-fallback-only");
        state.panel.classList.remove("is-buffering");
        maybeStartExperience(state);
    }

    function applyMediaVariant(state, { forceReload = false } = {}) {
        const nextVideoSrc = getVideoSrc(state.key);
        const nextCoverSrc = getCoverSrc(state.key);
        const nextPoster = nextCoverSrc;

        state.coverImage.src = nextCoverSrc;
        state.coverImage.alt = `Cover ${state.key}`;
        state.media.style.backgroundImage = `url("${nextCoverSrc}")`;
        state.video.poster = nextPoster;

        applyVideoAttributes(state.video);

        if (forceReload || state.video.dataset.currentSrc !== nextVideoSrc) {
            state.requested = false;
            state.ready = false;
            state.failed = false;
            state.autoplayBlocked = false;
            state.titleDismissed = false;
            state.panel.classList.remove("is-ready", "is-buffering", "cover-dismissed", "is-fallback-only");
            state.video.pause();
            state.video.removeAttribute("src");
            state.video.load();
            state.video.src = nextVideoSrc;
            state.video.dataset.currentSrc = nextVideoSrc;
        }
    }

    function initPanel(panel) {
        const key = panel.dataset.key;
        const media = panel.querySelector(".media");
        const video = panel.querySelector("video");
        const coverImage = panel.querySelector(".cover-image");
        const playbackHint = panel.querySelector(".playback-hint");

        const state = {
            key,
            panel,
            media,
            video,
            coverImage,
            playbackHint,
            requested: false,
            ready: false,
            failed: false,
            autoplayBlocked: false,
            titleDismissed: false,
            titleTimer: null,
            hintTimer: null,
            index: -1
        };

        applyMediaVariant(state, { forceReload: true });

        const markReady = () => {
            if (state.failed) return;
                    const cont = container.closest('.cont-swiper') || container.parentElement;
                    const nextEl = cont ? (cont.querySelector('.swiper-button-next-news') || cont.querySelector('.swiper-button-next')) : null;
                    const prevEl = cont ? (cont.querySelector('.swiper-button-prev-news') || cont.querySelector('.swiper-button-prev')) : null;
            panel.classList.remove("is-buffering");
            maybeStartExperience(state);
        };

        video.addEventListener("loadeddata", markReady);
        video.addEventListener("canplay", markReady);

        video.addEventListener("waiting", () => {
            if (state.index === activeIndex && !state.failed) panel.classList.add("is-buffering");
        });

        video.addEventListener("playing", () => {
            panel.classList.remove("is-buffering");
            if (state.index === activeIndex) {
                state.panel.classList.add("cover-dismissed");
            }
        });

        video.addEventListener("timeupdate", updateProgressUI);
        video.addEventListener("loadedmetadata", updateProgressUI);
        video.addEventListener("durationchange", updateProgressUI);
        video.addEventListener("seeked", updateProgressUI);
        video.addEventListener("ended", updateProgressUI);

        video.addEventListener("error", () => {
            enableFallbackOnly(state);
        });

        panel.addEventListener("click", (event) => {
            if (event.target.closest(".sound-toggle, .side-nav, .credits, .credit-link, .countdown-overlay")) return;
            if (state.failed) return;
            if (state.index !== activeIndex || !state.ready || !state.titleDismissed) return;

            if (video.paused) {
                playActive(state);
                showPlaybackHint(state, "play");
            } else {
                video.pause();
                showPlaybackHint(state, "pause");
            }
        });

        panelState.set(panel.id, state);
        return state;
    }

    function requestVideo(state) {
        if (!state || state.requested || state.failed) return;
        state.requested = true;
        state.video.load();
    }

    function getActiveState() {
        return panelState.get(panels[activeIndex]?.id);
    }

    function updateProgressUI() {
        const activeState = getActiveState();
        const video = activeState?.video;
        if (!video || !video.duration || !Number.isFinite(video.duration)) {
            videoProgressFill.style.width = "0%";
            videoProgress.setAttribute("aria-valuenow", "0");
            return;
        }

        const progress = Math.max(0, Math.min(100, (video.currentTime / video.duration) * 100));
        videoProgressFill.style.width = `${progress}%`;
        videoProgress.setAttribute("aria-valuenow", progress.toFixed(2));
    }

    function seekActiveVideo(clientX) {
        const activeState = getActiveState();
        const video = activeState?.video;
        if (!video || !video.duration || !Number.isFinite(video.duration)) return;

        const rect = videoProgress.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        video.currentTime = video.duration * ratio;
        updateProgressUI();
    }

    function bindVideoProgress() {
        if (!videoProgress) return;

        let isDraggingProgress = false;

        videoProgress.addEventListener("pointerdown", (event) => {
            isDraggingProgress = true;
            videoProgress.setPointerCapture?.(event.pointerId);
            seekActiveVideo(event.clientX);
            event.preventDefault();
        });

        videoProgress.addEventListener("pointermove", (event) => {
            if (!isDraggingProgress) return;
            seekActiveVideo(event.clientX);
            event.preventDefault();
        });

        const stopDragging = (event) => {
            if (!isDraggingProgress) return;
            seekActiveVideo(event.clientX);
            isDraggingProgress = false;
            if (event.pointerId != null) {
                videoProgress.releasePointerCapture?.(event.pointerId);
            }
        };

        videoProgress.addEventListener("pointerup", stopDragging);
        videoProgress.addEventListener("pointercancel", stopDragging);

        videoProgress.addEventListener("keydown", (event) => {
            const activeState = getActiveState();
            const video = activeState?.video;
            if (!video || !video.duration || !Number.isFinite(video.duration)) return;

            const step = Math.max(video.duration * 0.02, 1);

            if (event.key === "ArrowRight") {
                video.currentTime = Math.min(video.duration, video.currentTime + step);
                updateProgressUI();
                event.preventDefault();
            }

            if (event.key === "ArrowLeft") {
                video.currentTime = Math.max(0, video.currentTime - step);
                updateProgressUI();
                event.preventDefault();
            }
        });
    }

    function hideCountdownOverlay() {
        if (!countdownOverlay || !countdownRingProgress) return;
        countdownOverlay.classList.remove("is-visible");
        countdownOverlay.setAttribute("aria-hidden", "true");
        countdownRingProgress.style.strokeDasharray = `${COUNTDOWN_RING_CIRCUMFERENCE}`;
        countdownRingProgress.style.strokeDashoffset = "0";
    }

    function goToNextPanelLoop() {
        hideCountdownOverlay();
        goToPanel(activeIndex === panels.length - 1 ? 0 : activeIndex + 1);
    }

    function updateCountdownUI() {
        const activeState = getActiveState();
        const video = activeState?.video;

        if (!video || activeState?.failed || !activeState?.titleDismissed || !video.duration || !Number.isFinite(video.duration)) {
            countdownAdvanceLock = false;
            hideCountdownOverlay();
            return;
        }

        const remaining = Math.max(0, video.duration - video.currentTime);
        const shouldShowCountdown = !video.paused && remaining <= COUNTDOWN_SECONDS && remaining > 0.02;

        if (!shouldShowCountdown) {
            if (remaining > COUNTDOWN_SECONDS) {
                countdownAdvanceLock = false;
            }
            hideCountdownOverlay();
            return;
        }

        const visibleRatio = Math.max(0, Math.min(1, remaining / COUNTDOWN_SECONDS));
        const dashOffset = COUNTDOWN_RING_CIRCUMFERENCE * (1 - visibleRatio);

        countdownRingProgress.style.strokeDasharray = `${COUNTDOWN_RING_CIRCUMFERENCE}`;
        countdownRingProgress.style.strokeDashoffset = `${dashOffset}`;
        countdownOverlay.classList.add("is-visible");
        countdownOverlay.setAttribute("aria-hidden", "false");

        if (remaining <= 0.12 && !countdownAdvanceLock) {
            countdownAdvanceLock = true;
            goToNextPanelLoop();
        }
    }

    function startLiveUiLoop() {
        if (liveUiFrame) cancelAnimationFrame(liveUiFrame);

        const tick = () => {
            updateProgressUI();
            updateCountdownUI();
            liveUiFrame = requestAnimationFrame(tick);
        };

        tick();
    }

    function updateActiveNav() {
        navButtons.forEach((button, index) => {
            button.classList.toggle("is-current", index === activeIndex);
        });
    }

    function playActive(state) {
        if (state.failed) return;

        state.video.muted = !soundEnabled;
        state.video.defaultMuted = !soundEnabled;
        state.video.playsInline = true;
        state.video.setAttribute("playsinline", "");
        state.video.setAttribute("webkit-playsinline", "");

        const playPromise = state.video.play();

        if (playPromise && typeof playPromise.then === "function") {
            playPromise
                .then(() => {
                    state.autoplayBlocked = false;
                    if (state.index === activeIndex) {
                        state.panel.classList.add("cover-dismissed");
                    }
                })
                .catch(() => {
                    state.autoplayBlocked = true;
                    state.panel.classList.remove("is-buffering");
                    if (state.index === activeIndex) {
                        state.panel.classList.add("cover-dismissed");
                        showPlaybackHint(state, "play");
                    }
                });
        }
    }

    function showPlaybackHint(state, type) {
        const hint = state.playbackHint;
        if (!hint) return;
        hint.innerHTML = type === "pause" ? ICON_PAUSE : ICON_PLAY;
        hint.classList.add("is-visible");
        clearTimeout(state.hintTimer);
        state.hintTimer = setTimeout(() => {
            hint.classList.remove("is-visible");
        }, HINT_MS);
    }

    function dismissCover(state) {
        if (state.titleDismissed) return;
        state.titleDismissed = true;
        setTimeout(() => {
            if (state.index !== activeIndex) return;
            if (!state.failed) {
                playActive(state);
            } else {
                state.panel.classList.add("cover-dismissed");
            }
        }, TITLE_SLIDE_MS);
    }

    function maybeStartExperience(state) {
        if (state.index !== activeIndex || !state.ready || state.titleTimer) return;
        state.titleTimer = setTimeout(() => {
            state.titleTimer = null;
            if (state.index !== activeIndex) return;
            dismissCover(state);
        }, TITLE_HOLD_MS);
    }

    function resetCoverState(state) {
        clearTimeout(state.titleTimer);
        state.titleTimer = null;
        state.titleDismissed = false;
        state.panel.classList.remove("cover-dismissed");
    }

    function stopInactive(indexToKeep) {
        countdownAdvanceLock = false;
        hideCountdownOverlay();

        panels.forEach((panel, index) => {
            const state = panelState.get(panel.id);
            panel.classList.toggle("is-active", index === indexToKeep);

            if (index === indexToKeep) {
                resetCoverState(state);
                requestVideo(state);
                maybeStartExperience(state);

                // actualizar créditos para el panel activo
                try { updateCreditsForPanel(panel); } catch (e) { /* silent */ }

                if (index + 1 < panels.length) requestVideo(panelState.get(panels[index + 1].id));
                if (index - 1 >= 0) requestVideo(panelState.get(panels[index - 1].id));
            } else {
                clearTimeout(state.titleTimer);
                clearTimeout(state.hintTimer);
                state.titleTimer = null;
                state.hintTimer = null;
                if (state.playbackHint) state.playbackHint.classList.remove("is-visible");
                state.video.pause();
                state.video.currentTime = 0;
                panel.classList.remove("is-buffering");
                state.panel.classList.remove("cover-dismissed");
                state.titleDismissed = false;
            }
        });
    }

    function goToPanel(index) {
        const boundedIndex = Math.max(0, Math.min(index, panels.length - 1));
        if (boundedIndex === activeIndex && !isAutoScrolling) return;

        activeIndex = boundedIndex;
        isAutoScrolling = true;

        const targetPanel = panels[activeIndex];
        const targetTop = targetPanel.offsetTop;

        experience.scrollTo({
            top: targetTop,
            behavior: "smooth"
        });

        updateActiveNav();
        stopInactive(activeIndex);

        clearTimeout(goToPanel.doneTimer);
        goToPanel.doneTimer = setTimeout(() => {
            isAutoScrolling = false;
        }, 780);
    }

    function closestPanelIndex() {
        const viewportCenter = experience.scrollTop + (window.innerHeight / 2);
        let closestIndex = 0;
        let closestDistance = Infinity;

        panels.forEach((panel, index) => {
            const panelCenter = panel.offsetTop + (panel.offsetHeight / 2);
            const distance = Math.abs(viewportCenter - panelCenter);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        return closestIndex;
    }

    function onScroll() {
        const lastPanel = panels[panels.length - 1];
        const inFooterZone = experience.scrollTop > lastPanel.offsetTop;

        updateFooterRevealFromScroll();

        if (inFooterZone) {
            activeIndex = panels.length - 1;
            updateActiveNav();
            return;
        }

        const nextIndex = closestPanelIndex();
        if (nextIndex !== activeIndex && !isAutoScrolling) {
            activeIndex = nextIndex;
            updateActiveNav();
            stopInactive(activeIndex);
        }
    }

    function lockWheel() {
        wheelLock = true;
        setTimeout(() => {
            wheelLock = false;
        }, 760);
    }

    function refreshMediaVariantIfNeeded() {
        // rebuild maps in case panel dataset changed
        moduleMaps = buildModuleMaps();
        const nextIsMobile = mobileQuery.matches;
        if (nextIsMobile === isMobileView) return;

        isMobileView = nextIsMobile;

        panels.forEach((panel, index) => {
            const state = panelState.get(panel.id);
            applyMediaVariant(state, { forceReload: true });

            if (index === activeIndex || index === activeIndex + 1 || index === activeIndex - 1) {
                requestVideo(state);
            }
        });

        stopInactive(activeIndex);
    }

    experience.addEventListener("wheel", (event) => {
        const lastPanel = panels[panels.length - 1];
        const lastPanelTop = lastPanel.offsetTop;
        const inFooterZone = experience.scrollTop > lastPanelTop;
        const isLastSlide = activeIndex === panels.length - 1;
        const goingDown = event.deltaY > 0;
        const goingUp = event.deltaY < 0;

        if (inFooterZone) {
            return;
        }

        if (isLastSlide) {
            if (goingDown && experience.scrollTop >= lastPanelTop - 2) {
                return;
            }

            if (goingUp && experience.scrollTop > lastPanelTop + 2) {
                return;
            }
        }

        if (wheelLock || isAutoScrolling) {
            event.preventDefault();
            return;
        }

        if (Math.abs(event.deltaY) < 16) return;

        event.preventDefault();
        lockWheel();
        goToPanel(activeIndex + (goingDown ? 1 : -1));
    }, { passive: false });

    experience.addEventListener("touchstart", (event) => {
        touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });

    experience.addEventListener("touchend", (event) => {
        const lastPanel = panels[panels.length - 1];
        const lastPanelTop = lastPanel.offsetTop;
        const inFooterZone = experience.scrollTop > lastPanelTop;
        const deltaY = touchStartY - event.changedTouches[0].clientY;
        const isLastSlide = activeIndex === panels.length - 1;
        const goingDown = deltaY > 0;
        const goingUp = deltaY < 0;

        if (inFooterZone) {
            return;
        }

        if (isLastSlide) {
            if (goingDown && experience.scrollTop >= lastPanelTop - 2) {
                return;
            }

            if (goingUp && experience.scrollTop > lastPanelTop + 2) {
                return;
            }
        }

        if (isAutoScrolling) return;
        if (Math.abs(deltaY) < 45) return;

        goToPanel(activeIndex + (goingDown ? 1 : -1));
    }, { passive: true });

    experience.addEventListener("scroll", onScroll, { passive: true });

    navButtons.forEach((button, index) => {
        button.addEventListener("click", () => goToPanel(index));
    });

    soundToggle.addEventListener("click", () => {
        soundEnabled = !soundEnabled;
        updateSoundButton();

        panels.forEach((panel, index) => {
            const state = panelState.get(panel.id);
            state.video.muted = !soundEnabled;
            state.video.defaultMuted = !soundEnabled;
            if (!state.failed && index === activeIndex && !state.video.paused) {
                state.video.volume = 1;
            }
        });
    });

    panels.forEach((panel, index) => {
        const state = initPanel(panel);
        state.index = index;
    });

    requestVideo(panelState.get(panels[0].id));
    if (panels[1]) {
        requestVideo(panelState.get(panels[1].id));
    }

    bindFooterHitbox();
    bindVideoProgress();

    countdownPill?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        countdownAdvanceLock = true;
        goToNextPanelLoop();
    });

    startLiveUiLoop();
    updateSoundButton();
    updateActiveNav();
    stopInactive(activeIndex);
    onScroll();
    updateProgressUI();
    updateFooterMetrics();

    window.addEventListener("resize", () => {
        refreshMediaVariantIfNeeded();
        updateFooterMetrics();
    });

    if (typeof mobileQuery.addEventListener === "function") {
        mobileQuery.addEventListener("change", refreshMediaVariantIfNeeded);
    } else if (typeof mobileQuery.addListener === "function") {
        mobileQuery.addListener(refreshMediaVariantIfNeeded);
    }

    const footer = getFooter();
    if (footer && typeof ResizeObserver !== "undefined") {
        const resizeObserver = new ResizeObserver(() => updateFooterMetrics());
        resizeObserver.observe(footer);
    }
});
